import {
  ON_START_GET_SMS_SETTINGS,ON_GET_SMS_SETTINGS,ON_ERROR_GET_SMS_SETTINGS,
  ON_START_UPDATE_SMS_SETTINGS,ON_UPDATE_SMS_SETTINGS,ON_ERROR_UPDATE_SMS_SETTINGS,
  ON_START_GET_DASHBOARD_VALUEOF,ON_GET_DASHBOARD_VALUEOF,ON_ERROR_GET_DASHBOARD_VALUEOF,
  ON_START_UPDATE_DASHBOARD_VALUEOF,ON_UPDATE_DASHBOARD_VALUEOF,ON_ERROR_UPDATE_DASHBOARD_VALUEOF,
  ON_START_GET_KONTO_TAGS,ON_GET_KONTO_TAGS,ON_ERROR_GET_KONTO_TAGS,
  ON_START_GET_KUND_KONTAKTER,ON_GET_KUND_KONTAKTER,ON_ERROR_GET_KUND_KONTAKTER,
  ON_START_GET_ARTIKEL_TBAVDRAG,ON_GET_ARTIKEL_TBAVDRAG,ON_ERROR_GET_ARTIKEL_TBAVDRAG,
  ON_START_ADD_ARTIKEL_TBAVDRAG, ON_ADD_ARTIKEL_TBAVDRAG, ON_ERROR_ADD_ARTIKEL_TBAVDRAG,
  ON_START_DELETE_ORGNR_FAMILY_TREE, ON_DELETE_ORGNR_FAMILY_TREE,
  ON_START_ADD_ORGNR_FAMILY_TREE, ON_ADD_ORGNR_FAMILY_TREE, ON_ERROR_ADD_ORGNR_FAMILY_TREE,
  ON_START_ORGNR_FAMILY_TREE,ON_ORGNR_FAMILY_TREE,ON_ERROR__ORGNR_FAMILY_TREE,
  ON_START_FLODE_LIKES,ON_FLODE_LIKES,ON_ERROR_FLODE_LIKES,
  ON_START_SEARCH_KOMMENTAR,ON_SEARCH_KOMMENTAR,ON_ERROR_SEARCH_KOMMENTAR,
  ON_START_GET_UNDERKONTO_KUNDER,ON_GET_UNDERKONTO_KUNDER,ON_ERROR_GET_UNDERKONTO_KUNDER,
  ON_START_GET_IMPORT_SAMPLE,ON_GET_IMPORT_SAMPLE,ON_ERROR_GET_IMPORT_SAMPLE,
  ON_START_CHECH_KUNDNR,ON_CHECH_KUNDNR,ON_ERROR_CHECH_KUNDNR,
  ON_START_FETCH_RAPPORTV2,ON_FETCH_RAPPORTV2,ON_ERROR_FETCH_RAPPORTV2,ON_SET_TO_NULL_IMPORTSAMPLE,
  ON_START_DELETE_AFID_RAPPORTV2, ON_DELETE_AFID_RAPPORTV2, ON_ERROR_DELETE_AFID_RAPPORTV2,
  ON_START_UPDATE_RAPPORTV2, ON_UPDATE_RAPPORTV2, ON_ERROR_UPDATE_RAPPORTV2,
  ON_START_GET_SPARAD_RAPPORTV2,ON_GET_SPARAD_RAPPORTV2,ON_ERROR_GET_SPARAD_RAPPORTV2,
  ON_START_GET_LOGG_RAPPORTV2,ON_GET_LOGG_RAPPORTV2,ON_ERROR_GET_LOGG_RAPPORTV2,
  ON_START_GET_KONTO_STORAGE,ON_GET_KONTO_STORAGE,ON_ERROR_GET_KONTO_STORAGE,
  ON_START_GET_CATE_ARENDE_AFID,ON_GE_CATE_ARENDE_AFID,ON_ERROR_CATE_ARENDE_AFID,
  ON_DELETE_SAVE_NEW_CATE_ARENDE,ON_DELETE_ARENDE_CATE_FREEINPUT,
  ON_START_GET_FREEINPUT_ARENDE_AFID,ON_GET_FREEINPUT_ARENDE_AFID,ON_ERROR_FREEINPUT_ARENDE_AFID,
  ON_START_SAVE_NEW_ARENDE_CATE_FREEINPUT, ON_SAVE_NEW_NEW_ARENDE_CATE_FREEINPUT, ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT,
  ON_START_SAVE_NEW_CATE_ARENDE, ON_SAVE_SAVE_NEW_CATE_ARENDE, ON_ERROR_SAVE_NEW_CATE_ARENDE,
  ON_START_GET_FI_AFID_ARENDE,ON_GET_FI_AFID_ARENDE,ON_ERROR_FI_AFID_ARENDE,
  ON_GET_UPDATE_DASHBOARD_BOKATV,ON_GET_UPDATE_DASHBOARD_ORDERTV,
  START_FETCH_CONTACT1_BY_ID,  ON_FETCH_CONTACT1_BY_ID_REST,ON_GET_UPDATE_DASHBOARD,ON_GET_UPDATE_DASHBOARD_DIALER,
  ON_GET_UPDATE_DASHBOARD_AKTIVITET,ON_GET_UPDATE_DASHBOARD_PROSPEKT,ON_GET_UPDATE_DASHBOARD_OFFERT,
  ON_GET_UPDATE_DASHBOARD_PROJEKT,ON_GET_UPDATE_DASHBOARD_TIDPROJEKT,ON_GET_UPDATE_DASHBOARD_ARENDE,
  ON_GET_UPDATE_DASHBOARD_AVTAL,ON_GET_UPDATE_DASHBOARD_LYNES,ON_GET_UPDATE_DASHBOARD_DEVICE,
  ON_GET_UPDATE_DASHBOARD_ISMESSAGE,
  ON_START_GET_VALITIVE,ON_GET_VALITIVE,ON_ERROR_GET_VALITIVE,
  ON_START_GET_IMPORTERAD_RINGLISTOR,ON_GET_IMPORTERAD_RINGLISTOR,ON_ERROR_GET_IMPORTERAD_RINGLISTOR,  
  START_FETCH_CONTACT2_BY_ID,  ON_FETCH_CONTACT2_BY_ID_REST,
  START_FETCH_CONTACT3_BY_ID,  ON_FETCH_CONTACT3_BY_ID_REST,
  ON_START_CHECK_FILE,ON_CHECK_FILE,ON_ERROR_CHECK_FILE,ON_CLOSE_CHECK_FILE,
  ON_START_AKTIVE_TYP_AV_AFFAR,ON_AKTIVE_TYP_AV_AFFAR,ON_ERROR_AKTIVE_TYP_AV_AFFAR,
  ON_START_GET_DOWN_FILE_NO_SAVE,ON_GET_DOWN_FILE_NO_SAVE,ON_ERROR_GET_DOWN_FILE_NO_SAVE,
  ON_START_GET_ADS,ON_GET_ADS,ON_ERROR_GET_ADS,
  ON_START_GET_FBADS,ON_GET_FBADS,ON_ERROR_GET_FBADS,
  ON_START_GET_FAKTURA_INTERVALL_AFID,  ON_GET_FAKTURA_INTERVALL_AFID,  ON_ERROR_GET_FAKTURA_INTERVALL_AFID,
  ON_START_SAVE_NEW_TYP_AV_AFFAR,ON_SAVE_NEW_TYP_AV_AFFAR,ON_ERROR_SAVE_NEW_TYP_AV_AFFAR,
  ON_START_GET_TYP_AV_AFFAR,  ON_GET_TYP_AV_AFFAR,  ON_ERROR_GET_TYP_AV_AFFAR,
  ON_START_DELETE_TYP_AV_AFFAR,   ON_DELETE_TYP_AV_AFFAR,   ON_ERROR_DELETE_TYP_AV_AFFAR,
  ON_START_GET_PRISLISTA_BY_ORGNR,ON_GET_PRISLISTA_BY_ORGNR,ON_ERROR_GET_PRISLISTA_BY_ORGNR,
  ON_START_CHECK_FORTNOX_KUNDNAME1,ON_GET_CHECK_FORTNOX_KUNDNAME1,ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME1,
  ON_START_CHECK_FORTNOX_KUNDNAME,ON_GET_CHECK_FORTNOX_KUNDNAME,ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME,
  ON_START_UPDATE_AVTALFORMULA,  ON_UPDATE_AVTALFORMULA,  ON_ERROR_UPDATE_AVTALFORMULA,
  ON_START_GET_AVTALFORMULA, ON_GET_AVTALFORMULA, ON_ERROR_AVTALFORMULA,
  ON_START_UPDATE_EVENT_STATUS, ON_UPDATE_EVENT_STATUS, ON_ERROR_UPDATE_EVENT_STATUS,
  ON_START_DELETE_EVENT_STATUS, ON_DELETE_EVENT_STATUS, ON_ERROR_DELETE_EVENT_STATUS,
  ON_START_GET_EVENT_STATUS,  ON_GET_EVENT_STATUS,  
  ON_START_UPDATE_AKTIVITETE_TYPE, ON_UPDATE_AKTIVITETE_TYPE, ON_ERROR_UPDATE_AKTIVITETE_TYPE,
  ON_START_DELETE_AKTIVITETE_TYPE, ON_DELETE_AKTIVITETE_TYPE, ON_ERROR_DELETE_AKTIVITETE_TYPE,
  ON_START_NEW_AKTIVITETE_TYPE, ON_NEW_AKTIVITETE_TYPE, ON_ERROR_AKTIVITETE_TYPE,
  ON_START_GET_AKTIVITETE_TYPE, ON_GET_AKTIVITETE_TYPE, ON_ERROR_GET_AKTIVITETE_TYPE,
  ON_START_NEW_EVENT_STATUS, ON_NEW_EVENT_STATUS, ON_ERROR_EVENT_STATUS,
  ON_START_UPDATE_AVTALS_FORTNOX_SETTING,ON_UPDATE_AVTALS_FORTNOX_SETTING,ON_ERROR_UPDATE_AVTALS_FORTNOX_SETTING,
  ON_START_GET_AVTALS_FORTNOX_SETTINGS,ON_GET_AVTALS_FORTNOX_SETTINGSG,ON_ERROR_GET_AVTALS_FORTNOX_SETTINGS,
  ON_START_DELETE_AVTAL_AVSLUTNING,ON_DELETE_DELETE_AVTAL_AVSLUTNING,ON_ERROR_DELETE_AVTAL_AVSLUTNING,
  ON_START_SAVE_NEW_AVTAL_AVSLUTNING,ON_SAVE_NEW_AVTAL_AVSLUTNING,ON_ERROR_SAVE_NEW_AVTAL_AVSLUTNING,
  ON_START_GET_AVTALS_AVSLUTNING,ON_GET_AVTALS_AVSLUTNING,ON_ERROR_GET_AVTALS_AVSLUTNING,
  ON_START_GET_ORDER_FREE_INPUTS,ON_GET_ORDER_FREE_INPUTS,ON_ERROR_GET_ORDER_FREE_INPUTS,
  ON_START_GET_KUND_MESSAGE,ON_GET_KUND_MESSAGE,ON_ERROR_GET_KUND_MESSAGE,
  ON_START_DELETE_ARANDE_EMAIL,ON_DELETE_ARANDE_EMAIL,ON_ERROR_DELETE_ARANDE_EMAIL,
  ON_START_GET_NOTYFILE_USERS, ON_GET_NOTYFILE_USERS, ON_ERROR_GET_NOTYFILE_USERS,ON_CLOSE_KONTO_TOASTR,
  FETCH_ALL_CONTACT_FLAGS,ON_FETCH_CONTACT_FLAGS_BY_ID,FETCH_ACCOUNT_FLAGS_ERROR,
  ON_CLOSE_KUND_TOASTR,ON_CLOSE_RAPPORT_TOASTR,ON_SAVE_PAGE_ANV,
  ON_START_GET_DOWN_FILE,ON_GET_DOWN_FILE,ON_ERROR_GET_DOWN_FILE,
  ON_START_GET_HOGIA_OFFICES,ON_GET_HOGIA_OFFICES,ON_ERROR_GET_HOGIA_OFFICES,
  ON_START_FORTNOX_TEMPLATE_GET,   ON_FORTNOX_TEMPLATE_GET,   ON_ERROR_FORTNOX_TEMPLATE_GET,
  ON_START_FORTNOX_TERMOFPAYMENTS_GET,   ON_FORTNOX_TERMOFPAYMENTS_GET,   ON_ERROR_FORTNOX_TERMOFPAYMENTS_GET,
  ON_START_FORTNOX_ATTACHMENTS_GET,   ON_FORTNOX_ATTACHMENTS_GET,   ON_ERROR_FORTNOX_ATTACHMENTS_GET,
  ON_START_DELETE_HANDELSE_LOGG, ON_DELETE_HANDELSE_LOGG, ON_ERROR_DELETE_HANDELSE_LOGG,
  ON_START_EDIT_HANDELSE_LOGG,ON_EDIT_HANDELSE_LOGG,ON_ERROR_START_EDIT_HANDELSE_LOGG,
  ON_START_GET_DONT_HA_PL_CHILD,ON_GET_DONT_HA_PL_CHILD,ON_ERROR_GET_DONT_HA_PL_CHILD,
  ON_START_NEW_ARANDE_EMAIL, ON_NEW_ARANDE_EMAIL, ON_ERROR_NEW_ARANDE_EMAIL,
  ON_START_UPDATEN_ARANDE_EMAIL, ON_UPDATEN_ARANDE_EMAIL, ON_ERROR_UPDATEN_ARANDE_EMAIL,
  ON_START_DELETE_CASE_TYPE, ON_DELETE_CASE_TYPE, ON_ERROR_DELETE_CASE_TYPE,
  ON_START_DELETE_CASE_CATE_TYPE, ON_DELETE_CASE_CATE_TYPE, ON_ERROR_DELETE_CASE_CATE_TYPE,
  ON_START_NEW_CASE_CATE_TYPE, ON_NEW_CASE_CATE_TYPE, ON_ERROR_NEW_CASE_CATE_TYPE,
  ON_START_GET_ARANDETYP_KUND,ON_FETCH_ARANDETYP_KUND,ON_ERROR_ARANDETYP_KUND,
  ON_START_NEW_CASE_TYPE,   ON_NEW_CASE_TYPE,   ON_ERROR_NEW_CASE_TYPE,
  ON_START_FETCH_UTOKNING,ON_FETCH_UTOKNING,ON_ERROR_FETCH_UTOKNING,
  ON_START_FETCH_UTOKNING_DYNAMIC_FIELDS,ON_FETCH_UTOKNING_DYNAMIC_FIELDS,ON_ERROR_FETCH_UTOKNING_DYNAMIC_FIELDS,
  ON_START_GET_UTOKNING_KUND_LIST_BY_TYPE,
  ON_GET_UTOKNING_KUND_LIST_BY_TYPE,
  ON_ERROR_GET_UTOKNING_KUND_LIST_BY_TYPE,
  ON_START_KUND_KUNDDATA_GET, ON_KUND_KUNDDATA_GET, ON_ERROR_KUND_KUNDDATA_GET,
  ON_START_OFFICE_ALL_USERS, ON_OFFICE_ALL_USERS, ON_ERROR_OFFICE_ALL_USERS,
  ON_START_OFFICE_UPDATE_USER, ON_OFFICE_UPDATE_USER, ON_ERROR_OFFICE_UPDATE_USER,
  ON_START_OFFICE_GET, ON_OFFICE_GET, ON_ERROR_OFFICE_GET,
  ON_START_BLACK_LIST, ON_BLACK_LIST, ON_ERROR_BLACK_LIST,
  ON_START_GET_ORDER_SETTING_AF, ON_GET_ORDER_SETTING_AF, ON_ERROR_GET_ORDER_SETTING_AF,
  ON_START_GET_ORDER_AFFAR_FROM_AF,ON_GET_ORDER_AFFAR_FROM_AF,ON_ERROR_GET_ORDER_AFFAR_FROM_AF,
  ON_START_NEW_ORDER_AFFAR_FROM_AF, ON_NEW_ORDER_AFFAR_FROM_AF, ON_ERROR_ORDER_AFFAR_FROM_AF,
  ON_START_UPDATE_ORDER_AFFAR_FROM_AF, ON_UPDATE_ORDER_AFFAR_FROM_AF,
  ON_START_GET_EVENT_SETTING_AF,ON_GET_EVENT_SETTING_AF,ON_ERROR_GET_EVENT_SETTING_AF,
  ON_START_GET_LOBBY_SETTING_AF,   ON_GET_LOBBY_SETTING_AF,   ON_ERROR_GET_LOBBY_SETTING_AF,
  ON_START_UPDATE_ORDER_SETTING_AF, ON_UPDATE_ORDER_SETTING_AF, ON_ERROR_UPDATE_ORDER_SETTING_AF,
  ON_START_UPDATE_EVENT_SETTING_AF, ON_UPDATE_EVENT_SETTING_AF, ON_ERROR_UPDATE_EVENT_SETTING_AF,
  ON_START_UPDATE_LOBBY_SETTING_AF, ON_UPDATE_LOBBY_SETTING_AF, ON_ERROR_UPDATE_LOBBY_SETTING_AF,
  ON_START_FORTNOX_TERMOFPAY_GET, ON_FORTNOX_TERMOFPAY_GET, ON_ERROR_FORTNOX_TERMOFPAY_GET,
  ON_START_FORTNOX_WAYOFDELIVERY_GET, ON_FORTNOX_WAYOFDELIVERY_GET, ON_ERROR_FORTNOX_WAYOFDELIVERY_GET,
  ON_START_FORTNOX_PRISLISTOR_GET,ON_FORTNOX_PRISLISTOR_GET,ON_ERROR_FORTNOX_PRISLISTOR_GET,
  ON_START_FORTNOX_TERMSOFDELIVERY_GET, ON_FORTNOX_TERMSOFDELIVERY_GET, ON_ERROR_FORTNOX_TERMSOFDELIVERY_GET,
  ON_START_FORTNOX_PROJEKT_GET,   ON_FORTNOX_PROJEKT_GET,   ON_ERROR_FORTNOX_PROJEKT_GET,
  ON_UPDATE_PROSPEKT_KUND_PARAMETERS,ON_GET_KUND_MOTE_ANTAL,
  ON_START_CHECK_FORTNOX,ON_GET_CHECK_FORTNOX,ON_ERROR_GET_CHECK_FORTNOX,
  ON_START_FORTNOX_KUND_FAKTUROR, ON_FORTNOX_KUND_FAKTUROR, ON_ERROR_FORTNOX_KUND_FAKTUROR,ON_RESET_FORTNOX_KUND_FAKTUROR,
  ON_START_FORTNOX_FAKTUROR_DOWNLOAD,ON_FORTNOX_FAKTURO_DOWNLOAD,ON_ERROR_FORTNOX_FAKTUROR_DOWNLOAD,
  ON_START_FORTNOX_FAKTUROR_CONNECT,ON_FORTNOX_FAKTUROR_CONNECT,ON_ERROR_FORTNOX_FAKTUROR_CONNECT,
  ON_START_FORTNOX_FAKTUROR_CANCEL, ON_FORTNOX_FAKTUROR_CANCEL, ON_ERROR_FORTNOX_FAKTUROR_CANCEL,
  ON_START_FORTNOX_FAKTUROR_SEND, ON_FORTNOX_FAKTUROR_SEND, ON_ERROR_FORTNOX_FAKTUROR_SEND,
  ON_START_FORTNOX_FAKTUROR_EDIT,ON_FORTNOX_FAKTUROR_EDIT,ON_ERROR_FORTNOX_FAKTUROR_EDIT,
  ON_START_FORTNOX_FAKTUROR_NEW,ON_FORTNOX_FAKTUROR_NEW,ON_ERROR_FORTNOX_FAKTUROR_NEW,
  ON_START_FORTNOX_FAKTURA_GET, ON_FORTNOX_FAKTURA_GET, ON_ERROR_FORTNOX_FAKTURA_GET,
  ON_START_KUND_KALKYL_OPTIONS,ON_KUND_KALKYL_OPTIONS,ON_ERROR_KUND_KALKYL_OPTIONS,
  ON_START_DIALER_ADD_BORTFALL, ON_DIALER_ADD_BORTFALL, ON_ERROR_DIALER_ADD_BORTFALL,
  ON_START_DIALER_ADD_BLACKLIST_TAGG, ON_DIALER_ADD_BLACKLIST_TAGG, ON_ERROR_DIALER_ADD_BLACKLIST_TAGG,
  ON_START_DASHBORD_USERLIST, ON_DASHBORD_USERLIST, ON_ERROR_DASHBORD_USERLIST,
  ON_START_GET_AF_LHOGIA,ON_GET_AF_LHOGIA,ON_ERROR_GET_AF_LHOGIA,ON_GET_AF_LHOGIA_STORE,ON_GET_AF_LHOGIA_DELETE_STORE,
  ON_START_BESTALLA_HOGIA, ON_BESTALLA_HOGIA, ON_ERROR_BESTALLA_HOGIA,
  ON_START_FETCH_UTOKNING_RAPPORT,ON_FETCH_UTOKNING_RAPPORT,ON_ERROR_FETCH_UTOKNING_RAPPORT,
  ON_START_FLYTTA_INAKTIV_USER, ON_FETCH_FLYTTA_INAKTIV_USER, ON_ERROR_FLYTTA_INAKTIV_USER,
  ON_START_GET_MINA_DOCUMENT_LIST,ON_GET_MINA_DOCUMENT_LIST,ON_ERROR_GET_MINA_DOCUMENT_LIST,
  ON_START_GET_MINA_DOCUMENT_KUND_LIST,ON_GET_MINA_DOCUMENT_KUND_LIST,ON_ERROR_GET_MINA_DOCUMENT_KUND_LIST,
  FETCH_START_SAVE_NEW_CHILD,ON_SAVE_NEW_CHILD,ON_ERROR_SAVE_NEW_CHILD,
  ON_START_GET_CHILD,  ON_GET_CHILD,  ON_ERROR_GET_CHILD,ON_GET_KUNDER_PAGE_BASIC,ON_GET_KUNDER_SEARCH_BASIC,
  ON_GET_KONTAKT_PAGE_BASIC,ON_GET_KUND_TABINDEX,ON_GET_KUNDER_PAGE_ROWS_BASIC,ON_GET_KUND_SORTOBJ,
  ON_START_DELETE_AFID_CHILD, ON_DELETE_AFID_CHILD,  ON_ERROR_DELETE_AFID_CHILD, 
  FETCH_START_SAVE_BLTYPE_CHILD,ON_SAVE_BLTYPE_CHILD,ON_ERROR_SAVE_BLTYPE_CHILD,ON_SAVE_CCTYPE_CHILD,
  ON_START_CHILD_KONTO_GET, ON_CHILD_KONTO_GET, ON_ERROR_CHILD_KONTO_GET,
  ON_START_CHILD_KONTO_KONTOR_GET, ON_CHILD_KONTO_KONTOR_GET, ON_ERROR_CHILD_KONTO_KONTOR_GET,
  ON_START_CHILD_KONTO_USERS_GET, ON_CHILD_KONTO_USERS_GET, ON_ERROR_CHILD_KONTO_USERS_GET,
  ON_START_CHILD_KONTO_OFFICES_GET, ON_CHILD_KONTO_OFFICES_GET, ON_ERROR_CHILD_KONTO_OFFICES_GET,
ON_START_CHILD_KONTO_TEAMS_GET, ON_CHILD_KONTO_TEAMS_GET, ON_ERROR_CHILD_KONTO_TEAMS_GET,
ON_START_CHILD_KONTO_TEAM_SGET_ALL,ON_CHILD_KONTO_TEAMS_GET_ALL,ON_ERROR_CHILD_KONTO_TEAMS_GET_ALL,
  ON_START_CHILD_KONTO_USERS_ALL_GET, ON_CHILD_KONTO_USERS_ALL_GET, ON_ERROR_CHILD_KONTO_ALL_USERS_GET,
  ON_START_CHILD_KONTO_AVTALTYPER_GET, ON_CHILD_KONTO_AVTALTYPER_GET, ON_ERROR_CHILD_KONTO_AVTALTYPER_GET,
  FETCH_START_SAVE_FNTYPE_CHILD,ON_SAVE_FNTYPE_CHILD,ON_ERROR_SAVE_FNTYPE_CHILD,
  FETCH_START_SAVE_CLTYPE_CHILD,ON_SAVE_CLTYPE_CHILD,ON_ERROR_SAVE_CLTYPE_CHILD,
  FETCH_START_SAVE_CATYPE_CHILD,ON_SAVE_CATYPE_CHILD,ON_ERROR_SAVE_CATYPE_CHILD,
  ON_START_BESTALLA_CREDITSAFE, ON_BESTALLA_CREDITSAFE, ON_ERROR_BESTALLA_CREDITSAFE,
  ON_START_BESTALLA_SVEACREDIT, ON_BESTALLA_SVEACREDIT, ON_ERROR_BESTALLA_SVEACREDIT,
  ON_START_GET_CREDITSAFE,ON_GET_CREDITSAFE,ON_ERROR_GET_CREDITSAFE,
  ON_START_GET_SVEACREDIT,ON_GET_SVEACREDIT,ON_ERROR_GET_SVEACREDIT,
  ON_START_SEND_CREDITSAFE, ON_SEND_CREDITSAFE, ON_ERROR_SEND_CREDITSAFE,
  ON_START_SEND_SVEACREDIT, ON_SEND_SVEACREDIT, ON_ERROR_SEND_SVEACREDIT,
  ON_START_CREDITSAFE_ALLOW_USER, ON_CREDITSAFE_ALLOW_USER, ON_ERROR_CREDITSAFE_ALLOW_USER,
  ON_START_SVEACREDIT_ALLOW_USER, ON_SVEACREDIT_ALLOW_USER, ON_ERROR_SVEACREDIT_ALLOW_USER,
  ON_START_GET_ALL_SVEACREDIT_ALLOW_USER,ON_GET_ALL_SVEACREDIT_ALLOW_USER,ON_ERROR_GET_ALL_SVEACREDIT_ALLOW_USER,
  ON_START_GET_ALL_CREDITSAFE_ALLOW_USER,ON_GET_ALL_CREDITSAFE_ALLOW_USER,ON_ERROR_GET_ALL_CREDITSAFE_ALLOW_USER,
  ON_START_CREDITSAFE_AKTIVE_ALLOW_USER, ON_CREDITSAFE_AKTIVE_ALLOW_USER, ON_ERROR_CREDITSAFE_AKTIVE_ALLOW_USER,
  ON_START_SVEACREDIT_AKTIVE_ALLOW_USER, ON_SVEACREDIT_AKTIVE_ALLOW_USER, ON_ERROR_SVEACREDIT_AKTIVE_ALLOW_USER,
  ON_START_GET_ALL_CREDITSAFE_CREDIT_RES,ON_GET_ALL_CREDITSAFE_CREDIT_RES,ON_ERROR_GET_ALL_CREDITSAFE_CREDIT_RES,
  ON_START_SEND_CREDITSAFE_CR, ON_ERROR_SEND_CREDITSAFE_CR,ON_RESET_CREDITSAFE,
  ON_START_GET_LAST_CREDIT, ON_GET_LAST_CREDIT, ON_ERROR_GET_LAST_CREDIT,
  ON_START_GET_LAST_SVEACREDIT, ON_GET_LAST_SVEACREDIT, ON_ERROR_GET_LAST_SVEACREDIT,
  ON_START_GET_ORGNR_FORDON, ON_GET_ORGNR_FORDON, ON_ERROR_GET_ORGNR_FORDON,
  ON_START_GET_RPS_CREDIT, ON_GET_RPS_CREDIT, ON_ERROR_GET_RPS_CREDIT,
  START_FETCH_CONTACT_BY_ID,ON_FETCH_CONTACT_BY_ID_REST,FETCH_ACCOUNT_REST_ERROR,
    FETCH_ALL_CONTACT,ON_SET_KUND_SEARCH,ON_DIALER_DELETE_BORTFALL,ON_DIALER_DELETE_BLACKLIST_TAGG,ON_RESET_CURRENT_OBJEKT_FALT,
    ON_START_NEW_ESIGNERING_FREE_SETTING_AF, ON_NEW_ESIGNERING_FREE_SETTING_AF, ON_ERROR_NEW_ESIGNERING_FREE_SETTING_AF,
    ON_START_GET_ESIGNERING_FREE_SETTING_AF, ON_GET_ESIGNERING_FREE_SETTING_AF, ON_ERROR_GET_ESIGNERING_FREE_SETTING_AF,
    ON_START_DELETE_ESIGNERING_FREE_SETTING_AF,ON_DELETE_ESIGNERING_FREE_SETTING_AF,ON_ERROR_DELETE_ESIGNERING_FREE_SETTING_AF,
    ON_START_UPDATE_ESIGNERING_FREE_SETTING_AF, ON_UPDATE_ESIGNERING_FREE_SETTING_AF, ON_ERROR_UPDATE_ESIGNERING_FREE_SETTING_AF,
    FETCH_ALL_CONTACT_SUCCESS,ON_Update_STATUS_CONTACT,ON_Update_ANSVARIG_CONTACT,
    ON_DELETE_CONTACT,ON_FETCH_CONTACT_BY_ID,
    ON_SAVE_NEW_OFFICE,ON_SAVE_NEW_TEAM,ON_SAVE_NEW_USER,ON_SET_ZERO_FORTNOX_UPPGIFTER,
    ON_DELETE_OFFICE,ON_DELETE_TEAM,ON_EDIT_OFFICE,ON_EDIT_TEAM,
    FETCH_ACCOUNT_ERROR,ON_EDIT_USER_BASIC,ON_START_EDIT_USER_BASIC,
    ON_START_NEW_USER_VAXLE, ON_NEW_USER_VAXLE, ON_ERROR_NEW_USER_VAXLE,ON_START_GET_USER_VAXLE,
    ON_START_SET_KUNDLIST_TAG,ON_SET_KUNDLIST_TAG,ON_ERROR_SET_KUNDLIST_TAG,
    ON_START_GET_KUNDDATA_HEADER, ON_GET_KUNDDATA_HEADER, ON_ERROR_GET_KUNDDATA_HEADER,
    ON_START_GET_KUNDDATA_BYTYPE, ON_GET_KUNDDATA_BYTYPE, ON_ERROR_GET_KUNDDATA_BYTYPE,
    ON_START_DELETE_ROW_KUNDDATA_BYTYPE,ON_DELETE_ROW_KUNDDATA_BYTYPE,ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE,
    ON_SAVE_ROW_KUNDDATA_BYTYPE,ON_START_SAVE_ROW_KUNDDATA_BYTYPE,ON_SAVE_All_ROW_KUNDDATA_BYTYPE,
    ON_START_SAVE_ROW_KUNDDATA_DIALER_BYTYPE, ON_SAVE_All_ROW_KUNDDATA_DIALER_BYTYPE, ON_ERROR_GET_KUNDDATA_ALL_DIALER_BYTYPE,
    ON_START_DELETE_ROW_ALL_KUNDDATA_BYTYPE,ON_DELETE_ROW_ALL_KUNDDATA_BYTYPE,
    ON_START_GET_KUNDDATA_ALL_HEADER, ON_GET_KUNDDATA_ALL_HEADER, ON_ERROR_GET_KUNDDATA_ALL_HEADER,
    ON_START_GET_KUNDDATA_ALL_BYTYPE,ON_GET_KUNDDATA_ALL_BYTYPE,ON_ERROR_GET_KUNDDATA_ALL_BYTYPE,
    ON_START_GET_KUNDDATA_DIALER_ALL_BYTYPE,ON_GET_KUNDDATA_DIALER_ALL_BYTYPE,ON_ERROR_GET_KUNDDATA_DIALER_ALL_BYTYPE,
    ON_START_DELETE_ALL_ROW_KUNDDATA_BYTYPE,ON_DELETE_ALL_ROW_KUNDDATA_BYTYPE,ON_ERROR_DELETE_ALL_ROW_KUNDDATA_BYTYPE,
    ON_START_CREATE_RINGLIST_FROM_KUNDDATA, ON_CREATE_RINGLIST_FROM_KUNDDATA, ON_ERROR_CREATE_RINGLIST_FROM_KUNDDATA,
    ON_START_CREATE_RINGLIST_FROM_KUNDLIST, ON_CREATE_RINGLIST_FROM_KUNDLIST, ON_ERROR_CREATE_RINGLIST_FROM_KUNDLIST,
    ON_START_CREATE_RINGLIST_FROM_AVTALSTID, ON_CREATE_RINGLIST_FROM_AVTALSTID, ON_ERROR_CREATE_RINGLIST_FROM_AVTALSTID,
    ON_START_SAVE_NEW_TYPE_ARTIKEL, ON_SAVE_SAVE_NEW_TYPE_ARTIKEL, ON_ERROR_SAVE_NEW_TYPE_ARTIKEL,
    ON_START_GET_TYPE_ARTIKEL_AFID,ON_GET_TYPE_ARTIKEL_AFID,ON_ERROR_TYPE_ARTIKEL_AFID,ON_DELETE_SAVE_NEW_TYPE_ARTIKEL,
		ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST, ON_GET_FREEINPUT_ARTIKEL_AFID_LIST, ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST,
		ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS, ON_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS, ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS,
    ON_START_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, ON_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT, ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT,
    ON_START_GET_FREEINPUT_ARTIKEL_AFID,ON_GET_FREEINPUT_ARTIKEL_AFID,ON_ERROR_FREEINPUT_ARTIKEL_AFID,ON_DELETE_TYPE_ARTIKEL_FREEINPUT,
    ON_START_GET_FREEINPUT_ARTIKEL_ALL_AFID,ON_GET_FREEINPUT_ARTIKEL_ALL_AFID,
    ON_START_FETCH_ORDER_IMPORT_FILE,ON_FETCH_ORDER_IMPORT_FILE,
    ON_START_GET_AFID_USERLIST,ON_GET_AFID_USERLIST,ON_ERROR_GET_AFID_USERLIST,
    ON_START_FETCH_KUND_HANDELSER_DIALERD,   ON_FETCH_KUND_HANDELSER_DIALERD,   ON_ERROR_FETCH_KUND_HANDELSER_DIALERD,
    ON_START_FETCH_SAVED_ANPASSAD,ON_FETCH_SAVED_ANPASSAD,ON_ERROR_FETCH_SAVED_ANPASSAD,ON_START_FETCH_UPDATE_ANPASSAD,
    ON_START_SAVE_NEW_PRISLISTA,ON_SAVE_NEW_PRISLISTA,ON_ERROR_SAVE_NEW_PRISLISTA,
    ON_START_GET_AFID_PRISLISTA,ON_GET_AFID_PRISLISTA,ON_ERROR_GET_AFID_PRISLISTA,
    ON_SEARCH_KUND,ON_DELETE_DELETE_AFID_PRISLISTA,ON_UPDATE_AFID_PRISLISTA,
    ON_START_SEARCH_KUND,
    ON_ERROR_SEARCH_KUND,
    ON_START_SEARCH_KUND_BASIC,
    ON_SEARCH_KUND_BASIC,    ON_ERROR_SEARCH_KUND_BASIC,    ON_START_FETCH_KUND_BASIC,
    ON_START_FETCH_KUND_BASIC_NOMESSAGE,ON_FETCH_KUND_BASIC_NOMESSAGE,ON_START_FETCH_KUND_BASIC_REST,
    ON_FETCH_KUND_BASIC,
    ON_ERROR_FETCH_KUND_BASIC,
    ON_AKTIVE_KUND,ON_START_AKTIVE_KUND,ON_ERROR_AKTIVE_KUND,ON_INAKTIVE_KUND,ON_START_INAKTIVE_KUND,
    ON_DELETE_KUND_ANSVARIG,
    ON_START_DELETE_KUND_ANSVARIG,
    ON_ERROR_DELETE_KUND_ANSVARIG,
    ON_NEW_KUND_ANSVARIG,
    ON_START_NEW_KUND_ANSVARIG,
    ON_ERROR_NEW_KUND_ANSVARIG,
    ON_DELETE_KUND_TAG,
    ON_START_DELETE_KUND_TAG,
    ON_ERROR_DELETE_KUND_TAG,
    ON_NEW_KUND_TAG,
    ON_START_NEW_KUND_TAG,
    ON_ERROR_NEW_KUND_TAG,
    ON_START_CREATE_HANDELSE,
    ON_CREATE_HANDELSE,
    ON_ERROR_CREATE_HANDELSE,
    ON_FETCH_KUND_HANDELSER,
    ON_ERROR_FETCH_KUND_HANDELSER,
    ON_START_FETCH_KUND_HANDELSER,
    ON_START_FETCH_CURRENT_HANDELSE,
    ON_FETCH_CURRENT_HANDELSE,
    ON_ERROR_FETCH_CURRENT_HANDELSE,
    ON_FETCH_CURRENT_HANDELSE_NEW_TEXT,
    ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT,
    ON_START_FETCH_CURRENT_HANDELSE_NEW_TEXT,
    ON_DELETE_CURRENT_HANDELSE,
    ON_START_DELETE_CURRENT_HANDELSE,
    ON_ERROR_DELETE_CURRENT_HANDELSE,
    ON_START_NEW_KUND_KONTAKT,
    ON_NEW_KUND_KONTAKT,
    ON_ERROR_NEW_KUND_KONTAKT,    
    ON_START_EDIT_KUND_KONTAKT,
    ON_EDIT_KUND_KONTAKT,
    ON_ERROR_EDIT_KUND_KONTAKT,
    ON_START_DELETE_KUND_KONTAKT,
    ON_DELETE_KUND_KONTAKT,
    ON_ERROR_DELETE_KUND_KONTAKT,
    ON_START_EDIT_KUND_ITESCO_INFO, ON_EDIT_KUND_ITESCO_INFO, ON_ERROR_EDIT_KUND_ITESCO_INFO,
    ON_START_EDIT_KUND_INFO,
    ON_EDIT_KUND_INFO,
    ON_ERROR_EDIT_KUND_INFO,
    ON_START_NEW_LEVERANTOR,
    ON_ERROR_NEW_LEVERANTOR,
    ON_NEW_LEVERANTOR,
    ON_START_DELETE_LEVERANTOR,
    ON_ERROR_DELETE_LEVERANTOR,
    ON_DELETE_LEVERANTOR,
    ON_START_NEW_TYPE,
    ON_ERROR_NEW_TYPE,
    ON_NEW_TYPE,
    ON_START_DELETE_TYPE,
    ON_DELETE_TYPE,
    ON_ERROR_DELETE_TYPE,
    ON_START_UPDATE_TYPE,
    ON_UPDATE_TYPE,
    ON_ERROR_UPDATE_TYPE,
    ON_START_NEW_KALKYL,
    ON_NEW_KALKYL,
    ON_ERROR_NEW_KALKYL,
    ON_START_DELETE_KALKYL,
    ON_DELETE_KALKYL,
    ON_ERROR_DELETE_KALKYL,
    ON_START_UPDATE_KALKYL,
    ON_UPDATE_KALKYL,
    ON_ERROR_UPDATE_KALKYL,

    ON_START_GET_SCHABLON,
    ON_GET_SCHABLON,
    ON_ERROR_GET_SCHABLON,
    ON_START_NEW_SCHABLON,
    ON_NEW_SCHABLON,
    ON_ERROR_NEW_SCHABLON,
    ON_START_DELETE_SCHABLON,
    ON_DELETE_SCHABLON,
    ON_ERROR_DELETE_SCHABLON,
    ON_START_UPDATE_SCHABLON,
    ON_UPDATE_SCHABLON,
    ON_ERROR_UPDATE_SCHABLON,

    ON_START_NEW_SCHABLON_PRESET,
    ON_NEW_SCHABLON_PRESET,
    ON_ERROR_NEW_SCHABLON_PRESET,
    ON_START_DELETE_SCHABLON_PRESET,
    ON_DELETE_SCHABLON_PRESET,
    ON_ERROR_DELETE_SCHABLON_PRESET,
    ON_START_UPDATE_SCHABLON_PRESET,
    ON_UPDATE_SCHABLON_PRESET,
    ON_ERROR_UPDATE_SCHABLON_PRESET,

    ON_START_RESET_SCHABLON,
    ON_RESET_SCHABLON,
    ON_ERROR_RESET_SCHABLON,
    ON_START_FETCH_KUND_KONTAKT,
    ON_FETCH_KUND_KONTAKT,
    ON_ERROR_FETCH_KUND_KONTAKT,
    ON_START_NEW_FAS,
    ON_NEW_FAS,
    ON_ERROR_NEW_FAS,
    ON_START_DELETE_FAS,
    ON_DELETE_FAS,
    ON_ERROR_DELETE_FAS,
    ON_UPDATE_FAS,
    ON_START_UPDATE_FAS,
    ON_ERROR_UPDATE_FAS,
    ON_START_NEW_KUNDDATA,
    ON_NEW_KUNDDATA,
    ON_ERROR_NEW_KUNDDATA,
    ON_START_GET_KUNDDATA_BY_AVTAL,
    ON_GET_KUNDDATA_BY_AVTAL,
    ON_ERROR_GET_KUNDDATA_BY_AVTAL,
    ON_START_DELETE_KUNDDATA,
    ON_DELETE_KUNDDATA,
    ON_ERROR_DELETE_KUNDDATA,
    ON_START_UPDATE_KUNDDATA,
    ON_UPDATE_KUNDDATA,
    ON_ERROR_UPDATE_KUNDDATA,
    ON_START_KONTO_INFO_UPDATE,
    ON_KONTO_INFO_UPDATE,
    ON_ERROR_KONTO_INFO_UPDATE,
    ON_SET_CURRENT_KONTO_TAB_INDEX,
    ON_START_UPDATE_MODULE,    ON_UPDATE_MODULE,    ON_ERROR_UPDATE_MODULE,
    ON_UPDATE_MODULE_DONT_UPDATE,
    ON_START_NEW_ORDER_EMAIL,
    ON_NEW_ORDER_EMAIL,
    ON_ERROR_NEW_ORDER_EMAIL,
    ON_START_DELETE_ORDER_EMAIL,
    ON_DELETE_ORDER_EMAIL,
    ON_ERROR_DELETE_ORDER_EMAIL,
    ON_START_MINA_KUNDER,    ON_MINA_KUNDER,    ON_ERROR_MINA_KUNDER,
    ON_START_MINA_KUNDER_NOMESSAGE,ON_MINA_KUNDER_NOMESSAGE,
    ON_START_MINA_KUNDER_CLOSE_TO,
    ON_MINA_KUNDER_CLOSE_TO,
    ON_ERROR_MINA_KUNDER_CLOSE_TO,
    ON_START_MINA_KONTAKTPERSONER,ON_MINA_KONTAKTPERSONER,ON_ERROR_MINA_KONTAKTPERSONER,
    ON_START_MINA_KONTAKTPERSONER_NOMESSAGE,ON_MINA_KONTAKTPERSONER_NOMESSAGE,
    ON_START_GET_DOC_ORGNR, ON_GET_DOC_ORGNR,ON_GET_DOC_ORGNR_0, ON_ERROR_GET_DOC_ORGNR,
    ON_START_GET_DOC_ORGNR_PDF,ON_GET_DOC_ORGNR_PDF,ON_ERROR_GET_DOC_ORGNR_PDF,
    ON_START_IMPORT_FUNC,
    ON_IMPORT_FUNC,
    ON_ERROR_IMPORT_FUNC,
    ON_START_BESTALLA_ESIGN,
    ON_BESTALLA_ESIGN,
    ON_ERROR_BESTALLA_ESIGN,
    ON_START_GET_AF_ESIGNERING,
    ON_GET_AF_ESIGNERING,
    ON_ERROR_GET_AF_ESIGNERING,
    ON_START_SAVE_ESIGN,
    ON_SAVE_ESIGN,
    ON_ERROR_SAVE_ESIGN,
    ON_SAVE_PRICELIST,
    GET_PRICELIST_BY_ID,
    GET_ALL_PRICELISTS,
    ON_START_GET_OLD_AF,
    ON_GET_OLD_AF,
    ON_ERROR_GET_OLD_AF,
    ON_START_GET_OLD_AF_USER,
    ON_GET_OLD_AF_USER,
    ON_ERROR_GET_OLD_AF_USER,
    ON_START_INSERT_TILLGODO_KUND, ON_INSERT_TILLGODO_KUND, ON_ERROR_INSERT_TILLGODO_KUND,
    ON_START_GET_TILLGODO_KUND,ON_FETCH_TILLGODO_KUND,ON_ERROR_TILLGODO_KUND,
    ON_START_UPDATE_ORDER_FALT, ON_UPDATE_ORDER_FALT, ON_ERROR_UPDATE_ORDER_FALT,
    ON_START_DELETE_ORDER_FALT, ON_DELETE_ORDER_FALT, ON_ERROR_DELETE_ORDER_FALT,
    ON_START_NEW_ORDER_FALT, ON_NEW_ORDER_FALT, ON_ERROR_ORDER_FALT,
    ON_START_NEW_PROSPEKT_FALT, ON_NEW_PROSPEKT_FALT, ON_ERROR_PROSPEKT_FALT,
    ON_START_UPDATE_PROSPEKT_FALT, ON_UPDATE_PROSPEKT_FALT, ON_ERROR_UPDATE_PROSPEKT_FALT,
    ON_START_DELETE_PROSPEKT_FALT, ON_DELETE_PROSPEKT_FALT, ON_ERROR_DELETE_PROSPEKT_FALT,
    ON_START_NEW_ORDER_STATUS, ON_NEW_ORDER_STATUS, ON_ERROR_ORDER_STATUS,
    ON_START_DELETE_ORDER_STATUS, ON_DELETE_ORDER_STATUS, ON_ERROR_DELETE_ORDER_STATUS,
    ON_START_NEW_PROJEKT_STATUS, ON_NEW_PROJEKT_STATUS, ON_ERROR_PROJEKT_STATUS,
    ON_START_DELETE_PROJEKT_STATUS, ON_DELETE_PROJEKT_STATUS, ON_ERROR_DELETE_PROJEKT_STATUS,
    ON_START_NEW_PROJEKT_FAS, ON_NEW_PROJEKT_FAS, ON_ERROR_PROJEKT_FAS,
    ON_START_DELETE_PROJEKT_FAS, ON_DELETE_PROJEKT_FAS, ON_ERROR_DELETE_PROJEKT_FAS,
    ON_START_UPDATE_PROJEKT_FAS, ON_UPDATE_PROJEKT_FAS, ON_ERROR_UPDATE_PROJEKT_FAS,
    
    ON_START_NEW_PROJEKT_FAS_VIEW,
    ON_NEW_PROJEKT_FAS_VIEW,
    ON_ERROR_NEW_PROJEKT_FAS_VIEW,
    ON_START_DELETE_PROJEKT_FAS_VIEW,
    ON_DELETE_PROJEKT_FAS_VIEW,
    ON_ERROR_DELETE_PROJEKT_FAS_VIEW,
    ON_START_UPDATE_PROJEKT_FAS_VIEW,
    ON_UPDATE_PROJEKT_FAS_VIEW,
    ON_ERROR_UPDATE_PROJEKT_FAS_VIEW,

    ON_START_NEW_ARENDE_STATUS, ON_NEW_ARENDE_STATUS, ON_ERROR_ARENDE_STATUS,
    ON_START_DELETE_ARENDE_STATUS, ON_DELETE_ARENDE_STATUS, ON_ERROR_DELETE_ARENDE_STATUS,
    ON_START_UPDATE_ARENDE_STATUS, ON_UPDATE_ARENDE_STATUS, ON_ERROR_UPDATE_ARENDE_STATUS,
    ON_START_GET_ARENDE_STATUS, ON_GET_ARENDE_STATUS,

    ON_OPEN_FILTER_KUNDER,ON_ClOSE_FILTER_KUNDER,
    ON_START_SYNC_USER,ON_SYNC_USER,ON_ERROR_SYNC_USER,
    ON_START_FLAGA_HANDELSE,ON_FLAGA_HANDELSE,ON_ERROR_FLAGA_HANDELSE,
    SET_ZERO_KUND,KALKYL_ALLREADY_SAVED,
    ON_KUND_ANTAL_ORDER,
    ON_START_GET_DASHBORAD_OBJEKT,ON_FETCH_DASHBORAD_OBJEKT,ON_ERROR_DASHBORAD_OBJEKT,
    ON_START_GET_DASHBORAD_LOOP_OBJEKT,ON_FETCH_DASHBORAD_LOOP_OBJEKT,ON_ERROR_DASHBORAD_LOOP_OBJEKT,
    ON_START_GENERATE_DASHBORAD_LINK, ON_GENERATE_DASHBORAD_LINK, ON_ERROR_GENERATE_DASHBORAD_LINK,
    ON_START_GET_NEW_KUND_BASIC, ON_GET_NEW_KUND_BASIC, ON_ERROR_GET_NEW_KUND_BASIC,
    //ON_START_GET_NEW_KUND_TOOLTIP_DETAILS, ON_GET_NEW_KUND_TOOLTIP_DETAILS, ON_ERROR_GET_NEW_KUND_TOOLTIP_DETAILS,
    ON_START_NEW_KUND,ON_NEW_KUND,ON_ERROR_NEW_KUND,
    ON_START_NEW_UTOKNING, ON_NEW_UTOKNING, ON_ERROR_NEW_UTOKNING,
    ON_START_NEW_FALT, ON_NEW_FALT, ON_ERROR_NEW_FALT,
    ON_START_DELETE_KALK_TEMP_ROW,
    ON_DELETE_KALK_TEMP_ROW,
    ON_ERROR_DELETE_KALK_TEMP_ROW,
    ON_START_ADD_KALK_TEMP_ROW,
    ON_ADD_KALK_TEMP_ROW,
    ON_ERROR_ADD_KALK_TEMP_ROW,
    ON_START_UPDATE_KALK_TEMP_ROW,
    ON_UPDATE_KALK_TEMP_ROW,
    ON_ERROR_UPDATE_KALK_TEMP_ROW,
    ON_START_GET_UTOKNING,ON_GET_UTOKNING,ON_ERROR_GET_UTOKNING,
    ON_START_DELETE_FALT, ON_DELETE_FALT, ON_ERROR_DELETE_FALT,
    ON_START_SAVE_FALT, ON_SAVE_FALT, ON_ERROR_SAVE_FALT,
    ON_SAVE_KONTO_OBJECT,ON_ARCHIVE_KONTO_OBJECT,
    ON_START_KUND_NEW_UTOKNING, ON_KUND_NEW_UTOKNING, ON_ERROR_KUND_NEW_UTOKNING,
    ON_START_GET_UTOKNING_BY_ORGNR,ON_GET_UTOKNING_BY_ORGNR,ON_ERROR_UTOKNING_BY_ORGNR,
    ON_START_SAVE_UTOKNING_DESC_BY_ORGNR, ON_SAVE_UTOKNING_DESC_BY_ORGNR, ON_ERROR_SAVE_UTOKNING_DESC_BY_ORGNR,
    ON_START_GET_UTOKNING_DESC_BY_ORGNR, ON_GET_UTOKNING_DESC_BY_ORGNR, ON_ERROR_GET_UTOKNING_DESC_BY_ORGNR,
    ON_START_GET_UTOKNING_LIST_BY_ORGNR,ON_GET_UTOKNING_LIST_BY_ORGNR,ON_ERROR_UTOKNING_LIST_BY_ORGNR,
    ON_START_DELETE_UTOKNING_BY_ORGNR, ON_DELETE_UTOKNING_BY_ORGNR, ON_ERROR_DELETE_UTOKNING_BY_ORGNR,
    ON_START_KUND_UPDATE_UTOKNING, ON_KUND_UPDATE_UTOKNING, ON_ERROR_KUND_UPDATE_UTOKNING,
    SET_KUNDER_FILTER,
    ON_START_NEW_AFID_KEDJA, ON_NEW_AFID_KEDJA, ON_ERROR_NEW_AFID_KEDJA,
    ON_DELETE_AFID_KEDJA,ON_START_DELETE_AFID_KEDJA,ON_ERROR_DELETE_AFID_KEDJA,
    ON_UPDATE_AFID_KEDJA,ON_START_UPDATE_AFID_KEDJA,ON_ERROR_UPDATE_AFID_KEDJA,
    ON_START_GET_AF_DIALER,ON_GET_AF_DIALER,ON_ERROR_GET_AF_DIALER,
    ON_START_GET_USER_DIALER,ON_GET_USER_DIALER,ON_ERROR_GET_USER_DIALER,
    ON_START_SAVE_DIALER,ON_SAVE_DIALER,ON_ERROR_SAVE_DIALER,
    ON_START_SAVE_USER_DIALER, ON_SAVE_USER_DIALER, ON_ERROR_SAVE_USER_DIALER,
    ON_START_DIALER_ADD_EJSVAR, ON_DIALER_ADD_EJSVAR, ON_ERROR_DIALER_ADD_EJSVAR,
    ON_START_DIALER_ADD_NEJTACK, ON_DIALER_ADD_NEJTACK, ON_ERROR_DIALER_ADD_NEJTACK,
    ON_DIALER_DELETE_NEJTACK,ON_DIALER_DELETE_EJSVAR,
    ON_START_ADD_DOCUMENT, ON_ADD_DOCUMENT, ON_ERROR_ADD_DOCUMENT,
    ON_START_SYNC_DOCUMENT_ONEDRIVE, ON_SYNC_DOCUMENT_ONEDRIVE, ON_ERROR_SYNC_DOCUMENT_ONEDRIVE,
    ON_START_UPDATE_KUND_DOCUMENT, ON_UPDATE_KUND_DOCUMENT, ON_ERROR_UPDATE_KUND_DOCUMENT,
    ON_START_EJAKTIV_USER,  ON_EJAKTIV_USER,ON_TAEJAKTIV_USER,  ON_ERROR_EJAKTIV_USER,
    ON_START_PERATER_USER,  ON_PERATER_USER,  ON_ERROR_PERATER_USER,
    ON_START_FETCH_ADMIN_STATISTIK,ON_FETCH_ADMIN_STATISTIK,ON_ERROR_ADMIN_STATISTIK,
    ON_START_FETCH_RAPPORT,ON_FETCH_RAPPORT,ON_ERROR_FETCH_RAPPORT,
    ON_FETCH_RAPPORT_MESSAGE,ON_ERROR_FETCH_RAPPORT_MESSAGE,
    ON_START_FETCH_MINATAG,ON_FETCH_MINATAG,ON_ERROR_MINATAG,
    ON_START_FETCH_MINAORT,ON_FETCH_MINAORT,ON_ERROR_MINAORT,
    ON_START_DELETE_KUND_DOCUMENT, ON_DELETE_KUND_DOCUMENT, ON_ERROR_DELETE_KUND_DOCUMENT,
    ON_START_GET_DASHBORAD_LINK,ON_FETCH_DASHBORAD_LINK,ON_ERROR_DASHBORAD_LINK,
    ON_START_BESTALLA_FORTNOX, ON_BESTALLA_FORTNOX, ON_ERROR_BESTALLA_FORTNOX,
    ON_START_GET_AF_FORTNOX,ON_GET_AF_FORTNOX,ON_ERROR_GET_AF_FORTNOX,
    ON_START_GET_AF_LFORTNOX,ON_GET_AF_LFORTNOX,ON_ERROR_GET_AF_LFORTNOX,
    ON_START_GET_AF_DFORTNOX,ON_GET_AF_DFORTNOX,ON_ERROR_GET_AF_DFORTNOX,
    ON_START_GET_AF_FORTNOX_KUNDER,ON_GET_AF_FORTNOX_KUNDER,ON_ERROR_GET_AF_FORTNOX_KUNDER,
    ON_START_GET_AF_FORTNOX_ARTIKLAR,ON_GET_AF_FORTNOX_ARTIKLAR,ON_ERROR_GET_AF_FORTNOX_ARTIKLAR,
    ON_START_GET_AF_FORTNOX_ORDER,ON_GET_AF_FORTNOX_ORDER,ON_ERROR_GET_AF_FORTNOX_ORDER,
    ON_START_GET_AF_FORTNOX_OFFERT,ON_GET_AF_FORTNOX_OFFERT,ON_ERROR_GET_AF_FORTNOX_OFFERT,
    ON_START_GET_AF_FORTNOX_KUND,ON_GET_AF_FORTNOX_KUND,ON_ERROR_GET_AF_FORTNOX_KUND,
    ON_START_FORTNOX_NEWKUND, ON_FORTNOX_NEWKUND, ON_ERROR_FORTNOX_NEWKUND,
    ON_START_FORTNOX_EDITKUND, ON_FORTNOX_EDITKUND, ON_ERROR_FORTNOX_EDITKUND,
    ON_START_FORTNOX_CONNECT_KUND,ON_FORTNOX_CONNECT_KUND,ON_ERROR_FORTNOX_CONNECT_KUND,
    ON_START_FORTNOX_DELKUND, ON_FORTNOX_DELKUND, ON_ERROR_FORTNOX_DELKUND,
    ON_START_UPDATE_ORDER_STATUS, ON_UPDATE_ORDER_STATUS, ON_ERROR_UPDATE_ORDER_STATUS,
    ON_START_GET_ORDER_STATUS,ON_GET_ORDER_STATUS,
    ON_START_UPDATE_PROJEKT_STATUS, ON_UPDATE_PROJEKT_STATUS, ON_ERROR_UPDATE_PROJEKT_STATUS,
    ON_START_GET_PROJEKT_STATUS,ON_GET_PROJEKT_STATUS,
    ON_START_GET_UTOKNING_BY_AFID,
    ON_GET_UTOKNING_BY_AFID,
    ON_ERROR_UTOKNING_BY_AFID,
    ON_START_SEARCH_UTOKNING_BY_AFID,
    ON_ERROR_SEARCH_UTOKNING_BY_AFID,
    ON_SEARCH_UTOKNING_BY_AFID,
    ON_START_GET_UTOKNING_LOGG,
    ON_ERROR_GET_UTOKNING_LOGG,
    ON_GET_UTOKNING_LOGG,
    ARENDE_ON_FETCH_ASSISTANSBÅT,
    ON_BUFFER_UTOKNING_BY_AFID,
    ON_CACHE_UTOKNING_BY_AFID,
    ON_LOAD_CACHE_UTOKNING_BY_AFID,
    ON_START_CONNECT_WOOCOMMERCE, ON_CONNECT_WOOCOMMERCE, ON_ERROR_CONNECT_WOOCOMMERCE,
    ON_START_GET_WOOCOMMERCE, ON_GET_WOOCOMMERCE, ON_ERROR_GET_WOOCOMMERCE,
    ON_START_DISCONNECT_WOOCOMMERCE, ON_DISCONNECT_WOOCOMMERCE, ON_ERROR_DISCONNECT_WOOCOMMERCE,
    ON_START_SYNC_WOOCOMMERCE_CUSTOMERS, ON_SYNC_WOOCOMMERCE_CUSTOMERS,ON_ERROR_SYNC_WOOCOMMERCE_CUSTOMERS,
    ON_START_CREATE_WOOCOMMERCE_CUSTOMER, ON_CREATE_WOOCOMMERCE_CUSTOMER,ON_ERROR_CREATE_WOOCOMMERCE_CUSTOMER,
    ON_START_DISCONNECT_WOOCOMMERCE_CUSTOMER, ON_DISCONNECT_WOOCOMMERCE_CUSTOMER,ON_ERROR_DISCONNECT_WOOCOMMERCE_CUSTOMER,
    ON_START_CONNECT_WOOCOMMERCE_CUSTOMER, ON_CONNECT_WOOCOMMERCE_CUSTOMER,ON_ERROR_CONNECT_WOOCOMMERCE_CUSTOMER,
    ON_START_GET_WOOCOMMERCE_CUSTOMER, ON_GET_WOOCOMMERCE_CUSTOMER,ON_ERROR_GET_WOOCOMMERCE_CUSTOMER,
    ON_START_UPDATE_WOOCOMMERCE, ON_UPDATE_WOOCOMMERCE, ON_ERROR_UPDATE_WOOCOMMERCE,
    
    ON_START_CONNECT_WOOCOMMERCE_WP_REST,
    ON_CONNECT_WOOCOMMERCE_WP_REST,
    ON_ERROR_CONNECT_WOOCOMMERCE_WP_REST,
    ON_ERROR_DISCONNECT_WOOCOMMERCE_WP_REST,
    ON_START_DISCONNECT_WOOCOMMERCE_WP_REST,
    ON_DISCONNECT_WOOCOMMERCE_WP_REST,

    ON_START_CONNECT_BITLOG_REST,
    ON_CONNECT_BITLOG_REST,
    ON_ERROR_CONNECT_BITLOG_REST,
    ON_ERROR_DISCONNECT_BITLOG_REST,
    ON_START_DISCONNECT_BITLOG_REST,
    ON_DISCONNECT_BITLOG_REST,

    ON_START_ADD_WOOCOMMERCE_WEBHOOK,
    ON_ADD_WOOCOMMERCE_WEBHOOK,
    ON_ERROR_ADD_WOOCOMMERCE_WEBHOOK,
    ON_START_GET_WOOCOMMERCE_WEBHOOK,
    ON_GET_WOOCOMMERCE_WEBHOOK,
    ON_ERROR_GET_WOOCOMMERCE_WEBHOOK,
    ON_START_DELETE_WOOCOMMERCE_WEBHOOK,
    ON_DELETE_WOOCOMMERCE_WEBHOOK,
    ON_ERROR_DELETE_WOOCOMMERCE_WEBHOOK,
    ON_START_FETCH_WP_WOOCOMMERCE_WEBHOOK,
    ON_FETCH_WP_WOOCOMMERCE_WEBHOOK,
    ON_ERROR_FETCH_WP_WOOCOMMERCE_WEBHOOK,

    ON_GET_WHOLESALESUTIE_ROLES,
    ON_START_GET_WHOLESALESUTIE_ROLES,
    ON_ERROR_GET_WHOLESALESUTIE_ROLES,
    ON_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST,
    ON_START_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST,
    ON_ERROR_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST,
    ON_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST,
    ON_START_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST,
    ON_ERROR_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST,

    ON_START_GET_PYRAMID, 
    ON_GET_PYRAMID, 
    ON_ERROR_GET_PYRAMID, 
    ON_START_CONNECT_PYRAMID, 
    ON_CONNECT_PYRAMID, 
    ON_ERROR_CONNECT_PYRAMID, 
    ON_START_DISCONNECT_PYRAMID, 
    ON_DISCONNECT_PYRAMID, 
    ON_ERROR_DISCONNECT_PYRAMID, 
    ON_START_UPDATE_PYRAMID, 
    ON_UPDATE_PYRAMID,
    ON_ERROR_UPDATE_PYRAMID, 

    ON_START_CREATE_PYRAMID_CUSTOMER,
    ON_CREATE_PYRAMID_CUSTOMER,
    ON_ERROR_CREATE_PYRAMID_CUSTOMER,
    ON_START_CONNECT_PYRAMID_CUSTOMER,
    ON_CONNECT_PYRAMID_CUSTOMER,
    ON_ERROR_CONNECT_PYRAMID_CUSTOMER,
    ON_START_DISCONNECT_PYRAMID_CUSTOMER,
    ON_DISCONNECT_PYRAMID_CUSTOMER,
    ON_ERROR_DISCONNECT_PYRAMID_CUSTOMER,
    ON_START_GET_PYRAMID_CUSTOMER,
    ON_GET_PYRAMID_CUSTOMER,
    ON_ERROR_GET_PYRAMID_CUSTOMER,

    ON_START_CREATE_PYRAMID_CONTACT,
    ON_CREATE_PYRAMID_CONTACT,
    ON_ERROR_CREATE_PYRAMID_CONTACT,
    ON_START_CONNECT_PYRAMID_CONTACT,
    ON_CONNECT_PYRAMID_CONTACT,
    ON_ERROR_CONNECT_PYRAMID_CONTACT,
    ON_START_DISCONNECT_PYRAMID_CONTACT,
    ON_DISCONNECT_PYRAMID_CONTACT,
    ON_ERROR_DISCONNECT_PYRAMID_CONTACT,
    ON_START_GET_PYRAMID_CONTACT,
    ON_GET_PYRAMID_CONTACT,
    ON_ERROR_GET_PYRAMID_CONTACT,

    ON_START_CONNECT_ZENDESK,
    ON_CONNECT_ZENDESK,
    ON_ERROR_CONNECT_ZENDESK,
    ON_START_DISCONNECT_ZENDESK,
    ON_DISCONNECT_ZENDESK,
    ON_ERROR_DISCONNECT_ZENDESK,
    ON_GET_ZENDESK,
    ON_ERROR_GET_ZENDESK,
    ON_START_GET_ZENDESK,
    ON_START_ADD_NEW_TAG, ON_ADD_NEW_TAG, ON_ERROR_ADD_NEW_TAG,
    ON_START_REMOVE_TAG_FROM_ACCOUNT,
    ON_REMOVE_TAG_FROM_ACCOUNT,
    ON_ERROR_REMOVE_TAG_FROM_ACCOUNT,
    ON_START_UPDATE_TAG_FROM_ACCOUNT,
    ON_UPDATE_TAG_FROM_ACCOUNT,
    ON_ERROR_UPDATE_TAG_FROM_ACCOUNT,
    
    ON_START_GET_PROJEKT_FAS_LIST,
    ON_GET_PROJEKT_FAS_LIST,
    ON_ERROR_GET_PROJEKT_FAS_LIST,

    ON_START_STATISTIC_TOTALORDER,GET_STATISTIC_TOTALORDER,ERROR_STATISTIC_TOTALORDER,
    ON_START_STATISTIC_TOTALMOTEN,GET_STATISTIC_TOTALMOTE,ERROR_STATISTIC_TOTALMOTE,
    ON_START_STATISTIC_TOTALAKTIVITETER, GET_STATISTIC_TOTALAKTIVITETER, ERROR_STATISTIC_TOTALAKTIVITETER,
    ON_START_STATISTIC_TOTALOFFERT,GET_STATISTIC_TOTALOFFERT,ERROR_STATISTIC_TOTALOFFERT,
    ON_START_STATISTIC_LOPANDEINTAKT_TOTAL, GET_STATISTIC_LOPANDEINTAKT_TOTAL, ERROR_STATISTIC_LOPANDEINTAKT_TOTAL,
    ON_START_STATISTIC_ORDERTYP_TOTAL, GET_STATISTIC_ORDERTYP_TOTAL, ERROR_STATISTIC_ORDERTYP_TOTAL,
    ON_START_STATISTIC_SALES_TOTAL, GET_STATISTIC_SALES_TOTAL, ERROR_STATISTIC_SALES_TOTAL,

    ON_START_CREATE_API_TOKEN,
    ON_ERROR_CREATE_API_TOKEN,
    ON_CREATE_API_TOKEN,
    ON_START_REVOKE_API_TOKEN,
    ON_ERROR_REVOKE_API_TOKEN,
    ON_REVOKE_API_TOKEN,
    GET_AF_BUDGET_WORK_DAYS,

    ON_START_GET_AF_NOTIS,
    ON_GET_AF_NOTIS,
    ON_ERROR_GET_AF_NOTIS,
    ON_START_SET_AF_NOTIS_SEEN,
    ON_SET_AF_NOTIS_SEEN,
    ON_ERROR_SET_AF_NOTIS_SEEN,

    ON_START_ADD_NEW_DISTRIKT,
    ON_ERROR_ADD_NEW_DISTRIKT,
    ON_ADD_NEW_DISTRIKT,

    ON_START_UPDATE_DISTRIKT,
    ON_ERROR_UPDATE_DISTRIKT,
    ON_UPDATE_DISTRIKT,

    ON_START_DELETE_DISTRIKT,
    ON_ERROR_DELETE_DISTRIKT,
    ON_DELETE_DISTRIKT,

    ON_START_GET_DISTRIKT,
    ON_ERROR_GET_DISTRIKT,
    ON_GET_DISTRIKT,

    ON_START_GET_THIS_DISTRIKT,
    ON_ERROR_GET_THIS_DISTRIKT,
    ON_GET_THIS_DISTRIKT,

    ON_START_GET_MINA_DISTRIKT_POSTNR,
    ON_ERROR_GET_MINA_DISTRIKT_POSTNR,
    ON_GET_MINA_DISTRIKT_POSTNR,

    ON_GET_ONEDRIVE_ROOT,
    ON_ERROR_GET_ONEDRIVE_ROOT,
    ON_START_GET_ONEDRIVE_ROOT,
    ON_ADD_ONEDRIVE_ROOT,
    ON_ERROR_ADD_ONEDRIVE_ROOT,
    ON_START_ADD_ONEDRIVE_ROOT,
    ON_GET_AKTIVAKUND_KONTAKTER,
    ON_START_GET_AKTIVAKUND_KONTAKTER,
    ON_ERROR_GET_AKTIVAKUND_KONTAKTER,
    ON_SET_NUMAKTIVITETER_KUND,
    //Jack
    ON_START_ADD_PROJEKT_TIME_TYPE,ON_ADD_PROJEKT_TIME_TYPE,ON_ERROR_ADD_PROJEKT_TIME_TYPE,
    ON_UPPDATE_PROJEKT_TIME_TYPE,ON_DELETE_PROJEKT_TIME_TYPE,ON_NEW_PROJEKT_TIME_TYPE_CATEGORY,
    ON_DELETE_PROJEKT_TIME_TYPE_CATEGORY,ON_ADD_PROJEKT_NEW_TEMPLATE_BOARD,
    ON_UPDATE_PROJEKT_TEMPLATE_BOARD,ON_ERROR_UPDATE_PROJEKT_TIME_TYPE,ON_DELETE_PROJEKT_TEMPLATE_BOARD,
    ON_START_NEW_ARTIKEL_TAGG,ON_NEW_ARTIKEL_TAGG,ON_ERROR_NEW_ARTIKEL_TAGG,ON_UPPDATE_ARTIKEL_TAGG,
    ON_DELETE_ARTIKEL_TAGG,ON_DELETE_AKTIVITET,
    ON_START_MESSAGE_KUND,  ON_MESSAGE_KUND,  ON_ERROR_MESSAGE_KUND,
    ON_NEW_AF_PROSPEKT_TASK,
    ON_START_NEW_AF_PROSPEKT_TASK,
    ON_ERROR_NEW_AF_PROSPEKT_TASK,
    ON_UPDATE_AF_PROSPEKT_TASK,
    ON_START_UPDATE_AF_PROSPEKT_TASK,
    ON_ERROR_UPDATE_AF_PROSPEKT_TASK,
    ON_DELETE_AF_PROSPEKT_TASK,
    ON_START_DELETE_AF_PROSPEKT_TASK,
    ON_ERROR_DELETE_AF_PROSPEKT_TASK,
    ON_GET_AF_PROSPEKT_TASK,
    ON_START_GET_AF_PROSPEKT_TASK,
    ON_ERROR_GET_AF_PROSPEKT_TASK,
    //
    ON_START_NEW_AF_ORDER_TASK, ON_NEW_AF_ORDER_TASK, ON_ERROR_NEW_AF_ORDER_TASK,
    ON_START_GET_AF_ORDER_TASK,ON_GET_AF_ORDER_TASK,ON_ERROR_GET_AF_ORDER_TASK,
    ON_START_UPDATE_AF_ORDER_TASK, ON_UPDATE_AF_ORDER_TASK, ON_ERROR_UPDATE_AF_ORDER_TASK,
    ON_START_DELETE_AF_ORDER_TASK,ON_DELETE_AF_ORDER_TASK,ON_ERROR_DELETE_AF_ORDER_TASK,

    ON_START_FETCH_VALID_REST_API_TOKEN,
    ON_ERROR_FETCH_VALID_REST_API_TOKEN,
    ON_FETCH_VALID_REST_API_TOKEN,

    ON_ADD_AUTH_MAIL_DOMAIN,
    ON_ERROR_ADD_AUTH_MAIL_DOMAIN,
    ON_START_ADD_AUTH_MAIL_DOMAIN,
    ON_GET_AUTH_MAIL_DOMAIN,
    ON_ERROR_GET_AUTH_MAIL_DOMAIN,
    ON_START_GET_AUTH_MAIL_DOMAIN,
    ON_REMOVE_AUTH_MAIL_DOMAIN,
    ON_ERROR_REMOVE_AUTH_MAIL_DOMAIN,
    ON_START_REMOVE_AUTH_MAIL_DOMAIN,
    ON_VALIDATE_AUTH_MAIL_DOMAIN,
    ON_ERROR_VALIDATE_AUTH_MAIL_DOMAIN,
    ON_START_VALIDATE_AUTH_MAIL_DOMAIN,
   } from '../constants/ActionTypes'
import {isUndefined, isNull,isEmpty} from 'lodash'
import { translate } from "../util/intlHelper";

const INIT_STATE = {
   currentKontoTabIndex: 41,
   updatedashboard: 0,
   updatedashboardBokaTY: 0,
   updatedashboardOrderTY: 0,
   updatedashboardDialer: 0,
   updatedashboardAktivitet: 0,
   updatedashboardProspekt: 0,
   updatedashboardOffert: 0,
   updatedashboardProjekt: 0,
   updatedashboardTidProjekt: 0,
   updatedashboardArende: 0,
   updatedashboardAvtal: 0,
   updatedashboardLynes: 0,
   updatedashboardDevice: 0,
   updatedashboardisMessage: 0,
   KundMessageP:"",
   AfDistrikt: [],
   KundgoogleAdds: [],
   KundFacebookAdds: [],
   AvtalFormula:[
    {Order:0,text:"ID",isDelimiter:0},
    {Order:1,text:"-",isDelimiter:1},
    {Order:2,text:"Typ",isDelimiter:0},
    {Order:3,text:"-",isDelimiter:1},
    {Order:4,text:"Leverantör",isDelimiter:0}
   ],
   FakturaIntervall:[],
   /*TypAvAffarR:[
    {value: '1',label: 'Nytt',},
    {value: '3',label: 'Befintligt',},
    {value: '2',label: 'Omförhandling ny kund',},
    {value: '4',label: 'Omförhandling bef kund',}
   ],
   */
   TypAvAffarR:[],
   KundFornoxPrislist:0,
   budgetAfWorkDays: {},
   currentAfDistrikt: {},
   DistriktResponse: {},
   DistriktLoading: false,
   MinaDistrikt: [],
   ArandeList:[],
   FordonDataOrgnr:[],
   KundPrisListor:[],
   AFNotis: [],
   AntalStatistikOrder:{month:0,prevYear:0,year:0},
   AntalStatistikMote: {month:0,prevYear:0,year:0},
   AntalStatistikAktivitet: {month:0,prevYear:0,year:0},
   AntalStatistikOffert: {month:0,prevYear:0,year:0},
   AntalLopandeIntakt: 0,
   AntalOrderTyp: [],
   AntalSales: {month:0,prevYear:0,year:0},
   Woocommerce:[],
   WholesaleSuiteRoles:[],
   KundSKundData:[],
   AfidArticleTypesFreeInputs:[],
   ArendeCategori:[],
   ArendeCateFreeInputs:[],
   KontoArendeFI:[],
   VaxleUSer:[],
   HogiaStoreId:[],
   WoocommerceLoading: false,
   ZendeskLoading: false,
   Zendesk:[],
   WoocommerceWebhooks:[],
   CurrentWpWebhookUrl: null,
   loadingCurrentWpWebhookUrl: false,
   Office:{},
   ChildKonto:{},
   accounts:[],
   ChildList:[],
   UndekontoKontor:[],
   message:"",
   currentAccount:"",
   Kontorlista:[],
   Teamslista:[],
   MinaDokument:[],
   KundsDokument:[],
   OrgnrKund:"",
    TotalKundList:0,
    isPersonlig:0,
    FortnoxisActionDone:0,
   isLoadingMD:true,
   TotalList:0,
   AvtalTyp:"",
   MinaKedja:"",
   LeventorList:"",
   OrtList:"",
   Kalkyllist:"",
   Schablonlist:"",
   SchablonPresetList:"",
   KanChosOlikaBL:0,
   AktivaKunder:[],
   AktivaKundKontakter:[],
   KalkylOptions:[],
   SveaCreditResult:{},
   CreditSafeResult:{},
   LastCreditSafeResult:{},
   LastSveaCreditResult:{},
   CreditSafeRapports:[],
   Lastdate:"",
   LastSveadate:"",
   ResultId:0,
   CreditSafeResultisWaiting:false,
   Flags:"",
   Antal:"",
   ProspektFaslist:"",
   KundDatalist:[],
   AFOrderFreeInputsList:[],
   AvtalAvslutning:[],
   Userlista:[],
   searchedKund:"",
   IsloadingSearch:false,
   currentKund:"",
   currentWoocommerceKund:[],
   PyramidLoading:false,
   Pyramid:[],
   currentPyramidKund:[],
   currentPyramidKontakt:[],
   handelse:"",
   isLoading:false,
   isLoadingKundMap: false,
   handelselist:[],
   HisLoading:false,
   currentHandelse:"",
   CHisLoading:false,
   handelseLog:"",
   HandelseFiler:"",
   NKLoading:false,
   KontakterList:[],
   StandardEsiFree:[],
   ATLoading:false,
   FFLoading:false,
   FFRLoading:false,
   OrderMail:"",
   MinaKunder:[],
   MinaKunderCloseTo:[],
   MinaKontaktPersoner:[],
   KontaktAntal:0,
   KundFortnoxFak:[],
   ArandeMail:"",
   KundAntal:0,
   DocumentList:[],
   AntalDokPdf:0,
   DocumentListPdf:[],
   importeraLoading:false,
   Esignering:"",
   FortNox:"",
  FortNoxUppgifter: {},
  CurrentFaktura: {},
   FortNoxisLoading:false,
   FortnoxKundNrFortnox:0,
   Dailer:"",
   isIamChild:0,
   NejTackList:[],
   BortFallList:[],
   EjSvarList:[],
   BlackListT:[],
   HasOutlook:0,
   MyOfficeType:1,
   prisListor: [],
   ALlowedUsers: [],
   ALlowedSveaUsers: [],
   currentPriceList: {},
   OldAf:[],
   OldAFUsers:[],
   SyhncLoading:false,
   AktivitetTags:[],
   FilterKunderPopUp:false,
   KundSearch:{},
   KundSearchLoading: false,
   //KundTooltipDetails: null,
   UtokningDynamicFields:[],
   Utokning:[],
   UtokningKundList:[],
   CurrentObjektLogg: {},
   TillGodoObject: {},
   CurrentObjekt:[],
   CurrentObjektKalkTemp:[],
   CurrentObjektKundList:[],
   CurrentObjektKund:[],
   CurrentObjektKunddesc:"",
   CurrentObjektKundCount:0,
   CurrentObjektAfid:[],
   CurrentObjektAfidExt:[],
   CurrentObjektAfidCount:0,
   userLoading:false,
   MinaTags:[],
   MinaOrts:[],
   AccountTags:[],
   KanOlikaBL:0,
   FilterOption:isUndefined(localStorage.KunderFilter)?[]:JSON.parse(localStorage.KunderFilter), 
   AdminStatistik:[],
   AccountStatistic:[],
   isRapportLoading:false,
   isSearchLoading:false,
   OfficeUsers:[],
   ChildKontoUsers:[],
   ChildKontoTeams:[],
   ChildKontoTeamsAll:[],
   ChildKontoOffices:[],
   AllChildKontoUsers:[],
   OrderFreeInputsList:[],
   prospektAvtalFreeInputsList:[],
   OrderStatusList:[],
   EventStatusList:[],
   AktivitetTypeList:[],
   ProjectStatusList:[],
   ProjectFasList:[],
   ProjectFasViewList:[],
   ArendeStatusList:[],
   RestAPITokenList:[],
   ChildListWOPList:[],
   DashboardArr:[
    {Label:"Översikt",Url:"-",display:true},
    {Label:"Sälj TV",Url:"-",display:true},
    {Label:"Boka TV",Url:"-",display:true},
    {Label:"Order",Url:"-",display:true},
    {Label:"Aktiviteter",Url:"-",display:true},
    {Label:"Dialer",Url:"-",display:true},
    {Label:"Prognos",Url:"-",display:true},
    {Label:"Konton",Url:"-",display:false},
   ],
   DashboardLoopArr:[],
   DashboardObjekt:{},
   DashboardLoopObjekt:{},
   FortNoxMall:[
    {Template: "st",Name: "Standardmall"},
    {Template: "ps",Name: "Följesedel"},
    {Template: "cash",Name: "Kontantfaktura"},
    {Template: "residual_amount_rut_rot",Name: "Restbelopp RUT/ROT"},
   ],
   FortnoxAttachments:[],
   FortnoxFolder:[],
   Fortnoxbreadcrumbs:[],
   FortNoxTermOfPayments:[
    {Code:"",Description:'Välj'},
    {Code:"0",Description:'0 dagar'},
    {Code:"10",Description:'10 dagar'},
    {Code:"15",Description:'15 dagar'},
    {Code:"20",Description:'20 dagar'},
    {Code:"30",Description:'30 dagar'},
    {Code:"AG",Description:'Autogiro'},
    {Code:"K",Description:'Kontant'},
    {Code:"PF",Description:'Postförskott'},
   ],
   FortNoxPrisListors:[
    {value:"",Meta:'Välj'},
    {value:"A",Meta:'Prislista A'}
  ],
   FortNoxProjekt:[],
   FortNoxProjektCurrent:[],
   FortnoxdefaultMall:"st",
   FortnoxdefaultMoms:1,
   KundPage:1,
   KundPagerows:isUndefined(localStorage.KundPagerows)?25:JSON.parse(localStorage.KundPagerows),
   KundSearchText: '',
   KontaktPage:1,
   TabIndex:0,
   SortByObej:{label:"KundName",Method:"asc"},
   TermOfPayment:15,
   CreditSafeInfo:{},
   SveaCreditSafeInfo:{},
   SettingsAvtalFortnox:{},
   WayOfDelivery:[],
   TermsOfDelivery:[],
   NotyfileUsers:[],
   AntalDok:[{total:0}],
   OrderSetting:{KalkylOrderPop:0,dokumentOrderPop:0,kunddataOrderPop:0,defaultProduktOrderTempid:0,OrderPrefix:"",kanDelOrder:0},
   OrderAffarfrom:[],
   EventsSetting:{defaultAccept:1,standardKPI:0,ApproveRights:0,ljudnotis:0,FilterKlendarJEvent:0,StandardBjudaIn:0,NyProspektIDialer:0,StandardSubject:"",TeamLinks:1,AvtalEventDialer:0,defualtType:0},
   LobbySetting:{VunnenFlag:0,BokatFlag:0,EsigneringFlag:0,OffertFlag:0,ProjektFlag:0,ForsaljningmotBudget:1,AnpassadLobby:1},
   KundDataHeader:[],
   KundDataALLHeader:[],
   KundSKundDataType:[],
   ALLKundDataType:[],
   ALLDialerKundDataType:[],
   KdLoading:true,
   ResponseKontoMsg:{},
   ResponseKundMsg:{},
   ResponseRapportMsg:{},
   SavedAnRapport:[],
   OneDriveRoot: [],
   AfProspektTaskList: [],
   AfOrderTaskList: [],
   ImportSamples: [],
   ImportSamplesFlag:false,
   ImportSamplesMessage:{},
   SparadRapportV2:[],
   LoggRapportV2:[],
   UnderKontoKunder:[],
   KommentarResult:[],
   OrgnrTree:[],
   ArtiklarTBavdrag:[],
   isCheckedOk:2,
   isLoadingResult:false,
   AnvPage:1,
   ShowImportlogg:0,
   usingStorage:0,
   importType:"",
   FileBlod:{},
   SendGridAuthData: {},
   ValidRestApiToken: null,
   fileMessage:"",
   FileCheck:false,
   FileCheckWarning:false,
   DashBoardValueOf:JSON.stringify([
    {DashBaord:1,Value:1,options:[],isUpdated:0},
    {DashBaord:2,Value:1,options:[],isUpdated:0},
    {DashBaord:3,Value:1,options:[],isUpdated:0},
    {DashBaord:4,Value:1,options:[],isUpdated:0},
    {DashBaord:5,Value:1,options:[],isUpdated:0},
    {DashBaord:6,Value:1,options:[],isUpdated:0},
  ]),
	ArticleTypes: [],
	ArticleTypesFreeInputs: [],
	ArticleTypesFreeInputsList: [],
ArticleTypesFreeInputsListFilterOptions:[],
AfSmsSettings:{},
DailerUser:""
  };
  
  export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case SET_ZERO_KUND:{
        return { 
          currentKontoTabIndex: 0,
          updatedashboard: 0,
          updatedashboardBokaTY: 0,
          updatedashboardOrderTY: 0,
          updatedashboardDialer: 0,
          updatedashboardAktivitet: 0,
          updatedashboardProspekt: 0,
          updatedashboardOffert: 0,
          updatedashboardProjekt: 0,
          updatedashboardTidProjekt: 0,
          updatedashboardArende: 0,
          updatedashboardAvtal: 0,
          updatedashboardLynes: 0,
          updatedashboardDevice: 0,
          updatedashboardisMessage: 0,
          KundMessageP:"",
          FileBlod:{},
          SendGridAuthData: {},
          FordonDataOrgnr:[],
          KundPrisListor:[],
          AfDistrikt: [],
          KundgoogleAdds:[],
          KundFacebookAdds:[],
          AvtalFormula:[
            {Order:0,text:"ID",isDelimiter:0},
            {Order:1,text:"-",isDelimiter:1},
            {Order:2,text:"Typ",isDelimiter:0},
            {Order:3,text:"-",isDelimiter:1},
            {Order:4,text:"Leverantör",isDelimiter:0}
           ],
           TypAvAffarR:[],
           FakturaIntervall:[],
           /*
           TypAvAffarR:[ 
            {value: '1',label: 'Nytt',},
            {value: '3',label: 'Befintligt',},
            {value: '2',label: 'Omförhandling ny kund',},
            {value: '4',label: 'Omförhandling bef kund',}
          ],
          */
           KundFornoxPrislist:0,
          currentAfDistrikt: {},
          DistriktResponse: {},
          DistriktLoading: false,
          budgetAfWorkDays: {},
          MinaDistrikt: [],
          ArandeList:[],
          AFNotis: [],
          isPersonlig:0,
          Woocommerce:[],
          WholesaleSuiteRoles:[],
          Office:{},
          ChildKonto:{},
          CreditSafeInfo:{},
          SveaCreditSafeInfo:{},
          SettingsAvtalFortnox:{},
          accounts:[],
          ChildList:[],
          UndekontoKontor:[],
          KundSKundData:[],
          AfidArticleTypesFreeInputs:[],
          ArendeCategori:[],
          ArendeCateFreeInputs:[],
          KontoArendeFI:[],
          VaxleUSer:[],
          MinaDokument:[],
          KundsDokument:[],
          OrgnrKund:"",
          FortnoxKundNrFortnox:0,
    TotalKundList:0,
          isLoadingMD:true,
          TotalList:0,
          FortnoxisActionDone:0,
   message:"",
   currentAccount:"",
   Kontorlista:"",
   Teamslista:[],
   AvtalTyp:"",
   LeventorList:"",
   OrtList:"",
   MinaKedja:"",
   Kalkyllist:"",
   Schablonlist:"",
   SchablonPresetList:"",
   KanChosOlikaBL:0,
   Antal:"",
   ProspektFaslist:"",
   KundDatalist:[],
   AFOrderFreeInputsList:[],
   AvtalAvslutning:[],
   KalkylOptions:[],
   AktivaKunder:[],
   AktivaKundKontakter:[],
          KundFortnoxFak: [],
          CurrentFaktura: {},
   OrderFreeInputsList:[],
   prospektAvtalFreeInputsList:[],
   OrderStatusList:[],
   EventStatusList:[],
   AktivitetTypeList:[],
   ProjectStatusList:[],
   ProjectFasList:[],
   ProjectFasViewList:[],
   ArendeStatusList:[],
   RestAPITokenList:[],
   SveaCreditResult:{},
   CreditSafeResult:{},
   LastCreditSafeResult:{},
   LastSveaCreditResult:{},
   CreditSafeRapports:[],
   Lastdate:"",
   LastSveadate:"",
   ResultId:0,
   CreditSafeResultisWaiting:false,
   Userlista:[],
   OfficeUsers:[],
   ChildKontoUsers:[],
   AllChildKontoUsers:[],
   ALlowedUsers: [],
   ALlowedSveaUsers: [],
   ChildListWOPList:[],
   ChildKontoOffices:[],
   ChildKontoTeams:[],
   ChildKontoTeamsAll:[],
   searchedKund:"",
   searchedKundBasic:"",
   IsloadingSearch:false,
   currentKund:"",
   currentWoocommerceKund:[],
   PyramidLoading:false,
   Pyramid:[],
   currentPyramidKund:[],
   currentPyramidKontakt:[],
   handelse:"",
   isLoading:false,
   isLoadingKundMap: false,
   handelselist:[],
   HisLoading:false,
   currentHandelse:"",
   CHisLoading:false,
   handelseLog:"",
   HandelseFiler:"",
   NKLoading:false,
   KontakterList:[],
   StandardEsiFree:[],
   ATLoading:false,
   FFLoading:false,
   FFRLoading:false,
   OrderMail:"",
   ArandeMail:"",
   MinaKunder:[],
   MinaKunderCloseTo:[],
   MinaKontaktPersoner:[],
   KontaktAntal:0,
   KundAntal:0,
   DocumentList:[],
   AntalDokPdf:0,
   DocumentListPdf:[],
   importeraLoading:false,
   Esignering:"",
   FortNox:"",
   FortNoxUppgifter:{},
   FortNoxisLoading:false,
   Dailer:"",
   isIamChild:0,
   NejTackList:[],
   BortFallList:[],
   BlackListT:[],
   EjSvarList:[],
   HasOutlook:0,
   MyOfficeType:1,
   prisListor: [],
   currentPriceList: {},
   OldAf:[],
   OldAFUsers:[],
   SyhncLoading:false,
   AktivitetTags:[],
   FilterKunderPopUp:false, 
   KundSearch:{},
   KundSearchLoading: false,
  // KundTooltipDetails: null,
   ZendeskLoading: false,
   Zendesk:[],
   WoocommerceWebhooks:[],
   CurrentWpWebhookUrl: null,
   loadingCurrentWpWebhookUrl: false,
   UtokningDynamicFields:[],
   Utokning:[],
   UtokningKundList:[],
   CurrentObjektLogg: {},
   CurrentObjekt:[],
   CurrentObjektKalkTemp:[],
   CurrentObjektKundList:[],
   CurrentObjektKund:[],
   CurrentObjektKunddesc:"",
   CurrentObjektKundCount:0,
   CurrentObjektAfid:[],
   CurrentObjektAfidExt:[],
   CurrentObjektAfidCount:0,
   FilterOption:[], 
   AdminStatistik:[],
   AccountStatistic:[],
   TillGodoObject: {},
   MinaTags:[],
   MinaOrts:[],
   AccountTags:[],
   KanOlikaBL:0,
   isRapportLoading:false,
   isSearchLoading:false,
   DashboardObjekt:{},
   DashboardLoopObjekt:{},
   DashboardArr:[
    {Label:"Översikt",Url:"-",display:true},
    {Label:"Sälj TV",Url:"-",display:true},
    {Label:"Boka TV",Url:"-",display:true},
    {Label:"Order",Url:"-",display:true},
    {Label:"Aktiviteter",Url:"-",display:true},
    {Label:"Dialer",Url:"-",display:true},
    {Label:"Prognos",Url:"-",display:true},
    {Label:"Konton",Url:"-",display:false},
   ],
   DashboardLoopArr:[],
   FortnoxdefaultMall:"st",
   FortnoxdefaultMoms:1,
   FortNoxMall:[
    {Template: "st",Name: "Standardmall"},
    {Template: "ps",Name: "Följesedel"},
    {Template: "cash",Name: "Kontantfaktura"},
    {Template: "residual_amount_rut_rot",Name: "Restbelopp RUT/ROT"},
   ],
   FortnoxAttachments:[],
   FortnoxFolder:[],
   Fortnoxbreadcrumbs:[],
   FortNoxTermOfPayments:[
    {Code:"",Description:'Välj'},
    {Code:"0",Description:'0 dagar'},
    {Code:"10",Description:'10 dagar'},
    {Code:"15",Description:'15 dagar'},
    {Code:"20",Description:'20 dagar'},
    {Code:"30",Description:'30 dagar'},
    {Code:"AG",Description:'Autogiro'},
    {Code:"K",Description:'Kontant'},
    {Code:"PF",Description:'Postförskott'},
   ],
   FortNoxPrisListors:[
    {value:"",Meta:'Välj'},
    {value:"A",Meta:'Prislista A'}
  ],
   FortNoxProjekt:[],
   FortNoxProjektCurrent:[],
   KundPage:1,
   KundPagerows:isUndefined(localStorage.KundPagerows)?25:JSON.parse(localStorage.KundPagerows),
   KundSearchText: '',
   KontaktPage:1,
   TabIndex:0,
   SortByObej:{label:"KundName",Method:"asc"},
   TermOfPayment:15,
   AntalStatistikOrder:{month:0,prevYear:0,year:0},
   AntalStatistikMote: {month:0,prevYear:0,year:0},
   AntalStatistikAktivitet: {month:0,prevYear:0,year:0},
   AntalStatistikOffert: {month:0,prevYear:0,year:0},
   AntalLopandeIntakt: 0,
   AntalOrderTyp: [],
   AntalSales: {month:0,prevYear:0,year:0},
   WayOfDelivery:[],
   TermsOfDelivery:[],
   NotyfileUsers:[],
   OrderSetting:{KalkylOrderPop:0,dokumentOrderPop:0,kunddataOrderPop:0,defaultProduktOrderTempid:0,OrderPrefix:"",kanDelOrder:0},
   OrderAffarfrom:[],
   EventsSetting:{defaultAccept:1,standardKPI:0,ApproveRights:0,ljudnotis:0,FilterKlendarJEvent:0,StandardBjudaIn:0,NyProspektIDialer:0,StandardSubject:"",TeamLinks:1 ,AvtalEventDialer:0,defualtType:0},
   LobbySetting:{VunnenFlag:0,BokatFlag:0,EsigneringFlag:0,OffertFlag:0,ProjektFlag:0,ForsaljningmotBudget:1,AnpassadLobby:1},
   KundDataHeader:[],
   KundDataALLHeader:[],
   KundSKundDataType:[],
   ALLKundDataType:[],
   ALLDialerKundDataType:[],
   KdLoading:true,
   ResponseKontoMsg:{},
   ResponseKundMsg:{},
   SavedAnRapport:[],
   OneDriveRoot: [],
   AfProspektTaskList: [],
   AfOrderTaskList: [],
   ImportSamples: [],
   ImportSamplesFlag: false,
   ImportSamplesMessage:{},
   SparadRapportV2:[],
   LoggRapportV2:[],
   UnderKontoKunder:[],
   KommentarResult:[],
   OrgnrTree:[],
   ArtiklarTBavdrag:[],
   isCheckedOk:2,
   isLoadingResult:false,
   AnvPage:1,
   ShowImportlogg:0,
   usingStorage:0,
   importType:"",
   ValidRestApiToken: null,
   fileMessage:"",
   FileCheck:false,
   FileCheckWarning:false,
   DashBoardValueOf:JSON.stringify([
    {DashBaord:1,Value:1,options:[],isUpdated:0},
    {DashBaord:2,Value:1,options:[],isUpdated:0},
    {DashBaord:3,Value:1,options:[],isUpdated:0},
    {DashBaord:4,Value:1,options:[],isUpdated:0},
    {DashBaord:5,Value:1,options:[],isUpdated:0},
    {DashBaord:6,Value:1,options:[],isUpdated:0},
  ]),
		ArticleTypes: [],
	ArticleTypesFreeInputs: [],
	ArticleTypesFreeInputsList: [],
	ArticleTypesFreeInputsListFilterOptions:[],
  AfSmsSettings:{},
  DailerUser:""
        };
      }
      case FETCH_ALL_CONTACT: {
        return { 
            ...state,
            message:""
        };
      }
      case FETCH_ACCOUNT_ERROR: {
        console.log(FETCH_ACCOUNT_ERROR,action)
        return { 
            ...state,
            message:"",
            ResponseKontoMsg:isUndefined(action.payload) ? {} : {msg:action.payload,type:"error",loading:false},
        };
      }
      case FETCH_ALL_CONTACT_SUCCESS: {
        return { ...state,
            accounts: action.payload,
            message:""
        };
      }
      case GET_AF_BUDGET_WORK_DAYS: {
        return {
          ...state,
          budgetAfWorkDays:action.payload,
        }
      }
      //Jack
      //ON_START_GET_AF_ORDER_TASK,ON_GET_AF_ORDER_TASK,ON_ERROR_GET_AF_ORDER_TASK,
      case ON_GET_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfOrderTaskList: action.payload.AfOrderTaskList
        }
      }
      case ON_START_GET_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state
        }
      }
      case ON_ERROR_GET_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfOrderTaskList: []
        }
      }
      case ON_UPDATE_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfOrderTaskList: action.payload.AfOrderTaskList
        }
      }
      case ON_START_UPDATE_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state
        }
      }
      case ON_ERROR_UPDATE_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfOrderTaskList: []
        }
      }
      //ON_START_UPDATE_AF_ORDER_TASK, ON_UPDATE_AF_ORDER_TASK, ON_ERROR_UPDATE_AF_ORDER_TASK,
      //ON_START_DELETE_AF_ORDER_TASK,ON_DELETE_AF_ORDER_TASK,ON_ERROR_DELETE_AF_ORDER_TASK,
      case ON_DELETE_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfOrderTaskList: action.payload.AfOrderTaskList
        }
      }
      case ON_START_DELETE_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state
        }
      }
      case ON_ERROR_DELETE_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state
        }
      }
      //
      case ON_START_NEW_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state
        }
      }
      case ON_NEW_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfOrderTaskList: action.payload.AfOrderTaskList
        }
      }
      case ON_ERROR_NEW_AF_ORDER_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
        }
      }
      //
      case ON_NEW_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfProspektTaskList: action.payload.AfProspektTaskList
        }
      }
      case ON_START_NEW_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state
        }
      }
      case ON_ERROR_NEW_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfProspektTaskList: []
        }
      }
      case ON_UPDATE_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfProspektTaskList: action.payload.AfProspektTaskList
        }
      }
      case ON_START_UPDATE_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state
        }
      }
      case ON_ERROR_UPDATE_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfProspektTaskList: []
        }
      }
      case ON_DELETE_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfProspektTaskList: action.payload.AfProspektTaskList
        }
      }
      case ON_START_DELETE_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state
        }
      }
      case ON_ERROR_DELETE_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state
        }
      }
      case ON_GET_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfProspektTaskList: action.payload.AfProspektTaskList
        }
      }
      case ON_START_GET_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state
        }
      }
      case ON_ERROR_GET_AF_PROSPEKT_TASK: {
        console.log("", action.payload) 
        return {
          ...state,
          AfProspektTaskList: []
        }
      }
      case ON_Update_STATUS_CONTACT: {
        return { ...state,
            accounts: action.payload.results,
            message: action.payload.message
        };
      }
      case ON_Update_ANSVARIG_CONTACT: {
        return { ...state,
            accounts: action.payload.results,
            message: action.payload.message
        };
      }
      case SET_KUNDER_FILTER: {
        console.log("SET_KUNDER_FILTER",action.payload)
        localStorage.removeItem("KunderFilter");
        localStorage.setItem("KunderFilter", JSON.stringify(action.payload));
        return { ...state,
          FilterOption: action.payload
        };
      }
      case ON_DELETE_CONTACT: {
        return { ...state,
            accounts: action.payload.results,
            message: action.payload.message
        };
      }
      //ON_START_GET_AFID_USERLIST,GET_AFID_USERLIST,ON_ERROR_GET_AFID_USERLIST,
      case ON_START_GET_AFID_USERLIST: {
        return { 
            ...state,
            message:""
        };
      }
      case ON_GET_AFID_USERLIST: {
        return { 
            ...state,
            Userlista:action.payload.Users,
            message:""
        };
      }
      case ON_ERROR_GET_AFID_USERLIST: {
        return { 
            ...state,
            message:""
        };
      }
      /*
      START_FETCH_CONTACT1_BY_ID,  ON_FETCH_CONTACT1_BY_ID_REST,
      START_FETCH_CONTACT2_BY_ID,  ON_FETCH_CONTACT2_BY_ID_REST,
      START_FETCH_CONTACT3_BY_ID,  ON_FETCH_CONTACT3_BY_ID_REST,
      */
      //
      case ON_FETCH_CONTACT1_BY_ID_REST: {
        return { ...state,
          AktivitetTags:action.payload.AktivitetTags,
          AktivaKunder:action.payload.AktivitaKund,
          AktivaKundKontakter:action.payload.AktivaKundKontakter,
         
          /*  
            
            OrderMail:action.payload.OrderEmail,
            ArandeMail:action.payload.ArandeMail,
           
            Utokning:action.payload.Utokning,
            OrderFreeInputsList:action.payload.OrderFreeInputsList,
            prospektAvtalFreeInputsList:action.payload.prospektAvtalFreeInputsList,
            OrderStatusList:isUndefined(action.payload.OrderStatusList)?[]:action.payload.OrderStatusList,
            ProjectStatusList:isUndefined(action.payload.ProjectStatusList)?[]:action.payload.ProjectStatusList,
            ArendeStatusList:isUndefined(action.payload.ArendeStatusList)?[]:action.payload.ArendeStatusList,
            ProjectFasList:isUndefined(action.payload.ProjectFasList)?[]:action.payload.ProjectFasList,
            RestAPITokenList:isUndefined(action.payload.RestAPITokenList)?[]:action.payload.RestAPITokenList,
            NejTackList:action.payload.NejTackList,
            EjSvarList:action.payload.EjSvarList,
            BortFallList:action.payload.BortFallList,
            BlackListT:action.payload.BlackListT,
            MinaTags:action.payload.MinaTags,
            AccountTags:action.payload.AccountTags,
            KanOlikaBL:action.payload.KanOlikaBL,
            */
            ResponseKontoMsg:{},
        };
      }
      case ON_FETCH_CONTACT2_BY_ID_REST: {
        return { ...state,
          OrderMail:action.payload.OrderEmail,
          ArandeMail:action.payload.ArandeMail,
          Utokning:action.payload.Utokning,
          OrderFreeInputsList:action.payload.OrderFreeInputsList,
          prospektAvtalFreeInputsList:action.payload.prospektAvtalFreeInputsList,
          OrderStatusList:isUndefined(action.payload.OrderStatusList)?state.OrderStatusList:action.payload.OrderStatusList,
          ProjectStatusList:isUndefined(action.payload.ProjectStatusList)?[]:action.payload.ProjectStatusList,
          ArendeStatusList:isUndefined(action.payload.ArendeStatusList)?[]:action.payload.ArendeStatusList,
          ProjectFasList:isUndefined(action.payload.ProjectFasList)?[]:action.payload.ProjectFasList,
          ProjectFasViewList:isUndefined(action.payload.ProjectFasViewList)?[]:action.payload.ProjectFasViewList,
          RestAPITokenList:isUndefined(action.payload.RestAPITokenList)?[]:action.payload.RestAPITokenList,
          KundPrisListor: isUndefined(action.payload.KundPrisListor)?[]:action.payload.KundPrisListor,
          /*
            NejTackList:action.payload.NejTackList,
            EjSvarList:action.payload.EjSvarList,
            BortFallList:action.payload.BortFallList,
            BlackListT:action.payload.BlackListT,
            MinaTags:action.payload.MinaTags,
            AccountTags:action.payload.AccountTags,
            KanOlikaBL:action.payload.KanOlikaBL,
            */
            ResponseKontoMsg:{},
        };
      }
      case ON_FETCH_CONTACT3_BY_ID_REST: {
        return { ...state,        
            NejTackList:action.payload.NejTackList,
            EjSvarList:action.payload.EjSvarList,
            BortFallList:action.payload.BortFallList,
            BlackListT:action.payload.BlackListT,
            MinaTags:action.payload.MinaTags,
            AccountTags:action.payload.AccountTags,
            KanOlikaBL:action.payload.KanOlikaBL,
            ResponseKontoMsg:{},
        };
      }
      case START_FETCH_CONTACT1_BY_ID: {
        return { 
            ...state,
            message:""
        };
      }
      case START_FETCH_CONTACT2_BY_ID: {
        return { 
            ...state,
            message:""
        };
      }
      case START_FETCH_CONTACT3_BY_ID: {
        return { 
            ...state,
            message:""
        };
      }

      //START_FETCH_CONTACT_BY_ID,ON_FETCH_CONTACT_BY_ID_REST,FETCH_ACCOUNT_REST_ERROR,
      case START_FETCH_CONTACT_BY_ID: {
        return { 
            ...state,
            message:""
        };
      }
      case FETCH_ACCOUNT_REST_ERROR: {
        return { 
            ...state,
            message:""
        };
      }
      case ON_FETCH_CONTACT_BY_ID_REST: {
        return { ...state,
            KundSKundData:[],
            Kontorlista:action.payload.Offices,
            Teamslista:action.payload.Teamslista,
            AvtalTyp:action.payload.AvtalTyp,
            ArandeList:action.payload.ArandeList,
            LeventorList:action.payload.LeventorList,
            OrtList:action.payload.OrtList,
            MinaKedja:action.payload.MinaKedja,
            Kalkyllist:action.payload.Kalkyllist,
            // Schablonlist:action.payload.Schablonlist,
            Userlista:action.payload.Users,
            Flags:action.payload.Flag,
            HasOutlook:action.payload.HasOutlook,
            MyOfficeType:action.payload.MyOfficeType,
            Antal:action.payload.Antal,
            AntalLicens:action.payload.AntalLicens,
            isIamChild:action.payload.isIamChild,
            
            Schablonlist:action.payload.Schablonlist,
            SchablonPresetList:action.payload.SchablonPresetList,
            KanSeFordonData:action.payload.KanSeFordonData,
            ProspektFaslist:action.payload.ProspektFaslist,
            Esignering:"",
            FortNox:"",
            Dailer:"",
            /*KanSeFordonData:action.payload.KanSeFordonData,
            ProspektFaslist:action.payload.ProspektFaslist,
            Esignering:"",
            FortNox:"",
            Dailer:"",
            OrderMail:action.payload.OrderEmail,
            ArandeMail:action.payload.ArandeMail,
            
            AktivitetTags:action.payload.AktivitetTags,
            AktivaKunder:action.payload.AktivitaKund,
            AktivaKundKontakter:action.payload.AktivaKundKontakter,
            Utokning:action.payload.Utokning,
            OrderFreeInputsList:action.payload.OrderFreeInputsList,
            prospektAvtalFreeInputsList:action.payload.prospektAvtalFreeInputsList,
            OrderStatusList:isUndefined(action.payload.OrderStatusList)?[]:action.payload.OrderStatusList,
            ProjectStatusList:isUndefined(action.payload.ProjectStatusList)?[]:action.payload.ProjectStatusList,
            ArendeStatusList:isUndefined(action.payload.ArendeStatusList)?[]:action.payload.ArendeStatusList,
            ProjectFasList:isUndefined(action.payload.ProjectFasList)?[]:action.payload.ProjectFasList,
            RestAPITokenList:isUndefined(action.payload.RestAPITokenList)?[]:action.payload.RestAPITokenList,
            NejTackList:action.payload.NejTackList,
            
            EjSvarList:action.payload.EjSvarList,
            BortFallList:action.payload.BortFallList,
            BlackListT:action.payload.BlackListT,            
            MinaTags:action.payload.MinaTags,
            AccountTags:action.payload.AccountTags,
            KanOlikaBL:action.payload.KanOlikaBL,
            */
            ResponseKontoMsg:{},
        };
      }
      case ON_FETCH_CONTACT_BY_ID: {
        return { ...state,
            currentAccount: action.payload.Account[0],
            Flags:action.payload.Flag,
            MyOfficeType:action.payload.MyOfficeType,
            isIamChild:action.payload.isIamChild,
            MinaKedja:action.payload.MinaKedja,
            ResponseKontoMsg:{},
            AnvPage:1
        };
      }
      case ON_SAVE_NEW_OFFICE: {
        console.log(action)
        return { ...state,
            Kontorlista:action.payload.Offices,
            ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        };
      }
      case ON_SAVE_NEW_TEAM: {
        console.log(action)
        return { ...state,
            Teamslista:action.payload.Teams,
            ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        };
      }
      //FETCH_ALL_CONTACT_FLAGS,ON_FETCH_CONTACT_FLAGS_BY_ID,FETCH_ACCOUNT_FLAGS_ERROR,
      case ON_FETCH_CONTACT_FLAGS_BY_ID: {
        return { ...state,
            Flags:action.payload.Flag
        };
      }
      case FETCH_ALL_CONTACT_FLAGS: {
        return { ...state
        };
      }
      case FETCH_ACCOUNT_FLAGS_ERROR: {
        return { ...state
        };
      }
      //Flags
      case ON_DELETE_OFFICE: {
        console.log(action)
        return { ...state,
            Kontorlista:action.payload.Offices,
            ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        };
      }
      case ON_DELETE_TEAM: {
        console.log(action)
        return { ...state,
          Teamslista:action.payload.Teams,
            ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        };
      }
      case ON_EDIT_OFFICE: {
        console.log("ON_EDIT_OFFICE",action)
        return { ...state,
            Kontorlista:action.payload.Offices,
            ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        };
      }
      case ON_EDIT_TEAM: {
        console.log("ON_EDIT_TEAM",action)
        return { ...state,
          Teamslista:action.payload.Teams,
            ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        };
      }
      case ON_SAVE_NEW_USER: {
        console.log("ON_SAVE_NEW_USER",action)
        return { ...state,
          ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
          Userlista:action.payload.Users,
          ToSetting:false
        };
      }
      case ON_START_EDIT_USER_BASIC: {
        console.log("ON_EDIT_USER_BASIC",action)
        return { ...state,
            message:"",
            ResponseKontoMsg:{}
        };
      }
      case ON_EDIT_USER_BASIC: {
        console.log("ON_EDIT_USER_BASIC",action)
        return { ...state,
            Userlista:action.payload.Users,
            ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        };
      }
     case ON_ERROR_SEARCH_KUND:{
      console.log("ON_ERROR_SEARCH_KUND",action)
      return { ...state,
        searchedKund:"",
        isSearchLoading:false,
        message:action.payload.message
      };
     }
     case ON_START_SEARCH_KUND:{
      console.log("ON_START_SEARCH_KUND",action)
      return { ...state,
        searchedKund:"",
        message:"",
        isSearchLoading:true
      };
     }
     case ON_SEARCH_KUND:{
      console.log("ON_SEARCH_KUND",action)
      return { ...state,
        searchedKund:action.payload.searchKund,
        message:"",
        isSearchLoading:false
      };
     }
    //
    case ON_START_SEARCH_KUND_BASIC:{
      console.log("ON_START_SEARCH_KUND_BASIC",action)
      return { ...state,
        searchedKundBasic:"",
        IsloadingSearch:true,
        message:""
      };
     }
    case ON_SEARCH_KUND_BASIC:{
      console.log("ON_SEARCH_KUND_BASIC",action)
      return { ...state,
        searchedKundBasic:action.payload.searchKund,
        IsloadingSearch:false,
        message:""
      };
     }
    case ON_ERROR_SEARCH_KUND_BASIC:{
      console.log("ON_ERROR_SEARCH_KUND_BASIC",action)
      return { ...state,
        searchedKundBasic:"",
        IsloadingSearch:false,
        message:""
      };
     }
  
    // ON_START_FETCH_KUND_BASIC_NOMESSAGE,ON_FETCH_KUND_BASIC_NOMESSAGE,ON_START_FETCH_KUND_BASIC_REST
    case ON_START_FETCH_KUND_BASIC_REST:{
      console.log("ON_START_FETCH_KUND_BASIC_REST",action)
      return {
        ...state,
      }
    }
    case ON_START_FETCH_KUND_BASIC_NOMESSAGE:{
      console.log("ON_START_FETCH_KUND_BASIC_NOMESSAGE",action)
      return {
        ...state,
        AntalStatistikOrder:{month:0,prevYear:0,year:0},
        AntalStatistikMote: {month:0,prevYear:0,year:0},
        AntalStatistikAktivitet: {month:0,prevYear:0,year:0},
        AntalStatistikOffert: {month:0,prevYear:0,year:0},
        AntalSales: {month:0,prevYear:0,year:0},
        AntalLopandeIntakt: 0,
        AntalOrderTyp: [],
        handelseList:[],
        currentKund:"",
        message:""
      }
    }
    case ON_FETCH_KUND_BASIC_NOMESSAGE:{
      console.log("ON_FETCH_KUND_BASIC_NOMESSAGE",action)
      return {
        ...state,
        currentKund:action.payload.CurrentKund,
        KontakterList:action.payload.CurrentKund.Kontakter ? action.payload.CurrentKund.Kontakter : [],
        isPersonlig:action.payload.CurrentKund.isPersonlig,
        FortNoxUppgifter:{},
        KundFortnoxFak: [],
        CurrentFaktura: {},
        message:"",
      }
    }
    //
    case ON_START_FETCH_KUND_BASIC:{
      console.log("ON_START_FETCH_KUND_BASIC",action)
      return {
        ...state,
        AntalStatistikOrder:{month:0,prevYear:0,year:0},
        AntalStatistikMote: {month:0,prevYear:0,year:0},
        AntalStatistikAktivitet: {month:0,prevYear:0,year:0},
        AntalStatistikOffert: {month:0,prevYear:0,year:0},
        AntalSales: {month:0,prevYear:0,year:0},
        AntalLopandeIntakt: 0,
        AntalOrderTyp: [],
        handelseList:[],
        currentKund:"",
        ResponseKundMsg:{msg:translate("Action.Customer.Client.fetchting"),type:"info",loading:true},
        message:""
      }
    }
    case ON_ERROR_FETCH_KUND_BASIC:{
      console.log("ON_ERROR_FETCH_KUND_BASIC",action)
      return {
        ...state,
        ResponseKundMsg:action.payload.error === "Not_Found"?"":{msg:translate("Error.Customer.Client.fetcht"),type:"error",loading:false},
        currentKund:"",
        FortNoxUppgifter:{},
        KundFortnoxFak: [],
        CurrentFaktura: {},
        message: translate("Error.Customer")
      }
    }
    case ON_SET_ZERO_FORTNOX_UPPGIFTER:{
      return {
        ...state,
        FortNoxUppgifter:{},
      }
    }
    case ON_FETCH_KUND_BASIC:{
      console.log("ON_FETCH_KUND_BASIC",action)
      return {
        ...state,
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        currentKund:action.payload.CurrentKund,
        KontakterList:action.payload.CurrentKund.Kontakter ? action.payload.CurrentKund.Kontakter : [],
        isPersonlig:action.payload.CurrentKund.isPersonlig,
        FortNoxUppgifter:{},
        KundFortnoxFak: [],
        CurrentFaktura: {},
        message:"",
      }
    }
    case ON_START_EDIT_KUND_INFO:{
      console.log("ON_START_AKTIVE_KUND",action)
      return {
        ...state,
        searchedKund:"",
        ResponseKundMsg:{msg:translate("Action.Customer.Client.updating"),type:"info",loading:true},
        message:""
      }
    }
    case ON_ERROR_EDIT_KUND_INFO:{
      console.log("ON_ERROR_EDIT_KUND_INFO",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Customer.Client.updating",`Error: ${action.payload}`,{item:action.payload}),type:"error",loading:false},
        message: ""
      }
    }
    case ON_EDIT_KUND_INFO:{
      console.log("ON_EDIT_KUND_INFO",action)
      return {
        ...state,
        currentKund:{
          ...state.currentKund,
          Kund:action.payload.CurrentKund.Kund,
          Ansvarig:action.payload.CurrentKund.Ansvarig,
        },
        KontakterList:action.payload.CurrentKund.Kontakter,
        //AktivaKunder:action.payload.AktivaKunder,
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        message:"",
        searchedKund:""
      }
    }
//ON_START_EDIT_KUND_ITESCO_INFO, ON_EDIT_KUND_ITESCO_INFO, ON_ERROR_EDIT_KUND_ITESCO_INFO,
case ON_START_EDIT_KUND_ITESCO_INFO:{
  console.log("ON_START_EDIT_KUND_ITESCO_INFO",action)
  return {
    ...state,
    searchedKund:"",
    ResponseKundMsg:{msg:translate("Action.Customer.Client.updating"),type:"info",loading:true},
    message:""
  }
}
case ON_ERROR_EDIT_KUND_ITESCO_INFO:{
  console.log("ON_ERROR_EDIT_KUND_ITESCO_INFO",action)
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Error.Customer.Client.update.Valitive"),type:"error",loading:false},
    message:""
  }
}
case ON_EDIT_KUND_ITESCO_INFO:{
  console.log("ON_EDIT_KUND_ITESCO_INFO",action)
  return {
    ...state,
    currentKund:action.payload.CurrentKund,
    KontakterList:action.payload.CurrentKund.Kontakter,
    ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
    message:"",
    searchedKund:""
  }
}
//
    case ON_START_AKTIVE_KUND:{
      console.log("ON_START_AKTIVE_KUND",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Action.Customer.Client.Activing"),type:"info",loading:true},
        message:"",
        searchedKund:""
      }
    }
    case ON_START_INAKTIVE_KUND:{
      console.log("ON_START_AKTIVE_KUND",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Action.Customer.Client.Inactiving"),type:"info",loading:true},
        message:"",
        searchedKund:""
      }
    }
    case ON_ERROR_AKTIVE_KUND:{
      console.log("ON_ERROR_AKTIVE_KUND",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Customer.Client.Active"),type:"error",loading:false},
        message:""
      }
    }
    
    case ON_INAKTIVE_KUND:{
      console.log("ON_AKTIVE_KUND",action)
      return {
        ...state,
        currentKund:action.payload.CurrentKund,
        KontakterList:action.payload.CurrentKund.Kontakter,
        ResponseKundMsg:{msg:action.payload.message,type:"warning",loading:false},
        message:"",
        searchedKund:""
      }
    }
    case ON_AKTIVE_KUND:{
      console.log("ON_AKTIVE_KUND",action)
      return {
        ...state,
        currentKund:action.payload.CurrentKund,
        KontakterList:action.payload.CurrentKund.Kontakter,
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        message:"",
        searchedKund:""
      }
    }
    case ON_DELETE_KUND_ANSVARIG:{
      console.log("ON_DELETE_KUND_ANSVARIG",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:parseInt(action.payload.userRole) > 1?{msg:action.payload.message,type:"warning",loading:false}:{},
        currentKund:action.payload.CurrentKund,
        KontakterList:action.payload.CurrentKund.Kontakter,
      }
    }
    case ON_START_DELETE_KUND_ANSVARIG:{
      console.log("ON_START_DELETE_KUND_ANSVARIG",action)
      return {
        ...state,
        ResponseKundMsg:{},
        message:""
      }
    }
    case ON_ERROR_DELETE_KUND_ANSVARIG:{
      console.log("ON_ERROR_DELETE_KUND_ANSVARIG",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Customer.Client.Delete.responsible"),type:"error",loading:false},
        message:""
      }
    }
    case ON_NEW_KUND_ANSVARIG:{
      console.log("ON_NEW_KUND_ANSVARIG",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        currentKund:action.payload.CurrentKund,
        KontakterList:action.payload.CurrentKund.Kontakter,
      }
    }
    case ON_START_NEW_KUND_ANSVARIG:{
      console.log("ON_START_NEW_KUND_ANSVARIG",action)
      return {
        ...state,
        ResponseKundMsg:{},
        message:""
      }
    }
    case ON_ERROR_NEW_KUND_ANSVARIG:{
      console.log("ON_ERROR_NEW_KUND_ANSVARIG",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Customer.Client.Add.responsible"),type:"error",loading:false},
        message:""
      }
    }
    case ON_DELETE_KUND_TAG:{
      console.log("ON_DELETE_KUND_TAG",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:action.payload.message,type:"warning",loading:false},
        currentKund:action.payload.CurrentKund,
        KontakterList:action.payload.CurrentKund.Kontakter,
      }
    }
    case ON_START_DELETE_KUND_TAG:{
      console.log("ON_START_DELETE_KUND_TAG",action)
      return {
        ...state,
        ResponseKundMsg:{},
        message:""
      }
    }
    case ON_ERROR_DELETE_KUND_TAG:{
      console.log("ON_ERROR_DELETE_KUND_TAG",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Customer.Client.Delete.Tag"),type:"error",loading:false},
        message:""
      }
    }
    case ON_NEW_KUND_TAG:{
      console.log("ON_NEW_KUND_TAG",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        currentKund:action.payload.CurrentKund,
        KontakterList:action.payload.CurrentKund.Kontakter,
      }
    }
    case ON_START_NEW_KUND_TAG:{
      console.log("ON_START_NEW_KUND_TAG",action)
      return {
        ...state,
        ResponseKundMsg:{},
        message:""
      }
    }
    case ON_ERROR_NEW_KUND_TAG:{
      console.log("ON_ERROR_NEW_KUND_TAG",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Customer.Client.Add.Tag"),type:"error",loading:false},
        message:""
      }
    }

    case ON_START_CREATE_HANDELSE:{
      console.log("ON_START_CREATE_HANDELSE",action)
      return {
        ...state,
        isLoading:true,
        HisLoading:true,
        message:"",
        ResponseKundMsg:{},
        handelse:""
      }
    }
    case ON_CREATE_HANDELSE:{
      console.log("ON_CREATE_HANDELSE",action)
      return {
        ...state,
        isLoading:false,
        HisLoading:false,
        message:"",
        ResponseKundMsg:{msg:translate("Action.Customer.Client.notation.saving"),type:"success",loading:false},
        handelseList:action.payload.handelser
      }
    }
    case ON_ERROR_CREATE_HANDELSE:{
      console.log("ON_ERROR_NEW_KUND_TAG",action)
      return {
        ...state,
        isLoading:false,
        HisLoading:false,
        message:"",
        ResponseKundMsg:{msg:translate("Error.Customer.Client.notation.save"),type:"error",loading:false},
        handelse:""
      }
    }
    
    case ON_START_FLAGA_HANDELSE:{
      console.log("ON_START_FLAGA_HANDELSE",action)
      return {
        ...state,
        isLoading:true,
        ResponseKundMsg:{},
        HisLoading:true,
        message:"",
        handelse:""
      }
    }
    case ON_FLAGA_HANDELSE:{
      console.log("ON_FLAGA_HANDELSE",action)
      return {
        ...state,
        isLoading:false,
        HisLoading:false,
        message:"",
        ResponseKundMsg:{msg:translate("Action.Customer.Client.notation.Flag"),type:"success",loading:false},
        handelseList:action.payload.handelser
      }
    }
    case ON_ERROR_FLAGA_HANDELSE:{
      console.log("ON_ERROR_FLAGA_HANDELSE",action)
      return {
        ...state,
        isLoading:false,
        HisLoading:false,
        message:"",
        ResponseKundMsg:{msg:translate("Error.Customer.Client.notation.Flag"),type:"error",loading:false},
        handelse:""
      }
    }
//ON_START_FETCH_KUND_HANDELSER_DIALERD,   ON_FETCH_KUND_HANDELSER_DIALERD,   ON_ERROR_FETCH_KUND_HANDELSER_DIALERD,
case ON_START_FETCH_KUND_HANDELSER_DIALERD:{
  console.log("ON_START_FETCH_KUND_HANDELSER_DIALERD")
  return {
    ...state,
  }
}
case ON_ERROR_FETCH_KUND_HANDELSER_DIALERD:{
  console.log("ON_ERROR_FETCH_KUND_HANDELSER_DIALERD")
  return {
    ...state,
    HisLoading:false,
    message:""
  }
}
case ON_FETCH_KUND_HANDELSER_DIALERD:{
  console.log("ON_FETCH_KUND_HANDELSER_DIALERD",action)
  //
  let handelseList1 = state.handelseList.filter(item=>{return parseInt(item.type) !== 6 && parseInt(item.type) !== 102 })
  //
  let handelseList2 = handelseList1.concat(action.payload.handelser)
  console.log(handelseList2,"ON_FETCH_KUND_HANDELSER_DIALERD")
  return {
    ...state,
    HisLoading:false,
    handelseList:handelseList2
  }
}
    case ON_START_FETCH_KUND_HANDELSER:{
      console.log("ON_START_FETCH_KUND_HANDELSER",action)
      return {
        ...state,
        handelseList:[],
        HisLoading:true
      }
    }
    case ON_ERROR_FETCH_KUND_HANDELSER:{
      console.log("ON_ERROR_FETCH_KUND_HANDELSER",action)
      return {
        ...state,
        HisLoading:false,
        message: translate("Error.Customer")
      }
    }
    case ON_FETCH_KUND_HANDELSER:{
      console.log("ON_FETCH_KUND_HANDELSER",action)
      return {
        ...state,
        HisLoading:false,
        handelseList:action.payload.handelser
      }
    }
    case ON_START_FETCH_CURRENT_HANDELSE:{
      console.log("ON_START_FETCH_CURRENT_HANDELSE",action)
      return {
        ...state,
        currentHandelse:"",
        HandelseFiler:"",
        handelseLog:"",
        CHisLoading:true
      }
    }
    case ON_FETCH_CURRENT_HANDELSE:{
      console.log("ON_FETCH_CURRENT_HANDELSE",action)
      return {
        ...state,
        currentHandelse:action.payload.handelse,
        HandelseFiler:action.payload.Files,
        handelseLog:action.payload.Log,
        CHisLoading:false
      }
    }
    case ON_ERROR_FETCH_CURRENT_HANDELSE:{
      console.log("ON_ERROR_FETCH_CURRENT_HANDELSE",action)
      return {
        ...state,
        currentHandelse:"",
        HandelseFiler:"",
        handelseLog:"",
        message: translate("Error.Customer"),
        CHisLoading:false
      }
    }

    case ON_START_FETCH_CURRENT_HANDELSE_NEW_TEXT:{
      console.log("ON_START_FETCH_CURRENT_HANDELSE_NEW_TEXT",action)
      return {
        ...state,
        ResponseKundMsg:{},
        CHisLoading:true
      }
    }
    case ON_FETCH_CURRENT_HANDELSE_NEW_TEXT:{
      console.log("ON_FETCH_CURRENT_HANDELSE_NEW_TEXT",action)
      return {
        ...state,
        handelseLog:action.payload.Log,
        ResponseKontoMsg:{msg:translate("Action.Customer.Client.notation.save"),type:"success",loading:false},
        CHisLoading:false
      }
    }
    case ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT:{
      console.log("ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Customer.Client.notation.save1"),type:"error",loading:false},
        message:"",
        CHisLoading:false
      }
    }
    
    case ON_ERROR_DELETE_CURRENT_HANDELSE:{
      console.log("ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Customer.Client.notation.delete"),type:"error",loading:false},
        message:"",
        CHisLoading:false,
        HisLoading:false
      }
    }
    case ON_DELETE_CURRENT_HANDELSE:{
      console.log("ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Action.Customer.Client.notation.delete"),type:"warning",loading:false},
        handelseList:action.payload.handelser,
        CHisLoading:false,
        HisLoading:false
      }
    }
    case ON_START_DELETE_CURRENT_HANDELSE:{
      console.log("ON_ERROR_FETCH_CURRENT_HANDELSE_NEW_TEXT",action)
      return {
        ...state,
        ResponseKundMsg:{},
        message:"",
        CHisLoading:true,
        HisLoading:true
      }
    }


    case ON_START_NEW_KUND_KONTAKT:{
      console.log("ON_START_NEW_KUND_KONTAKT",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Action.Customer.Client.Contact.Creating"),type:"info",loading:true},
        message:"",
        NKLoading:false
      }
    }
    case ON_NEW_KUND_KONTAKT:{
      console.log("ON_NEW_KUND_KONTAKT",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        NKLoading:false,
        currentKund:{...state.currentKund,Kontakter:action.payload.Kontakter},
        KontakterList: action.payload.Kontakter,
      }
    }
    case ON_ERROR_NEW_KUND_KONTAKT:{
      console.log("ON_ERROR_NEW_KUND_KONTAKT",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Error.Customer.Client.Contact.Create"),type:"error",loading:false},
        NKLoading:false
      }
    }
    case ON_START_NEW_KUND:{
      console.log("ON_START_NEW_KUND",action)
      return {
        ...state,
        message:"",
        isLoading:true
      }
    }
    case ON_NEW_KUND:{
      console.log("ON_NEW_KUND",action)
      return {
        ...state,
        message: translate("Action.Customer.save"),
        currentKund:{},
        isLoading:true
      }
    }
    case ON_ERROR_NEW_KUND:{
      console.log("ON_ERROR_NEW_KUND",action)
      return {
        ...state,
        message: translate("Error.Customer"),
        isLoading:false
      }
    }
    case ON_START_EDIT_KUND_KONTAKT:{
      console.log("ON_START_EDIT_KUND_KONTAKT",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{},
        NKLoading:false
      }
    }
    case ON_EDIT_KUND_KONTAKT:{
      console.log("ON_EDIT_KUND_KONTAKT",action)
      return {
        ...state,
        message:"",
        NKLoading:false,
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        currentKund:{...state.currentKund,Kontakter:action.payload.Kontakter},
        KontakterList: action.payload.Kontakter,
      }
    }
    case ON_ERROR_EDIT_KUND_KONTAKT:{
      console.log("ON_ERROR_EDIT_KUND_KONTAKT",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Error.Customer.Client.Contact.Edit"),type:"error",loading:false},
        NKLoading:false
      }
    }
    case ON_START_DELETE_KUND_KONTAKT:{
      console.log("ON_START_DELETE_KUND_KONTAKT",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Action.Customer.Client.Contact.deleting"),type:"info",loading:true},
        NKLoading:false
      }
    }
    case ON_DELETE_KUND_KONTAKT:{
      console.log("ON_DELETE_KUND_KONTAKT",action)
      return {
        ...state,
        message:"",
        NKLoading:false,
        ResponseKundMsg:{msg:action.payload.message,type:"warning",loading:false},
        currentKund:{...state.currentKund,Kontakter:action.payload.Kontakter},
        KontakterList: action.payload.Kontakter,
      }
    }
    case ON_ERROR_DELETE_KUND_KONTAKT:{
      console.log("ON_ERROR_DELETE_KUND_KONTAKT",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Error.Customer.Client.Contact.delete"),type:"error",loading:false},
        NKLoading:false
      }
    }
    case ON_START_NEW_LEVERANTOR:{
      console.log("ON_START_NEW_LEVERANTOR",action)
      return {
        ...state,
        ATLoading:true,
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_ERROR_NEW_LEVERANTOR:{
      console.log("ON_ERROR_NEW_LEVERANTOR",action)
      return {
        ...state,
        ATLoading:false,
        ResponseKontoMsg:{msg:translate("Error.Customer.Supplier.add"),type:"error",loading:false},
        message:""
      }
    }
    case ON_NEW_LEVERANTOR:{
      console.log("ON_NEW_LEVERANTOR",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        ATLoading:false,
        AvtalTyp:action.payload.AvtalTyp
      }
    }
    case ON_START_DELETE_LEVERANTOR:{
      console.log("ON_START_DELETE_LEVERANTOR",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        ATLoading:true,
        message:""
      }
    }
    case ON_ERROR_DELETE_LEVERANTOR:{
      console.log("ON_ERROR_DELETE_LEVERANTOR",action)
      return {
        ...state,
        ATLoading:false,
        ResponseKontoMsg:{msg:translate("Error.Customer.Supplier.delete"),type:"error",loading:false},
        message:""
      }
    }
    case ON_DELETE_LEVERANTOR:{
      console.log("ON_DELETE_LEVERANTOR",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        ATLoading:false,
        AvtalTyp:action.payload.AvtalTyp
      }
    }
    case ON_START_NEW_TYPE:{
      console.log("ON_START_NEW_TYPE",action)
      return {
        ...state,
        ATLoading:true,
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_ERROR_NEW_TYPE:{
      console.log("ON_ERROR_NEW_TYPE",action)
      return {
        ...state,
        ATLoading:false,
        ResponseKontoMsg:{msg:translate("Error.Customer.type.add"),type:"error",loading:false},
        message:""
      }
    }
    case ON_NEW_TYPE:{
      console.log("ON_NEW_TYPE",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        AvtalTyp:action.payload.AvtalTyp,
        ATLoading:false
      }
    }
    case ON_START_DELETE_TYPE:{
      console.log("ON_START_DELETE_TYPE",action)
      return {
        ...state,
        ATLoading:true,
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_ERROR_DELETE_TYPE:{
      console.log("ON_ERROR_DELETE_TYPE",action)
      return {
        ...state,
        ATLoading:false,
        ResponseKontoMsg:{msg:translate("Error.Customer.type.delete"),type:"error",loading:false},
        message:""
      }
    }
    case ON_DELETE_TYPE:{
      console.log("ON_DELETE_TYPE",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        AvtalTyp:action.payload.AvtalTyp,
        ATLoading:false
      }
    }
    case ON_START_UPDATE_TYPE:{
      console.log("ON_START_DELETE_TYPE",action)
      return {
        ...state,
        ATLoading:true,
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_ERROR_UPDATE_TYPE:{
      console.log("ON_ERROR_DELETE_TYPE",action)
      return {
        ...state,
        ATLoading:false,
        ResponseKontoMsg:{msg:translate("Error.Customer.type.update"),type:"error",loading:false},
        message:""
      }
    }
    case ON_UPDATE_TYPE:{
      console.log("ON_UPDATE_TYPE",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        AvtalTyp:action.payload.AvtalTyp,
        ATLoading:false
      }
    }
    case ON_START_NEW_KALKYL:{
      console.log("ON_START_NEW_KALKYL",action)
      return {
        ...state,
        message:"",
        Kalkyllist:{},
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_NEW_KALKYL:{
      console.log("ON_NEW_KALKYL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        Kalkyllist:action.payload.Kalkyllist,
        ATLoading:false
      }
    }
    case ON_ERROR_NEW_KALKYL:{
      console.log("ON_ERROR_NEW_KALKYL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.Calc.Add"),type:"error",loading:false},
        ATLoading:false
      }
    }
    case ON_START_NEW_SCHABLON:{
      console.log("ON_START_NEW_SCHABLON",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        // Schablonlist:{},
        ATLoading:true
      }
    }
    case ON_NEW_SCHABLON:{
      console.log("ON_NEW_SCHABLON",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        Schablonlist:action.payload.Schablonlist,
        ATLoading:false
      }
    }
    case ON_ERROR_NEW_SCHABLON:{
      console.log("ON_ERROR_NEW_SCHABLON",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.SCHABLON.Add"),type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_GET_SCHABLON:{
      console.log("ON_START_GET_SCHABLON",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        // Schablonlist:{},
        ATLoading:true
      }
    }
    case ON_GET_SCHABLON:{
      console.log("ON_GET_SCHABLON",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        Schablonlist:action.payload.Schablonlist,
        ATLoading:false
      }
    }
    case ON_ERROR_GET_SCHABLON:{
      console.log("ON_ERROR_GET_SCHABLON",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_NEW_SCHABLON_PRESET:{
      console.log("ON_START_NEW_SCHABLON_PRESET",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        // Schablonlist:{},
        ATLoading:true
      }
    }
    case ON_NEW_SCHABLON_PRESET:{
      console.log("ON_NEW_SCHABLON_PRESET",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        SchablonPresetList:action.payload.SchablonPresetList,
        Schablonlist:action.payload.Schablonlist,
        ATLoading:false
      }
    }
    case ON_ERROR_NEW_SCHABLON_PRESET:{
      console.log("ON_ERROR_NEW_SCHABLON_PRESET",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.SCHABLON.PRESET"),type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_NEW_UTOKNING:{
      console.log("ON_START_NEW_UTOKNING",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        // Utokning:[],
        ATLoading:true
      }
    }
    case ON_NEW_UTOKNING:{
      console.log("ON_NEW_UTOKNING",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        message:"",
        Utokning:action.payload.Utokning,
        CurrentObjekt:action.payload.CurrentObjekt,
        ATLoading:false
      }
    }
    case ON_ERROR_NEW_UTOKNING:{
      console.log("ON_ERROR_NEW_UTOKNING",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.UTOKNING.Add"),type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_NEW_FALT:{
      console.log("ON_START_NEW_FALT",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_NEW_FALT:{
      console.log("ON_NEW_FALT",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        CurrentObjekt:action.payload.CurrentObjekt,
        ATLoading:false
      }
    }
    case ON_ERROR_NEW_FALT:{
      console.log("ON_ERROR_NEW_FALT",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }

    
    case ON_START_DELETE_KALK_TEMP_ROW : {
      console.log("ON_START_DELETE_KALK_TEMP_ROW", action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_DELETE_KALK_TEMP_ROW : {
      console.log("ON_DELETE_KALK_TEMP_ROW", action)
      return {
        ...state,
        message:"",
        CurrentObjektKalkTemp:action.payload.CurrentObjektKalkTemp,
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      }
    }
    case ON_ERROR_DELETE_KALK_TEMP_ROW : {
      console.log("ON_ERROR_DELETE_KALK_TEMP_ROW", action)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_ADD_KALK_TEMP_ROW : {
      console.log("ON_START_ADD_KALK_TEMP_ROW", action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_ADD_KALK_TEMP_ROW : {
      console.log("ON_ADD_KALK_TEMP_ROW", action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        CurrentObjektKalkTemp:action.payload.CurrentObjektKalkTemp,
        ATLoading:false
      }
    }
    case ON_ERROR_ADD_KALK_TEMP_ROW : {
      console.log("ON_ERROR_ADD_KALK_TEMP_ROW", action)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_UPDATE_KALK_TEMP_ROW : {
      console.log("ON_START_UPDATE_KALK_TEMP_ROW", action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_UPDATE_KALK_TEMP_ROW : {
      console.log("ON_UPDATE_KALK_TEMP_ROW", action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        CurrentObjektKalkTemp:action.payload.CurrentObjektKalkTemp,
        ATLoading:false
      }
    }
    case ON_ERROR_UPDATE_KALK_TEMP_ROW : {
      console.log("ON_ERROR_UPDATE_KALK_TEMP_ROW", action)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }


    case ON_START_GET_UTOKNING:{
      console.log("ON_START_GET_UTOKNING",action)
      return {
        ...state,
        message:"",
        ATLoading:false
      }
    }
    case ON_GET_UTOKNING:{
      console.log("ON_GET_UTOKNING",action)
      return {
        ...state,
        message:"",
        CurrentObjekt:action.payload.CurrentObjekt,
        CurrentObjektKalkTemp:action.payload.CurrentObjektKalkTemp,
        ATLoading:false
      }
    }
    case ON_ERROR_GET_UTOKNING:{
      console.log("ON_ERROR_GET_UTOKNING",action)
      return {
        ...state,
        message: translate("Error.Customer"),
        ATLoading:false
      }
    }
    case ON_START_FETCH_UTOKNING_RAPPORT:{
      console.log("ON_START_FETCH_UTOKNING_RAPPORT",action)
      return {
        ...state,
        FFRLoading:true,
      }
    }
    case ON_FETCH_UTOKNING_RAPPORT:{
      console.log("ON_FETCH_UTOKNING_RAPPORT",action)
      return {
        ...state,
        FFRLoading:false
      }
    }
    case ON_ERROR_FETCH_UTOKNING_RAPPORT:{
      console.log("ON_ERROR_FETCH_UTOKNING_RAPPORT",action)
      return {
        ...state,
        message: translate("Error.Customer"),
        FFRLoading:false
      }
    }
    case ON_START_GET_UTOKNING_LOGG:{
      console.log("ON_START_GET_UTOKNING_LOGG",action)
      return {
        ...state,
        message:"",
        ATLoading:false
      }
    }
    case ON_GET_UTOKNING_LOGG:{
      console.log("ON_GET_UTOKNING_LOGG",action)
      return {
        ...state,
        message:"",
        CurrentObjektLogg:action.payload,
        ATLoading:false
      }
    }
    case ON_ERROR_GET_UTOKNING_LOGG:{
      console.log("ON_ERROR_GET_UTOKNING_LOGG",action)
      return {
        ...state,
        message: translate("Error.Customer"),
        ATLoading:false
      }
    }
    case ON_START_DELETE_FALT:{
      console.log("ON_START_DELETE_FALT",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        message:"",
        ATLoading:true
      }
    }
    case ON_DELETE_FALT:{
      console.log("ON_DELETE_FALT",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        CurrentObjekt:action.payload.CurrentObjekt,
        ATLoading:false
      }
    }
    case ON_ERROR_DELETE_FALT:{
      console.log("ON_ERROR_DELETE_FALT",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.FIELD.delete"),type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    //, , ,
    case ON_START_SAVE_FALT:{
      console.log("ON_START_SAVE_FALT",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_SAVE_KONTO_OBJECT:{
      console.log("ON_SAVE_KONTO_OBJECT",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        Utokning:action.payload.Utokning,
        CurrentObjekt:action.payload.CurrentObjekt,
        ATLoading:false
      }
    }
    case ON_ARCHIVE_KONTO_OBJECT:{
      console.log("ON_ARCHIVE_KONTO_OBJECT",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        Utokning:action.payload.Utokning,
        CurrentObjekt:{},
        ATLoading:false
      }
    }
    case ON_SAVE_FALT:{
      console.log("ON_SAVE_FALT",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        CurrentObjekt:action.payload.CurrentObjekt,
        ATLoading:false
      }
    }
    case ON_ERROR_SAVE_FALT:{
      console.log("ON_ERROR_SAVE_FALT",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
        ATLoading:false
      }
    }
    //
    case ON_START_NEW_FAS:{
      console.log("ON_START_NEW_FAS",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ProspektFaslist:{},
        ATLoading:true
      }
    }
    case ON_NEW_FAS:{
      console.log("ON_NEW_FAS",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        ProspektFaslist:action.payload.ProspektFaslist,
        ATLoading:false
      }
    }
    case ON_ERROR_NEW_FAS:{
      console.log("ON_ERROR_NEW_FAS",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.FAS.Add"),type:"error",loading:false},
        ATLoading:false
      }
    }
    case ON_START_DELETE_FAS:{
      console.log("ON_START_DELETE_FAS",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_DELETE_FAS:{
      console.log("ON_DELETE_FAS",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        ProspektFaslist:action.payload.ProspektFaslist,
        ATLoading:false
      }
    }
    case ON_ERROR_DELETE_FAS:{
      console.log("ON_ERROR_DELETE_FAS",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.FAS.delete"),type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_UPDATE_FAS:{
      console.log("ON_START_UPDATE_FAS",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_UPDATE_FAS:{
      console.log("ON_UPDATE_FAS",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        ProspektFaslist:action.payload.ProspektFaslist,
        ATLoading:false
      }
    }
    case ON_ERROR_UPDATE_FAS:{
      console.log("ON_ERROR_UPDATE_FAS",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.FAS.update"),type:"error",loading:false},
        ATLoading:false
      }
    }
    case ON_START_DELETE_KALKYL:{
      console.log("ON_START_DELETE_KALKYL",action)
      return {
        ...state,
        message:"",
        Kalkyllist:{},
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_DELETE_KALKYL:{
      console.log("ON_DELETE_KALKYL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        Kalkyllist:action.payload.Kalkyllist,
        ATLoading:false
      }
    }
    case ON_ERROR_DELETE_KALKYL:{
      console.log("ON_ERROR_DELETE_KALKYL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.Calc.delete"),type:"error",loading:false},
        ATLoading:false
      }
    }
    case ON_START_UPDATE_KALKYL:{
      console.log("ON_START_UPDATE_KALKYL",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        message:"",
        //Kalkyllist:{},
        ATLoading:true
      }
    }
    case ON_UPDATE_KALKYL:{
      console.log("ON_UPDATE_KALKYL",action)
      let NKalkyllist = state.Kalkyllist
      NKalkyllist[NKalkyllist.findIndex(item=>item.id === action.payload.KalkyllistItem.id )] = action.payload.KalkyllistItem
      console.log("ON_UPDATE_KALKYL",NKalkyllist)
      console.log("ON_UPDATE_KALKYL",state.Kalkyllist)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        message:"",
        Kalkyllist:NKalkyllist,
        ATLoading:false
      }
    }
    case ON_ERROR_UPDATE_KALKYL:{
      console.log("ON_ERROR_UPDATE_KALKYL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.Calc.update"),type:"error",loading:false},
        ATLoading:false
      }
    }
    case ON_START_DELETE_SCHABLON:{
      console.log("ON_START_DELETE_SCHABLON",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        // Schablonlist:{},
        ATLoading:true
      }
    }
    case ON_DELETE_SCHABLON:{
      console.log("ON_DELETE_SCHABLON",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        message:"",
        Schablonlist:action.payload.Schablonlist,
        ATLoading:false
      }
    }
    case ON_ERROR_DELETE_SCHABLON:{
      console.log("ON_ERROR_DELETE_SCHABLON",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.SCHABLON.delete"),type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_DELETE_SCHABLON_PRESET:{
      console.log("ON_START_DELETE_SCHABLON_PRESET",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        // Schablonlist:{},
        ATLoading:true
      }
    }
    case ON_DELETE_SCHABLON_PRESET:{
      console.log("ON_DELETE_SCHABLON_PRESET",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        message:"",
        SchablonPresetList:action.payload.SchablonPresetList,
        Schablonlist:action.payload.Schablonlist,
        ATLoading:false
      }
    }
    case ON_ERROR_DELETE_SCHABLON_PRESET:{
      console.log("ON_ERROR_DELETE_SCHABLON_PRESET",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.SCHABLON.PRESET.delete"),type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_UPDATE_SCHABLON:{
      console.log("ON_START_UPDATE_SCHABLON",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        // Schablonlist:{},
        ATLoading:true
      }
    }
    case ON_UPDATE_SCHABLON:{
      console.log("ON_UPDATE_SCHABLON",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        Schablonlist:action.payload.Schablonlist,
        ATLoading:false
      }
    }
    case ON_ERROR_UPDATE_SCHABLON:{
      console.log("ON_ERROR_UPDATE_SCHABLON",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.SCHABLON.update"),type:"error",loading:false},
        ATLoading:false
      }
    }
    case ON_START_UPDATE_SCHABLON_PRESET:{
      console.log("ON_START_UPDATE_SCHABLON_PRESET",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        // Schablonlist:{},
        ATLoading:true
      }
    }
    case ON_UPDATE_SCHABLON_PRESET:{
      console.log("ON_UPDATE_SCHABLON_PRESET",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        SchablonPresetList:action.payload.SchablonPresetList,
        ATLoading:false
      }
    }
    case ON_ERROR_UPDATE_SCHABLON_PRESET:{
      console.log("ON_ERROR_UPDATE_SCHABLON_PRESET",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.SCHABLON.PRESET.update"),type:"error",loading:false},
        ATLoading:false
      }
    }

    case ON_START_RESET_SCHABLON: {
      console.log("ON_START_RESET_SCHABLON", action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Action.Customer.Setting.SCHABLON.default.fetching"),type:"info",loading:true},
        // Schablonlist:{},
        ATLoading:true
      }
    }
    case ON_RESET_SCHABLON: {
      console.log("ON_RESET_SCHABLON", action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Action.Customer.Setting.SCHABLON.default.fetch"),type:"success",loading:false},
        Schablonlist:action.payload.Schablonlist,
        ATLoading:false
      }
    }
    case ON_ERROR_RESET_SCHABLON: {
      console.log("ON_ERROR_RESET_SCHABLON", action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.SCHABLON.reset"),type:"error",loading:false},
        ATLoading:false
      }
    }

    case ON_START_FETCH_KUND_KONTAKT:{
      console.log("ON_START_FETCH_KUND_KONTAKT",action)
      return {
        ...state,
        KontakterList:{}
      }
    }
    case ON_FETCH_KUND_KONTAKT:{
      console.log("ON_FETCH_KUND_KONTAKT",action)
      return {
        ...state,
        KontakterList:action.payload.Kontakter
      }
    }
    case ON_ERROR_FETCH_KUND_KONTAKT:{
      console.log("ON_ERROR_FETCH_KUND_KONTAKT",action)
      return {
        ...state,
        message: translate("Error.Customer")
      }
    }
    case ON_START_NEW_KUNDDATA:{
      console.log("ON_START_NEW_KUNDDATA",action)
      return {
        ...state,
        KundDatalist:[],
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_NEW_KUNDDATA:{
      console.log("ON_NEW_KUNDDATA",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        KundDatalist:action.payload.KundDatalist,
        ATLoading:false
      }
    }
    case ON_ERROR_NEW_KUNDDATA:{
      console.log("ON_ERROR_NEW_KUNDDATA",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.ClientData.Add"),type:"error",loading:false},
        ATLoading:false
      }
    }
    case ON_START_GET_KUNDDATA_BY_AVTAL:{
      console.log("ON_START_GET_KUNDDATA_BY_AVTAL",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Action.Customer.Setting.ClientData.fetching"),type:"info",loading:true},
        KundDatalist:[],
        message:""
      }
    }
    case ON_GET_KUNDDATA_BY_AVTAL:{
      console.log("ON_GET_KUNDDATA_BY_AVTAL",action)
      //console.log("ON_GET_KUNDDATA_BY_AVTAL",action.payload.KundDatalist)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        KundDatalist:action.payload.KundDatalist,
        ATLoading:false
      }
    }
    case ON_ERROR_GET_KUNDDATA_BY_AVTAL:{
      console.log("ON_ERROR_GET_KUNDDATA_BY_AVTAL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.ClientData.fetch"),type:"error",loading:false},
        KundDatalist:[],
        ATLoading:false
      }
    }
    case ON_START_DELETE_KUNDDATA:{
      console.log("ON_START_DELETE_KUNDDATA",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        KundDatalist:[],
        message:"",
        ATLoading:true
      }
    }
    case ON_DELETE_KUNDDATA:{
      console.log("ON_DELETE_KUNDDATA",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        KundDatalist:action.payload.KundDatalist,
        ATLoading:false
      }
    }
    case ON_ERROR_DELETE_KUNDDATA:{
      console.log("ON_ERROR_DELETE_KUNDDATA",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.ClientData.delete"),type:"error",loading:false},
        ATLoading:false
      }
    }
    case ON_START_UPDATE_KUNDDATA:{
      console.log("ON_START_UPDATE_KUNDDATA",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_UPDATE_KUNDDATA:{
      console.log("ON_UPDATE_KUNDDATA",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        KundDatalist:action.payload.KundDatalist,
        ATLoading:false
      }
    }
    case ON_ERROR_UPDATE_KUNDDATA:{
      console.log("ON_ERROR_UPDATE_KUNDDATA",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Setting.ClientData.update"),type:"error",loading:false},
        KundDatalist:[],
        ATLoading:false
      }
    }
    case ON_START_KONTO_INFO_UPDATE:{
      console.log("ON_START_KONTO_INFO_UPDATE",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Action.Customer.Setting.saving"),type:"info",loading:true},
        //ATLoading:true
      }
    }
    case ON_KONTO_INFO_UPDATE:{
      console.log("ON_KONTO_INFO_UPDATE",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Action.Customer.info.save"),type:"success",loading:false},
        message:"",
        currentAccount: action.payload.Account[0],
        Flags:action.payload.Flag,
        ATLoading:false
      }
    }
    case ON_ERROR_KONTO_INFO_UPDATE:{
      console.log("ON_ERROR_KONTO_INFO_UPDATE",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Customer.info.save"),type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_UPDATE_MODULE:{
      console.log("ON_START_UPDATE_MODULE",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:false
      }
    }
    case ON_UPDATE_MODULE:{
      console.log("ON_UPDATE_MODULE",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:action.payload.messagetype,loading:false},
        Flags:action.payload.Flag,
        ATLoading:false
      }
    }
    case ON_UPDATE_MODULE_DONT_UPDATE:{
      console.log("ON_UPDATE_MODULE_DONT_UPDATE",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:action.payload.messagetype,loading:false},
        //Flags:action.payload.Flag,
        ATLoading:false
      }
    }
    case ON_ERROR_UPDATE_MODULE:{
      console.log("ON_ERROR_UPDATE_MODULE",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Customer.Module.save"),type:"error",loading:false},
        message:"",
        ATLoading:false
      }
    }
    case ON_START_NEW_ORDER_EMAIL:{
      console.log("ON_START_NEW_ORDER_EMAIL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_NEW_ORDER_EMAIL:{
      console.log("ON_NEW_ORDER_EMAIL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        OrderMail:action.payload.OrderEmail,
        ATLoading:false
      }
    }
    case ON_ERROR_NEW_ORDER_EMAIL:{
      console.log("ON_ERROR_NEW_ORDER_EMAIL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Order.Email.Add"),type:"error",loading:false},
        ATLoading:false
      }
    }
    case ON_START_DELETE_ORDER_EMAIL:{
      console.log("ON_START_DELETE_ORDER_EMAIL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{},
        ATLoading:true
      }
    }
    case ON_DELETE_ORDER_EMAIL:{
      console.log("ON_DELETE_ORDER_EMAIL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        OrderMail:action.payload.OrderEmail,
        ATLoading:false
      }
    }
    case ON_ERROR_DELETE_ORDER_EMAIL:{
      console.log("ON_ERROR_DELETE_ORDER_EMAIL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Order.Email.delete"),type:"error",loading:false},
        ATLoading:false
      }
    }
    //ON_START_MINA_KUNDER_NOMESSAGE,ON_MINA_KUNDER_NOMESSAGE,
    case ON_START_MINA_KUNDER_NOMESSAGE:{
      console.log("ON_START_MINA_KUNDER_NOMESSAGE",action)
      return {
        ...state,
        message:"",
        isLoading:true
      }
    }
    case ON_MINA_KUNDER_NOMESSAGE:{
      console.log("ON_MINA_KUNDER_NOMESSAGE",action)
      return {
        ...state,
        message:"",
        isLoading:false,
        MinaKunder:action.payload.Kunder,
        KundAntal:action.payload.Antal
      }
    }
    //
    case ON_START_MINA_KUNDER:{
      console.log("ON_START_MINA_KUNDER",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Action.Customer.Clients.fetching"),type:"info",loading:true},
        isLoading:true
      }
    }
    case ON_MINA_KUNDER:{
      console.log("ON_MINA_KUNDER",action)
      return {
        ...state,
        message:"",
        isLoading:false,
        MinaKunder:action.payload.Kunder,
        ResponseKundMsg:{msg:translate("Action.Customer.Clients.fetch"),type:"success",loading:false},
        KundAntal:action.payload.Antal
      }
    }
    case ON_ERROR_MINA_KUNDER:{
      console.log("ON_ERROR_MINA_KUNDER",action)
      return {
        ...state,
        message: translate("Error.Customer"),
        ResponseKontoMsg:{msg:translate("Error.Customer.Clients.fetch"),type:"error",loading:false},
        isLoading:false
      }
    }
    case ON_START_MINA_KUNDER_CLOSE_TO: {
      console.log("ON_START_MINA_KUNDER_CLOSE_TO", action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg: translate("Action.Customer.Clients.fetching"),type:"info",loading:true},
        isLoadingKundMap:true,
        MinaKunderCloseTo: []
      }
    }
    case ON_MINA_KUNDER_CLOSE_TO: {
      console.log("ON_MINA_KUNDER_CLOSE_TO", action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Action.Customer.Clients.fetch"),type:"success",loading:false},
        isLoadingKundMap:false,
        MinaKunderCloseTo: action.payload.MinaKunderCloseTo
      }
    }
    case ON_ERROR_MINA_KUNDER_CLOSE_TO: {
      console.log("ON_ERROR_MINA_KUNDER_CLOSE_TO", action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Clients.fetch"),type:"error",loading:false},
        isLoadingKundMap:false,
        MinaKunderCloseTo: []
      }
    }
    //ON_START_MINA_KONTAKTPERSONER_NOMESSAGE,ON_MINA_KONTAKTPERSONER_NOMESSAGE,
    case ON_START_MINA_KONTAKTPERSONER_NOMESSAGE:{
      console.log("ON_START_MINA_KONTAKTPERSONER_NOMESSAGE",action)
      return {
        ...state,
        isLoading:true
      }
    }
    case ON_MINA_KONTAKTPERSONER_NOMESSAGE:{
      console.log("ON_MINA_KONTAKTPERSONER_NOMESSAGE",action)
      return {
        ...state,
        message:"",
        isLoading:false,
        MinaKontaktPersoner:action.payload.Kontaktpersoner,
        KontaktAntal:action.payload.Antal
      }
    }
    //
    case ON_START_MINA_KONTAKTPERSONER:{
      console.log("ON_START_MINA_KONTAKTPERSONER",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Action.Customer.Contacters.fetching"),type:"info",loading:true},
        isLoading:true
      }
    }
    case ON_MINA_KONTAKTPERSONER:{
      console.log("ON_MINA_KONTAKTPERSONER",action)
      return {
        ...state,
        message:"",
        isLoading:false,
        ResponseKundMsg:{msg:translate("Action.Customer.Contacters.fetch"),type:"success",loading:false},
        MinaKontaktPersoner:action.payload.Kontaktpersoner,
        KontaktAntal:action.payload.Antal
      }
    }
    case ON_ERROR_MINA_KONTAKTPERSONER:{
      console.log("ON_ERROR_MINA_KONTAKTPERSONER",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Error.Customer.Contacters.fetch"),type:"error",loading:false},
        isLoading:false
      }
    }
    case ON_START_GET_DOC_ORGNR:{
      console.log("ON_START_GET_DOC_ORGNR",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Action.Customer.documents.fetching"),type:"info",loading:true},
        message:"",
        DocumentList:[]
      }
    }
    //ON_START_GET_DOC_ORGNR_PDF,ON_GET_DOC_ORGNR_PDF,ON_ERROR_GET_DOC_ORGNR_PDF,
    case ON_START_GET_DOC_ORGNR_PDF:{
      console.log("ON_GET_DOC_ORGNR",action)
      return {
        ...state,
      }
    }
    case ON_GET_DOC_ORGNR_PDF:{
      console.log("ON_GET_DOC_ORGNR_PDF",action)
      return {
        ...state,
        AntalDokPdf:action.payload.Antal[0].total,
        DocumentListPdf:action.payload.DocumentList
      }
    }
    case ON_ERROR_GET_DOC_ORGNR_PDF:{
      console.log("ON_GET_DOC_ORGNR",action)
      return {
        ...state,
      }
    }
    //
    case ON_GET_DOC_ORGNR:{
      console.log("ON_GET_DOC_ORGNR",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Action.Customer.documents.fetch"),type:"success",loading:false},
        DocumentList:action.payload.DocumentList,
        AntalDok:action.payload.Antal,
        currentKund:{
          ...state.currentKund,
          numDoc:[{numDoc:action.payload.Antal[0].total}]
        },
      }
    }
    case ON_GET_DOC_ORGNR_0:{
      console.log("ON_GET_DOC_ORGNR_0",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Action.Customer.documents.fetch"),type:"success",loading:false},
        DocumentList:action.payload.DocumentList,
        AntalDok:action.payload.Antal
      }
    }
    case ON_ERROR_GET_DOC_ORGNR:{
      console.log("ON_ERROR_GET_DOC_ORGNR",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Error.Customer.documents.fetch"),type:"error",loading:false},
        DocumentList:[]
      }
    }
    case ON_START_IMPORT_FUNC:{
      console.log("ON_START_IMPORT_FUNC",action)
      return {
        ...state,
        message:"",
        importType:action.payload,
        ResponseKontoMsg:{msg:translate("Action.import.starting"),type:"info",loading:true},
        importeraLoading:true,
        ShowImportlogg:action.payload==="Prislistor"?1:0
      }
    }
    case ON_IMPORT_FUNC:{
      console.log("ON_IMPORT_FUNC",action)
      return {
        ...state,
        message:"",
        importType:"",
        ResponseKontoMsg:{msg:translate("Action.import.start"),type:"success",loading:false},
        importeraLoading:false  
      }
    }
    case ON_ERROR_IMPORT_FUNC:{
      console.log("ON_ERROR_IMPORT_FUNC",action)
      return {
        ...state,
        importType:"",
        ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
        message:"",
        importeraLoading:false  
      }
    }
    case ON_START_BESTALLA_ESIGN:{
      console.log("ON_START_BESTALLA_ESIGN",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_BESTALLA_ESIGN:{
      console.log("ON_BESTALLA_ESIGN",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Action.save"),type:"success",loading:false},
        message:"",
        Esignering:action.payload.Esignering
      }
    }
    case ON_ERROR_BESTALLA_ESIGN:{
      console.log("ON_ERROR_BESTALLA_ESIGN",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
        message:"",
      }
    }

    case ON_START_GET_AF_ESIGNERING:{
      console.log("ON_START_GET_AF_ESIGNERING",action)
      return {
        ...state,
        message:""
      }
    }
    case ON_GET_AF_ESIGNERING:{
      console.log("ON_GET_AF_ESIGNERING",action)
      return {
        ...state,
        message:"",
        Esignering:action.payload.Esignering
      }
    }
    case ON_ERROR_GET_AF_ESIGNERING:{
      console.log("ON_ERROR_GET_AF_ESIGNERING",action)
      return {
        ...state,
        message: translate("Error.Customer"),
      }
    }
    //ON_START_GET_USER_DIALER,ON_GET_USER_DIALER,ON_ERROR_GET_USER_DIALER,
    case ON_START_GET_USER_DIALER:{
      console.log("ON_START_GET_USER_DIALER",action)
      return {
        ...state,
        message:""
      }
    }
    case ON_GET_USER_DIALER:{
      console.log("ON_GET_USER_DIALER",action)
      return {
        ...state,
        message:"",
        DailerUser:action.payload.Dailer
      }
    }
    case ON_ERROR_GET_USER_DIALER:{
      console.log("ON_ERROR_GET_USER_DIALER",action)
      return {
        ...state,
      }
    }
    case ON_START_SAVE_USER_DIALER:{
      console.log("ON_START_SAVE_USER_DIALER",action)
      return {
        ...state,
        message:""
      }
    }
    case ON_SAVE_USER_DIALER:{
      console.log("ON_SAVE_USER_DIALER",action)
      return {
        ...state,
        message:"",
        DailerUser:action.payload.Dailer
      }
    }
    case ON_ERROR_SAVE_USER_DIALER:{
      console.log("ON_ERROR_SAVE_USER_DIALER",action)
      return {
        ...state,
      }
    }
    //ON_START_SAVE_USER_DIALER, ON_SAVE_USER_DIALER, ON_ERROR_SAVE_USER_DIALER,
    case ON_START_GET_AF_DIALER:{
      console.log("ON_START_GET_AF_DIALER",action)
      return {
        ...state,
        message:""
      }
    }
    case ON_GET_AF_DIALER:{
      console.log("ON_GET_AF_DIALER",action)
      return {
        ...state,
        message:"",
        Dailer:action.payload.Dailer,
        NejTackList:action.payload.NejTackList,
        EjSvarList:action.payload.EjSvarList,
        BortFallList:action.payload.BortFallList,
        BlackListT:action.payload.BlackListT,
      }
    }
    case ON_ERROR_GET_AF_DIALER:{
      console.log("ON_ERROR_GET_AF_DIALER",action)
      return {
        ...state,
        message: translate("Error.Customer"),
      }
    }
    //, , ,
    case ON_START_SAVE_DIALER:{
      console.log("ON_START_SAVE_DIALER",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_SAVE_DIALER:{
      console.log("ON_SAVE_DIALER",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        Dailer:action.payload.Dailer,
        NejTackList:action.payload.NejTackList,
        EjSvarList:action.payload.EjSvarList,
        BortFallList:action.payload.BortFallList,
        BlackListT:action.payload.BlackListT,
      }
    }
    case ON_ERROR_SAVE_DIALER:{
      console.log("ON_ERROR_SAVE_DIALER",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Account.dialer.setting"),type:"error",loading:false},
        message:"",
      }
    }
    //
    //
    case ON_START_SAVE_ESIGN:{
      console.log("ON_START_SAVE_ESIGN",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_SAVE_ESIGN:{
      console.log("ON_SAVE_ESIGN",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:translate("Action.save"),type:"success",loading:false},
        Esignering:action.payload.Esignering
      }
    }
    case ON_ERROR_SAVE_ESIGN:{
      console.log("ON_ERROR_SAVE_ESIGN",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
        message:action.payload,
      }
    }
    case ON_SAVE_PRICELIST: {
      console.log("ON_SAVE_PRICELIST", action)
      //Spara till databas
      return {
        ...state,
        prisListor: [...state.prisListor, action.payload]
      }
    }
    case GET_PRICELIST_BY_ID: {
      console.log("GET_PRICELIST_BY_ID", action)

      let pricelist = {}
      state.prisListor.map(p => {
        if(action.payload === p.id)
          pricelist = p
      })
      return {
        ...state,
        currentPriceList: pricelist
      }
    }
    case GET_ALL_PRICELISTS: {
      console.log("GET_ALL_PRICELISTS", action)
      //Ladda frpn databas
      return {
        ...state,
        prisListor: action.payload
      }
    }
    case ON_START_GET_OLD_AF: {
      console.log("ON_START_GET_OLD_AF",action)
      return {
        ...state,
        message:""
      }
    }
    case ON_GET_OLD_AF: {
      console.log("ON_GET_OLD_AF", action)
      return {
        ...state,
        OldAf: action.payload.OldAf
      }
    }
    case ON_ERROR_GET_OLD_AF: {
      console.log("ON_ERROR_GET_OLD_AF", action)
      //Ladda frpn databas
      return {
        ...state,
        message: translate("Error.Customer")
      }
    }
    case ON_START_GET_OLD_AF_USER: {
      console.log("ON_START_GET_OLD_AF_USER",action)
      return {
        ...state,
        OldAFUsers:[],
        message:""
      }
    }
    case ON_GET_OLD_AF_USER: {
      console.log("ON_GET_OLD_AF_USER", action)
      return {
        ...state,
        OldAFUsers: action.payload.OldAFUsers
      }
    }
    case ON_ERROR_GET_OLD_AF_USER: {
      console.log("ON_ERROR_GET_OLD_AF_USER", action)
      //Ladda frpn databas
      return {
        ...state,
        message: translate("Error.Customer")
      }
    }
    case ON_OPEN_FILTER_KUNDER: {
      console.log("ON_OPEN_FILTER_KUNDER", action)
      //Ladda frpn databas
      return {
        ...state,
        FilterKunderPopUp:true
      }
    }
    case ON_ClOSE_FILTER_KUNDER: {
      console.log("ON_ClOSE_FILTER_KUNDER", action)
      //Ladda frpn databas
      return {
        ...state,
        FilterKunderPopUp:false
      }
    }
    case ON_START_SYNC_USER: {
      console.log("ON_START_SYNC_USER",action)
      return {
        ...state,
        SyhncLoading:true,
        message:""
      }
    }
    case ON_SYNC_USER: {
      console.log("ON_SYNC_USER", action)
      return {
        ...state,
        SyhncLoading:false,
        message:translate("Action.Done")
      }
    }
    case ON_ERROR_SYNC_USER: {
      console.log("ON_ERROR_SYNC_USER", action)
      //Ladda frpn databas
      return {
        ...state,
        SyhncLoading:false,
        message: translate("Error.Customer")
      }
    }
    case ON_KUND_ANTAL_ORDER: {
      console.log("ON_KUND_ANTAL_ORDER", action)
      //Ladda frpn databas
      return {
        ...state,
        currentKund:{
          ...state.currentKund,
          numOrder:action.payload.results.numOrder
        }
      }
    }
    case ON_START_GET_NEW_KUND_BASIC: {
      console.log("ON_START_GET_NEW_KUND_BASIC", action)
      //Ladda frpn databas
      return {
        ...state,
        KundSearchLoading: true,
        isPersonlig:0,
        KundSearch:{}
      }
    }
    case ON_GET_NEW_KUND_BASIC: {
      console.log("ON_GET_NEW_KUND_BASIC", action)
      //Ladda frpn databas
      return {
        ...state,
        KundSearchLoading: false,
        KundSearch:action.payload.Kund,
        isPersonlig:action.payload.isPersonlig
      }
    }
    case ON_ERROR_GET_NEW_KUND_BASIC: {
      console.log("ON_ERROR_GET_NEW_KUND_BASIC", action)
      //Ladda frpn databas
      return {
        ...state,
        KundSearchLoading: false,
      }
    }
/*
    case ON_START_GET_NEW_KUND_TOOLTIP_DETAILS: {
      console.log("ON_START_GET_NEW_KUND_TOOLTIP_DETAILS", action)
      //Ladda frpn databas
      return {
        ...state,
        KundTooltipDetails:{}
      }
    }
    case ON_GET_NEW_KUND_TOOLTIP_DETAILS: {
      console.log("ON_GET_NEW_KUND_TOOLTIP_DETAILS", action)
      //Ladda frpn databas
      return {
        ...state,
        KundTooltipDetails:action.payload.Tooltip
      }
    }
    case ON_ERROR_GET_NEW_KUND_TOOLTIP_DETAILS: {
      console.log("ON_ERROR_GET_NEW_KUND_TOOLTIP_DETAILS", action)
      //Ladda frpn databas
      return {
        ...state,
        }
    }
*/
    //, , ,
    case ON_START_KUND_NEW_UTOKNING: {
      console.log("ON_START_KUND_NEW_UTOKNING", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        ResponseKundMsg:{msg:translate("Action.Creating"),type:"info",loading:true},
        CurrentObjektKund:[]
      }
    }
    case ON_KUND_NEW_UTOKNING: {
      console.log("ON_KUND_NEW_UTOKNING", action)
      //Ladda frpn databas
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Action.Create"),type:"success",loading:false},
        ATLoading:false,
        CurrentObjektKund:action.payload.UtokningRow,
        CurrentObjektKundCount:action.payload.UtokningRowCount,
      }
    }
    case ON_ERROR_KUND_NEW_UTOKNING: {
      console.log("ON_ERROR_KUND_NEW_UTOKNING", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        ResponseKundMsg:{msg:translate("Error.Account.EXTENDING.setting"),type:"error",loading:false},
        message:""
        }
    }
    //ON_START_GET_UTOKNING_DESC_BY_ORGNR, ON_GET_UTOKNING_DESC_BY_ORGNR, ON_ERROR_GET_UTOKNING_DESC_BY_ORGNR,
    case ON_START_GET_UTOKNING_DESC_BY_ORGNR: {
      //Ladda frpn databas
      return {
        ...state,
        CurrentObjektKunddesc:"",
        ResponseKundMsg:{},
      }
    }
    case ON_GET_UTOKNING_DESC_BY_ORGNR: {
      //Ladda frpn databas
      return {
        ...state,
        CurrentObjektKunddesc:action.payload.CurrentObjektKunddesc,
      }
    }
    case ON_ERROR_GET_UTOKNING_DESC_BY_ORGNR: {
      //Ladda frpn databas
      return {
        ...state,
      }
    }
    //ON_START_SAVE_UTOKNING_DESC_BY_ORGNR, ON_SAVE_UTOKNING_DESC_BY_ORGNR, ON_ERROR_SAVE_UTOKNING_DESC_BY_ORGNR,
    case ON_START_SAVE_UTOKNING_DESC_BY_ORGNR: {
      //Ladda frpn databas
      return {
        ...state,
        ResponseKundMsg:{},
      }
    }
    case ON_SAVE_UTOKNING_DESC_BY_ORGNR: {
      console.log("ON_SAVE_UTOKNING_DESC_BY_ORGNR", action)       
      //Ladda frpn databas
      return {
        ...state,
        CurrentObjektKunddesc:action.payload.CurrentObjektKunddesc,
        ResponseKundMsg:{msg:translate("Action.save"),type:"success",loading:false},
      }
    }
    case ON_ERROR_SAVE_UTOKNING_DESC_BY_ORGNR: {
      //Ladda frpn databas
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Account.EXTENDING.save"),type:"error",loading:false},
      }
    }
    //
    case ON_START_GET_UTOKNING_BY_ORGNR: {
      console.log("ON_START_GET_UTOKNING_BY_ORGNR", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:true,
        CurrentObjektKund:[],
        CurrentObjektKundCount:0
      }
    }
    case ON_GET_UTOKNING_BY_ORGNR: {
      console.log("ON_GET_UTOKNING_BY_ORGNR", action)
      //Ladda frpn databas
      return {
        ...state,
        message:"",
        ATLoading:false,
        CurrentObjektKund:action.payload.UtokningRow,
        CurrentObjektKundCount:action.payload.UtokningRowCount,
        currentKund:{
          ...state.currentKund,
          numFria:action.payload.numFria
        },
      }
    }
    case ON_ERROR_UTOKNING_BY_ORGNR: {
      console.log("ON_ERROR_UTOKNING_BY_ORGNR", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        message:""
        }
    }
    
    // ON_START_GET_UTOKNING_LIST_BY_ORGNR,ON_GET_UTOKNING_LIST_BY_ORGNR,ON_ERROR_UTOKNING_LIST_BY_ORGNR,
    case ON_START_GET_UTOKNING_LIST_BY_ORGNR: {
      console.log("ON_START_GET_UTOKNING_LIST_BY_ORGNR", action)
      //Ladda frpn databas
      return {
        ...state,
        CurrentObjektKundList:[],
      }
    }
    case ON_GET_UTOKNING_LIST_BY_ORGNR: {
      console.log("ON_GET_UON_GET_UTOKNING_LIST_BY_ORGNRTOKNING_BY_ORGNR", action)
      //Ladda frpn databas
      return {
        ...state,
        CurrentObjektKundList:action.payload.UtokningList,
      }
    }
    case ON_ERROR_UTOKNING_LIST_BY_ORGNR: {
      console.log("ON_ERROR_UTOKNING_LIST_BY_ORGNR", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        message:""
        }
    }
    case ON_START_GET_UTOKNING_BY_AFID: {
      console.log("ON_START_GET_UTOKNING_BY_AFID", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:true,
        FFLoading:true,
        CurrentObjektAfid:[],
        CurrentObjektAfidCount:0,
      }
    }
    case ON_START_SEARCH_UTOKNING_BY_AFID: {
      console.log("ON_START_SEARCH_UTOKNING_BY_AFID", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:true,
        CurrentObjektAfid:[],
        CurrentObjektAfidCount:0,
      }
    }
    case ON_GET_UTOKNING_BY_AFID: {
      console.log("ON_GET_UTOKNING_BY_AFID", action)
      //Ladda frpn databas
      return {
        ...state,
        message:"",
        ATLoading:false,
        FFLoading:false,
        CurrentObjektAfid:action.payload.UtokningRow,
        CurrentObjektAfidCount: isUndefined(action.payload.Count) ? 0 : action.payload.Count,
      }
    }
    case ON_CACHE_UTOKNING_BY_AFID: {
      let sdate = new Date()
      let d = sdate.toISOString().split('T')[0]
      let t = sdate.toTimeString().split(' ')[0]
  
      let newDate = d + " " + t
      console.log(newDate)
      console.log("ON_CACHE_UTOKNING_BY_AFID", action)
      localStorage.setItem('utokning_cache_data_'+action.payload.ObjektId, JSON.stringify(action.payload.results.UtokningRow))
      localStorage.setItem('utokning_cache_sdate_'+action.payload.ObjektId, newDate)
      
      return state
    }
    case ON_LOAD_CACHE_UTOKNING_BY_AFID: {
      console.log("ON_LOAD_CACHE_UTOKNING_BY_AFID", action)
      let obj = []
      try{
        obj = JSON.parse(localStorage.getItem('utokning_cache_data_'+action.payload.ObjectId))
      } catch {
        obj = state.CurrentObjektAfid
      }
      console.log(obj)
      return {
        ...state,
        message:"",
        ATLoading:false,
        FFLoading:false,
        CurrentObjektAfid:!isNull(obj) ? obj : [],
      }
    }
    case ON_BUFFER_UTOKNING_BY_AFID: {
      console.log("ON_BUFFER_UTOKNING_BY_AFID", action)
      //Ladda frpn databas
      return {
        ...state,
        message:"",
        ATLoading:false,
        CurrentObjektAfid:action.payload.UtokningRow.concat(state.CurrentObjektAfid),
        CurrentObjektAfidCount:action.payload.Count[0]["COUNT(*)"],
      }
    }
    case ARENDE_ON_FETCH_ASSISTANSBÅT: {
      console.log("ARENDE_ON_FETCH_ASSISTANSBÅT", action)
      //Ladda frpn databas
        return {
          ...state,
          message:"",
          ATLoading:false,
          CurrentObjektAfidExt: isUndefined(action.payload) ? [] : action.payload.UtokningRow,
        }
    }
    case ON_SEARCH_UTOKNING_BY_AFID: {
      console.log("ON_SEARCH_UTOKNING_BY_AFID", action)
      //Ladda frpn databas
      return {
        ...state,
        message:"",
        ATLoading:false,
        CurrentObjektAfid:action.payload.UtokningRow,
        CurrentObjektAfidCount:action.payload.Count,
      }
    }
    case ON_ERROR_UTOKNING_BY_AFID: {
      console.log("ON_ERROR_UTOKNING_BY_AFID", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        message: translate("Error.Customer")
        }
    }
    case ON_ERROR_SEARCH_UTOKNING_BY_AFID: {
      console.log("ON_ERROR_UTOKNING_BY_AFID", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        message: translate("Error.Customer")
        }
    }
    //, , ,
    case ON_START_DELETE_UTOKNING_BY_ORGNR: {
      console.log("ON_START_DELETE_UTOKNING_BY_ORGNR", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        ResponseKundMsg:{msg:translate("Action.deleting"),type:"info",loading:true},
        CurrentObjektKund:[],
        CurrentObjektKundCount:0,
      }
    }
    case ON_DELETE_UTOKNING_BY_ORGNR: {
      console.log("ON_DELETE_UTOKNING_BY_ORGNR", action)
      //Ladda frpn databas
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:translate("Action.delete2"),type:"warning",loading:false},
        ATLoading:false,
        CurrentObjektKund:action.payload.UtokningRow,
        CurrentObjektKundCount:action.payload.UtokningRowCount
      }
    }
    case ON_ERROR_DELETE_UTOKNING_BY_ORGNR: {
      console.log("ON_ERROR_DELETE_UTOKNING_BY_ORGNR", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        ResponseKundMsg:{msg:translate("Error.Account.EXTENDING.delete"),type:"error",loading:false},
        message:""
        }
    }
    //, , ,
    case ON_START_KUND_UPDATE_UTOKNING: {
      console.log("ON_START_KUND_UPDATE_UTOKNING", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        ResponseKundMsg:{msg:translate("Action.saving"),type:"info",loading:true},
        CurrentObjektKund:[],
        CurrentObjektKundCount: 0
      }
    }
    case ON_KUND_UPDATE_UTOKNING: {
      console.log("ON_KUND_UPDATE_UTOKNING", action)
      //Ladda frpn databas
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        ATLoading:false,
        CurrentObjektKund:action.payload.UtokningRow,
        CurrentObjektKundCount:action.payload.UtokningRowCount
      }
    }
    case ON_ERROR_KUND_UPDATE_UTOKNING: {
      console.log("ON_ERROR_KUND_UPDATE_UTOKNING", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        ResponseKundMsg:{msg:translate("Error.Account.EXTENDING.save"),type:"error",loading:false},
        message:""
        }
    }
    //, , ,
    case ON_START_NEW_AFID_KEDJA: {
      console.log("ON_START_NEW_AFID_KEDJA", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:true,
        MinaKedja:[]
      }
    }
    case ON_NEW_AFID_KEDJA: {
      console.log("ON_NEW_AFID_KEDJA", action)
      //Ladda frpn databas
      return {
        ...state,
        message: translate("Action.Customer.save"),
        ATLoading:false,
        MinaKedja:action.payload.MinaKedja
      }
    }
    case ON_ERROR_NEW_AFID_KEDJA: {
      console.log("ON_ERROR_NEW_AFID_KEDJA", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        message: translate("Error.Customer")
        }
    }
    case ON_START_UPDATE_AFID_KEDJA: {
      console.log("ON_START_UPDATE_AFID_KEDJA", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:true,
        MinaKedja:[]
      }
    }
    case ON_UPDATE_AFID_KEDJA: {
      console.log("ON_UPDATE_AFID_KEDJA", action)
      //Ladda frpn databas
      return {
        ...state,
        message:translate("Action.Account.Chain.save"),
        ATLoading:false,
        MinaKedja:action.payload.MinaKedja
      }
    }
    case ON_ERROR_UPDATE_AFID_KEDJA: {
      console.log("ON_ERROR_UPDATE_AFID_KEDJA", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        message: translate("Error.Customer")
        }
    }
    //,,,
    case ON_START_DELETE_AFID_KEDJA: {
      console.log("ON_START_DELETE_AFID_KEDJA", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:true,
        MinaKedja:[]
      }
    }
    case ON_DELETE_AFID_KEDJA: {
      console.log("ON_DELETE_AFID_KEDJA", action)
      //Ladda frpn databas
      return {
        ...state,
        message:translate("Action.Account.Chain.delete"),
        ATLoading:false,
        MinaKedja:action.payload.MinaKedja
      }
    }
    case ON_ERROR_DELETE_AFID_KEDJA: {
      console.log("ON_ERROR_DELETE_AFID_KEDJA", action)
      //Ladda frpn databas
      return {
        ...state,
        ATLoading:false,
        message: translate("Error.Customer")
        }
    }
    // , , ,
    case ON_START_DIALER_ADD_EJSVAR:{
      console.log("ON_START_DIALER_ADD_EJSVAR",action)
      return {
        ...state,
        message:""
      }
    }
    case ON_DIALER_ADD_EJSVAR:{
      console.log("ON_DIALER_ADD_EJSVAR",action)
      return {
        ...state,
        message:translate("Action.save"),
        EjSvarList:action.payload.EjSvarList,
      }
    }
    case ON_ERROR_DIALER_ADD_EJSVAR:{
      console.log("ON_ERROR_DIALER_ADD_EJSVAR",action)
      return {
        ...state,
        message: translate("Error.Customer"),
      }
    }
    //ON_START_DIALER_ADD_BORTFALL, ON_DIALER_ADD_BORTFALL, ON_ERROR_DIALER_ADD_BORTFALL,
    case ON_START_DIALER_ADD_BORTFALL:{
      console.log("ON_START_DIALER_ADD_BORTFALL",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_DIALER_ADD_BORTFALL:{
      console.log("ON_DIALER_ADD_BORTFALL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        BortFallList:action.payload.BortFallList,
      }
    }
    case ON_ERROR_DIALER_ADD_BORTFALL:{
      console.log("ON_ERROR_DIALER_ADD_BORTFALL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:"Error 1001: fel i server",type:"error",loading:false},
      }
    }
    //
    case ON_START_DIALER_ADD_BLACKLIST_TAGG:{
      console.log("ON_START_DIALER_ADD_BLACKLIST_TAGG",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_DIALER_ADD_BLACKLIST_TAGG:{
      console.log("ON_DIALER_ADD_BLACKLIST_TAGG",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        BlackListT:action.payload.BlackListT,
      }
    }
    case ON_ERROR_DIALER_ADD_BLACKLIST_TAGG:{
      console.log("ON_ERROR_DIALER_ADD_BLACKLIST_TAGG",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:"Error 1001: fel i server",type:"error",loading:false},
        message:"",
      }
    }
    //  , , ,
    case ON_START_DIALER_ADD_NEJTACK:{
      console.log("ON_START_DIALER_ADD_NEJTACK",action)
      return {
        ...state,
        ResponseKontoMsg:{},
        message:""
      }
    }
    case ON_DIALER_ADD_NEJTACK:{
      console.log("ON_DIALER_ADD_NEJTACK",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        message:"",
        NejTackList:action.payload.NejTackList,
      }
    }
    case ON_ERROR_DIALER_ADD_NEJTACK:{
      console.log("ON_ERROR_DIALER_ADD_NEJTACK",action)
      return {
        ...state,
        ResponseKontoMsg:{msg:"Error 1001: fel i server",type:"error",loading:false},
        message:"",
      }
    }
    // ,,
    case ON_DIALER_DELETE_NEJTACK:{
      console.log("ON_DIALER_DELETE_NEJTACK",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        NejTackList:action.payload.NejTackList,
      }
    }
    case ON_DIALER_DELETE_EJSVAR:{
      console.log("ON_DIALER_DELETE_EJSVAR",action)
      return {
        ...state,
        message: translate("Action.delete"),
        EjSvarList:action.payload.EjSvarList,
      }
    }
    case ON_DIALER_DELETE_BORTFALL:{
      console.log("ON_DIALER_DELETE_BORTFALL",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        BortFallList:action.payload.BortFallList,
      }
    }
    case ON_DIALER_DELETE_BLACKLIST_TAGG:{
      console.log("ON_DIALER_DELETE_BLACKLIST_TAGG",action)
      return {
        ...state,
        message:"",
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        BlackListT:action.payload.BlackListT,
      }
    }
    //, , ON_ERROR_UPDATE_KUND_DOCUMENT,
    case ON_START_UPDATE_KUND_DOCUMENT:{
      console.log("ON_START_UPDATE_KUND_DOCUMENT",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Action.Account.document.saving"),type:"info",loading:true},
        message:"",
      }
    }
    case ON_UPDATE_KUND_DOCUMENT:{
      console.log("ON_UPDATE_KUND_DOCUMENT",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        DocumentList:action.payload.DocumentList,
        AntalDok:action.payload.Antal,
        currentKund:{
          ...state.currentKund,
          numDoc:[{numDoc:action.payload.Antal[0].total}]
        },
      }
    }
    case ON_ERROR_UPDATE_KUND_DOCUMENT:{
      console.log("ON_ERROR_UPDATE_KUND_DOCUMENT",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Account.document.saving"),type:"error",loading:false},
        message:""
      }
    }
    //, ON_ADD_DOCUMENT, ON_ERROR_ADD_DOCUMENT,
    case ON_START_ADD_DOCUMENT:{
      console.log("ON_START_ADD_DOCUMENT",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Action.Account.document.creating"),type:"info",loading:true},
        message:"",
      }
    }
    case ON_ADD_DOCUMENT:{
      console.log("ON_ADD_DOCUMENT",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        DocumentList:action.payload.DocumentList,
        AntalDok:action.payload.Antal,
        currentKund:{
          ...state.currentKund,
          numDoc:[{numDoc:action.payload.Antal[0].total}]
        },
      }
    }
    case ON_ERROR_ADD_DOCUMENT:{
      console.log("ON_ERROR_ADD_DOCUMENT",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Account.document.create"),type:"error",loading:false},
        message:""
      }
    }
    case ON_START_SYNC_DOCUMENT_ONEDRIVE:{
      console.log("ON_START_SYNC_DOCUMENT_ONEDRIVE",action)
      return {
        ...state,
        ResponseKundMsg:{msg:translate("Action.Account.document.oneDrive"),type:"info",loading:true},
        message:"",
      }
		} 
		case ON_SYNC_DOCUMENT_ONEDRIVE: {
      console.log("ON_ADD_DOCUMENT",action)
      return {
        ...state,
        message:"",
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
        DocumentList:action.payload.DocumentList,
        AntalDok:action.payload.Antal,
        currentKund:{
          ...state.currentKund,
          numDoc:[{numDoc:action.payload.Antal[0].total}]
        },
      }
		}
		case ON_ERROR_SYNC_DOCUMENT_ONEDRIVE: {
			return {
        ...state,
        ResponseKundMsg:{msg:translate("Error.Account.document.oneDrive"),type:"error",loading:false},
        message:""
			}
		}
    //
    case ON_START_EJAKTIV_USER:{
      console.log("ON_START_EJAKTIV_USER",action)
      return {
          ...state,  
          userLoading:true,
          ResponseKontoMsg:{}
         // Userlista:[] 
      }
  }
  case ON_EJAKTIV_USER:{
      console.log("ON_EJAKTIV_USER",action)
      return {
          ...state,
          Userlista:action.payload.Users,
          userLoading:false,
          ResponseKontoMsg:{msg:translate("Action.Account.user.inactive",`${action.payload.message} har inaktiverats`,{item:action.payload.message}),type:"error",loading:false},
      }
  }
  case ON_TAEJAKTIV_USER:{
      console.log("ON_TAEJAKTIV_USER",action)
      return {
          ...state,
          Userlista:action.payload.Users,
          userLoading:false,
          ResponseKontoMsg:{msg:translate("Action.Account.user.delete",`${action.payload.message} har raderats`,{item:action.payload.message}),type:"error",loading:false},
          //message: translate("Action.delete")
      }
  }
  case ON_ERROR_EJAKTIV_USER:{
      console.log("ON_ERROR_EJAKTIV_USER",action)
      return {
          ...state,
          userLoading:false,
          message: translate("Error.Customer")
      }
  }
  //ON_START_PERATER_USER,  ON_PERATER_USER,  ON_ERROR_PERATER_USER,
  case ON_START_PERATER_USER:{
    console.log("ON_START_PERATER_USER",action)
    return {
        ...state,  
        userLoading:true,
       // Userlista:[] 
    }
}
case ON_PERATER_USER:{
    console.log("ON_PERATER_USER",action)
    return {
        ...state,
        Userlista:action.payload.Users,
        userLoading:false,
        message:translate("Action.Done")
    }
}
case ON_ERROR_PERATER_USER:{
    console.log("ON_ERROR_PERATER_USER",action)
    return {
        ...state,
        userLoading:false,
        message: translate("Error.Customer")
    }
}
  //,,,
  case ON_START_FETCH_ADMIN_STATISTIK:{
    console.log("ON_START_FETCH_ADMIN_STATISTIK",action)
    return {
        ...state,  
       // Userlista:[] 
    }
}
case ON_FETCH_ADMIN_STATISTIK:{
    console.log("ON_FETCH_ADMIN_STATISTIK",action)
    return {
        ...state,
        AdminStatistik:action.payload.AdminStatistik,
        AccountStatistic:action.payload.AccountStatistic,
    }
}
case ON_ERROR_ADMIN_STATISTIK:{
    console.log("ON_ERROR_ADMIN_STATISTIK",action)
    return {
        ...state,
        message: action.payload
    }
}
  //,,,
  case ON_START_FETCH_RAPPORT:{
    console.log("ON_START_FETCH_RAPPORT",action)
    return {
        ...state,  
        isRapportLoading:true,
        ResponseRapportMsg:{}
      //  RapportFile:[] 
    }
}
case ON_FETCH_RAPPORT:{
    console.log("ON_FETCH_RAPPORT",action)
    return {
        ...state,
        isRapportLoading:false
      //  RapportFile:action.payload.AdminStatistik,
    }
}
//ON_FETCH_RAPPORT_MESSAGE,ON_ERROR_FETCH_RAPPORT_MESSAGE,
case ON_FETCH_RAPPORT_MESSAGE:{
  console.log("ON_FETCH_RAPPORT_MESSAGE",action)
  return {
      ...state,
      isRapportLoading:false,
      ResponseRapportMsg:{msg:action.payload.message,type:"success",loading:false},
    //  RapportFile:action.payload.AdminStatistik,
  }
}
case ON_ERROR_FETCH_RAPPORT_MESSAGE:{
  console.log("ON_ERROR_FETCH_RAPPORT_MESSAGE",action)
  return {
      ...state,
      isRapportLoading:false,
      
    //  RapportFile:action.payload.AdminStatistik,
  }
}
//
case ON_ERROR_FETCH_RAPPORT:{
    console.log("ON_ERROR_FETCH_RAPPORT",action)
    return {
        ...state,
        isRapportLoading:false,
        message: translate("Error.Customer")
    }
}  
//ON_START_FETCH_MINAORT,ON_FETCH_MINAORT,ON_ERROR_MINAORT,
case ON_START_FETCH_MINAORT:{
  console.log("ON_START_FETCH_MINAORT",action)
  return {
      ...state,  
    }
}
case ON_FETCH_MINAORT:{
  console.log("ON_FETCH_MINAORT",action)
  return {
      ...state,
      MinaOrts:action.payload.MinaOrts
    //  RapportFile:,
  }
}
case ON_ERROR_MINAORT:{
  console.log("ON_ERROR_MINATAG",action)
  return {
      ...state
  }
} 
//
case ON_START_FETCH_MINATAG:{
  console.log("ON_START_FETCH_MINATAG",action)
  return {
      ...state,  
    }
}
case ON_FETCH_MINATAG:{
  console.log("ON_FETCH_MINATAG",action)
  return {
      ...state,
      MinaTags:action.payload.MinaTags
    //  RapportFile:,
  }
}
case ON_ERROR_MINATAG:{
  console.log("ON_ERROR_MINATAG",action)
  return {
      ...state
  }
} 
//, , ,
case ON_START_DELETE_KUND_DOCUMENT:{
  console.log("ON_START_DELETE_KUND_DOCUMENT",action)
  return {
      ...state, 
      ResponseKundMsg:{msg:translate("Action.Account.document.deleting"),type:"info",loading:true}, 
    }
}
case ON_DELETE_KUND_DOCUMENT:{
  console.log("ON_DELETE_KUND_DOCUMENT",action)
  return {
      ...state,
      //DocumentList:action.payload.DocumentList,
      //AntalDok:action.payload.Antald,
      //currentKund:{
      //  ...state.currentKund,
      //  numDoc:[{numDoc:action.payload.Antal}]
      //},
      ResponseKundMsg:{msg:action.payload.message,type:"warning",loading:false}, 
      message:""
    //  RapportFile:,
  }
}
case ON_ERROR_DELETE_KUND_DOCUMENT:{
  console.log("ON_ERROR_DELETE_KUND_DOCUMENT",action)
  return {
      ...state,
      ResponseKundMsg:{msg:translate("Error.Account.document.delete"),type:"error",loading:false}, 
      message:""
  }
} 
//ON_SET_KUND_SEARCH
case ON_SET_KUND_SEARCH:{
  console.log("ON_SET_KUND_SEARCH",action)
  return {
      ...state,
      KundSearch:{},
      KontakterList:[]

  }
} 
//,,,
case ON_START_GET_DASHBORAD_LINK:{
  console.log("ON_START_GET_DASHBORAD_LINK",action)
  return {
      ...state,
  }
} 
case ON_FETCH_DASHBORAD_LINK:{
  console.log("ON_FETCH_DASHBORAD_LINK",action)
  return {
      ...state,
      DashboardArr:action.payload.DashboardArr,
      DashboardLoopArr:action.payload.DashboardLoopArr,
  }
} 
case ON_ERROR_DASHBORAD_LINK:{
  console.log("ON_ERROR_DASHBORAD_LINK",action)
  return {
      ...state,
  }
} 
//, , ,
case ON_START_GENERATE_DASHBORAD_LINK:{
  console.log("ON_START_GENERATE_DASHBORAD_LINK",action)
  return {
      ...state,
  }
} 
case ON_GENERATE_DASHBORAD_LINK:{
  console.log("ON_GENERATE_DASHBORAD_LINK",action)
  return {
      ...state,
      DashboardArr:action.payload.DashboardArr,
      DashboardLoopArr:action.payload.DashboardLoopArr,
  }
} 
case ON_ERROR_GENERATE_DASHBORAD_LINK:{
  console.log("ON_ERROR_GENERATE_DASHBORAD_LINK",action)
  return {
      ...state,
  }
} 
//,,,
case ON_START_GET_DASHBORAD_OBJEKT:{
  console.log("ON_START_GET_DASHBORAD_OBJEKT",action)
  return {
      ...state,
  }
} 
case ON_FETCH_DASHBORAD_OBJEKT:{
  console.log("ON_FETCH_DASHBORAD_OBJEKT",action)
  return {
      ...state,
      DashboardObjekt:action.payload.DashboardObjekt
  }
} 
case ON_ERROR_DASHBORAD_OBJEKT:{
  console.log("ON_ERROR_DASHBORAD_OBJEKT",action)
  return {
      ...state,
  }
} 
//ON_START_GET_DASHBORAD_LOOP_OBJEKT,ON_FETCH_DASHBORAD_LOOP_OBJEKT,ON_ERROR_DASHBORAD_LOOP_OBJEKT,
case ON_START_GET_DASHBORAD_LOOP_OBJEKT:{
  console.log("ON_START_GET_DASHBORAD_LOOP_OBJEKT",action)
  return {
      ...state,
  }
} 
case ON_FETCH_DASHBORAD_LOOP_OBJEKT:{
  console.log("ON_FETCH_DASHBORAD_LOOP_OBJEKT",action)
  return {
      ...state,
      DashboardLoopObjekt:action.payload.DashboardLoopObjekt
  }
} 
case ON_ERROR_DASHBORAD_LOOP_OBJEKT:{
  console.log("ON_ERROR_DASHBORAD_LOOP_OBJEKT",action)
  return {
      ...state,
  }
} 
//ON_START_NEW_PROSPEKT_FALT, ON_NEW_PROSPEKT_FALT, ON_ERROR_PROSPEKT_FALT,
case ON_START_NEW_PROSPEKT_FALT:{
  console.log("ON_START_NEW_PROSPEKT_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_NEW_PROSPEKT_FALT:{
  console.log("ON_NEW_PROSPEKT_FALT",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      prospektAvtalFreeInputsList:action.payload.prospektAvtalFreeInputsList
  }
} 
case ON_ERROR_PROSPEKT_FALT:{
  console.log("ON_ERROR_PROSPEKT_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.prospect.fields"),type:"error",loading:false},
      message:""
  }
} 
//ON_START_UPDATE_PROSPEKT_FALT, ON_UPDATE_PROSPEKT_FALT, ON_ERROR_UPDATE_PROSPEKT_FALT,
case ON_START_UPDATE_PROSPEKT_FALT:{
  console.log("ON_START_UPDATE_PROSPEKT_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_UPDATE_PROSPEKT_FALT:{
  console.log("ON_UPDATE_PROSPEKT_FALT",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      prospektAvtalFreeInputsList:action.payload.prospektAvtalFreeInputsList
  }
} 
case ON_ERROR_UPDATE_PROSPEKT_FALT:{
  console.log("ON_ERROR_UPDATE_PROSPEKT_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.prospect.fields.update"),type:"error",loading:false},
      message:""
  }
} 
//
//ON_START_NEW_ORDER_FALT, ON_NEW_ORDER_FALT, ON_ERROR_ORDER_FALT,
case ON_START_NEW_ORDER_FALT:{
  console.log("ON_START_NEW_ORDER_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_NEW_ORDER_FALT:{
  console.log("ON_NEW_ORDER_FALT",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      OrderFreeInputsList:action.payload.OrderFreeInputsList
  }
} 
case ON_ERROR_ORDER_FALT:{
  console.log("ON_ERROR_ORDER_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.order.fields"),type:"error",loading:false},
      message:""
  }
} 

//OrderFreeInputsList
//ON_START_DELETE_PROSPEKT_FALT, ON_DELETE_PROSPEKT_FALT, ON_ERROR_DELETE_PROSPEKT_FALT,
case ON_START_DELETE_PROSPEKT_FALT:{
  console.log("ON_START_DELETE_PROSPEKT_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_DELETE_PROSPEKT_FALT:{
  console.log("ON_DELETE_PROSPEKT_FALT",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      prospektAvtalFreeInputsList:action.payload.prospektAvtalFreeInputsList
  }
} 
case ON_ERROR_DELETE_PROSPEKT_FALT:{
  console.log("ON_ERROR_DELETE_PROSPEKT_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.prospect.fields.delete"),type:"error",loading:false},
      message:""
  }
} 
//
case ON_START_DELETE_ORDER_FALT:{
  console.log("ON_START_DELETE_ORDER_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{},
      OrderFreeInputsList:[]
  }
} 
case ON_DELETE_ORDER_FALT:{
  console.log("ON_DELETE_ORDER_FALT",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      OrderFreeInputsList:action.payload.OrderFreeInputsList
  }
} 
case ON_ERROR_DELETE_ORDER_FALT:{
  console.log("ON_ERROR_DELETE_ORDER_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Order.fields.delete"),type:"error",loading:false},
      message:""
  }
} 
//
case ON_START_UPDATE_ORDER_FALT:{
  console.log("ON_START_UPDATE_ORDER_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_UPDATE_ORDER_FALT:{
  console.log("ON_UPDATE_ORDER_FALT",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      OrderFreeInputsList:action.payload.OrderFreeInputsList
  }
} 
case ON_ERROR_UPDATE_ORDER_FALT:{
  console.log("ON_ERROR_UPDATE_ORDER_FALT",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Order.fields.update"),type:"error",loading:false},
      message:""
  }
} 
//ON_START_GET_TILLGODO_KUND,ON_FETCH_TILLGODO_KUND,ON_ERROR_TILLGODO_KUND,
case ON_START_GET_TILLGODO_KUND:{
  console.log("ON_START_GET_TILLGODO_KUND",action)
  return {
      ...state,
  }
} 
case ON_FETCH_TILLGODO_KUND:{
  console.log("ON_FETCH_TILLGODO_KUND",action)
  return {
      ...state,
     TillGodoObject:action.payload.TillGodoObject
  }
} 
case ON_ERROR_TILLGODO_KUND:{
  console.log("ON_ERROR_TILLGODO_KUND",action)
  return {
      ...state,
      message: translate("Error.Customer")
  }
} 
//ON_START_INSERT_TILLGODO_KUND, ON_INSERT_TILLGODO_KUND, ON_ERROR_INSERT_TILLGODO_KUND,
case ON_START_INSERT_TILLGODO_KUND:{
  console.log("ON_START_INSERT_TILLGODO_KUND",action)
  return {
      ...state,
  }
} 
case ON_INSERT_TILLGODO_KUND:{
  console.log("ON_INSERT_TILLGODO_KUND",action)
  return {
      ...state,
      message: translate("Action.Customer.save"),
     TillGodoObject:action.payload.TillGodoObject
  }
} 
case ON_ERROR_INSERT_TILLGODO_KUND:{
  console.log("ON_ERROR_INSERT_TILLGODO_KUND",action)
  return {
      ...state,
      message: translate("Error.Customer")
  }
} 
//ON_START_NEW_CASE_TYPE,   ON_NEW_CASE_TYPE,   ON_ERROR_NEW_CASE_TYPE,
case ON_START_NEW_CASE_TYPE:{
  console.log("ON_START_NEW_CASE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_NEW_CASE_TYPE:{
  console.log("ON_NEW_CASE_TYPE",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ArandeList:action.payload.ArandeList
  }
} 
case ON_ERROR_NEW_CASE_TYPE:{
  console.log("ON_ERROR_NEW_CASE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Accout.Case.Type"),type:"error",loading:false},
      message:""
  }
}
//ON_START_GET_ARANDETYP_KUND,ON_FETCH_ARANDETYP_KUND,ON_ERROR_ARANDETYP_KUND,
case ON_START_GET_ARANDETYP_KUND:{
  console.log("ON_START_GET_ARANDETYP_KUND",action)
  return {
      ...state,
      ATLoading:true,
  }
} 
case ON_FETCH_ARANDETYP_KUND:{
  console.log("ON_FETCH_ARANDETYP_KUND",action)
  return {
      ...state,
      ATLoading:false,
      ArandeList:action.payload.ArandeList
  }
} 
case ON_ERROR_ARANDETYP_KUND:{
  console.log("ON_ERROR_ARANDETYP_KUND",action)
  return {
      ...state,
      ATLoading:false,
      message: translate("Error.Customer")
  }
}
//
case ON_START_NEW_CASE_CATE_TYPE:{
  console.log("ON_START_NEW_CASE_CATE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_NEW_CASE_CATE_TYPE:{
  console.log("ON_NEW_CASE_CATE_TYPE",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ArandeList:action.payload.ArandeList
  }
} 
case ON_ERROR_NEW_CASE_CATE_TYPE:{
  console.log("ON_ERROR_NEW_CASE_CATE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Accout.Case.Cate.Type"),type:"error",loading:false},
      message:""
  }
}
//
case ON_START_DELETE_CASE_CATE_TYPE:{
  console.log("ON_START_DELETE_CASE_CATE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_DELETE_CASE_CATE_TYPE:{
  console.log("ON_DELETE_CASE_CATE_TYPE",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      ArandeList:action.payload.ArandeList
  }
} 
case ON_ERROR_DELETE_CASE_CATE_TYPE:{
  console.log("ON_ERROR_DELETE_CASE_CATE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Accout.Case.Cate.Type.delete"),type:"error",loading:false},
      message:""
  }
}
//
case ON_START_DELETE_CASE_TYPE:{
  console.log("ON_START_DELETE_CASE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_DELETE_CASE_TYPE:{
  console.log("ON_DELETE_CASE_TYPE",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      ArandeList:action.payload.ArandeList
  }
} 
case ON_ERROR_DELETE_CASE_TYPE:{
  console.log("ON_ERROR_DELETE_CASE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Accout.Case.Type.delete"),type:"error",loading:false},
      message:""
  }
}
//
case ON_START_NEW_ARANDE_EMAIL:{
  console.log("ON_START_NEW_ARANDE_EMAIL",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{},
    ATLoading:true
  }
}
case ON_NEW_ARANDE_EMAIL:{
  console.log("ON_NEW_ARANDE_EMAIL",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    ArandeMail:action.payload.ArandeMail,
    ATLoading:false
  }
}
case ON_ERROR_NEW_ARANDE_EMAIL:{
  console.log("ON_ERROR_NEW_ARANDE_EMAIL",action)
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Accout.Case.Email"),type:"error",loading:false},
    message:"",
    ATLoading:false
  }
}
//, , ,
case ON_START_UPDATEN_ARANDE_EMAIL:{
  console.log("ON_START_UPDATEN_ARANDE_EMAIL",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{},
    ATLoading:true
  }
}
case ON_UPDATEN_ARANDE_EMAIL:{
  console.log("ON_UPDATEN_ARANDE_EMAIL",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    ArandeMail:action.payload.ArandeMail,
    ATLoading:false
  }
}
case ON_ERROR_UPDATEN_ARANDE_EMAIL:{
  console.log("ON_ERROR_UPDATEN_ARANDE_EMAIL",action)
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Accout.Case.Email.update"),type:"error",loading:false},
    message:"",
    ATLoading:false
  }
}
//ON_START_DELETE_ARANDE_EMAIL,ON_DELETE_ARANDE_EMAIL,ON_ERROR_ARANDE_ORDER_EMAIL,
case ON_START_DELETE_ARANDE_EMAIL:{
  console.log("ON_START_DELETE_ARANDE_EMAIL",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{},
    ATLoading:true
  }
}
case ON_DELETE_ARANDE_EMAIL:{
  console.log("ON_DELETE_ARANDE_EMAIL",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
    ArandeMail:action.payload.ArandeMail,
    ATLoading:false
  }
}
case ON_ERROR_DELETE_ARANDE_EMAIL:{
  console.log("ON_ERROR_DELETE_ARANDE_EMAIL",action)
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Accout.Case.Email.delete"),type:"error",loading:false},
    message:"",
    ATLoading:false
  }
}
//,,,
case ON_START_FETCH_UTOKNING:{
  console.log("ON_START_FETCH_UTOKNING",action)
  return {
    ...state,
    message:"",
  }
}
case ON_FETCH_UTOKNING:{
  console.log("ON_FETCH_UTOKNING",action)
  return {
    ...state,
    Utokning:action.payload.Utokning,
  }
}
case ON_ERROR_FETCH_UTOKNING:{
  console.log("ON_ERROR_FETCH_UTOKNING",action)
  return {
    ...state,
  }
}

case ON_START_FETCH_UTOKNING_DYNAMIC_FIELDS:{
  console.log("ON_START_FETCH_UTOKNING_DYNAMIC_FIELDS",action)
  return {
    ...state,
    message:"",
  }
}
case ON_FETCH_UTOKNING_DYNAMIC_FIELDS:{
  console.log("ON_FETCH_UTOKNING_DYNAMIC_FIELDS",action)
  return {
    ...state,
    UtokningDynamicFields:action.payload.UtokningDynamicFields,
  }
}
case ON_ERROR_FETCH_UTOKNING_DYNAMIC_FIELDS:{
  console.log("ON_ERROR_FETCH_UTOKNING_DYNAMIC_FIELDS",action)
  return {
    ...state,
  }
}

case ON_START_GET_UTOKNING_KUND_LIST_BY_TYPE:{
  console.log("ON_START_GET_UTOKNING_KUND_LIST_BY_TYPE",action)
  return {
    ...state,
    message:"",
  }
}
case ON_GET_UTOKNING_KUND_LIST_BY_TYPE:{
  console.log("ON_GET_UTOKNING_KUND_LIST_BY_TYPE",action)
  return {
    ...state,
    UtokningKundList:action.payload.UtokningKundList,
  }
}
case ON_ERROR_GET_UTOKNING_KUND_LIST_BY_TYPE:{
  console.log("ON_ERROR_GET_UTOKNING_KUND_LIST_BY_TYPE",action)
  return {
    ...state,
  }
}
//Utokning
//ON_START_BESTALLA_FORTNOX, ON_BESTALLA_FORTNOX, ON_ERROR_BESTALLA_FORTNOX,
case ON_START_BESTALLA_FORTNOX:{
  console.log("ON_START_BESTALLA_FORTNOX",action)
  return {
    ...state,
    ResponseKontoMsg:{},
    message:""
  }
}
case ON_BESTALLA_FORTNOX:{
  console.log("ON_BESTALLA_FORTNOX",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    FortNox:action.payload.FortNox
  }
}
case ON_ERROR_BESTALLA_FORTNOX:{
  console.log("ON_ERROR_BESTALLA_FORTNOX",action)
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_AF_FORTNOX,ON_GET_AF_FORTNOX,ON_ERROR_GET_AF_FORTNOX,
case ON_START_GET_AF_FORTNOX:{
  console.log("ON_START_GET_AF_FORTNOX",action)
  return {
    ...state,
    message:""
  }
}
case ON_GET_AF_FORTNOX:{
  console.log("ON_GET_AF_FORTNOX",action)
  return {
    ...state,
    message:"",
    FortNox:action.payload.FortNox
  }
}
case ON_ERROR_GET_AF_FORTNOX:{
  console.log("ON_ERROR_GET_AF_FORTNOX",action)
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_GET_AF_DFORTNOX,ON_GET_AF_DFORTNOX,ON_ERROR_GET_AF_DFORTNOX,
case ON_START_GET_AF_DFORTNOX:{
  console.log("ON_START_GET_AF_DFORTNOX",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{},
    FortNoxisLoading:true
  }
}
case ON_GET_AF_DFORTNOX:{
  console.log("ON_GET_AF_DFORTNOX",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
    FortNox:"",
    FortNoxisLoading:false
  }
}
case ON_ERROR_GET_AF_DFORTNOX:{
  console.log("ON_ERROR_GET_AF_DFORTNOX",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:translate("Error.Account.Fortnox.disconnect"),type:"error",loading:false},
    FortNoxisLoading:false
  }
}

//
case ON_START_GET_AF_LFORTNOX:{
  console.log("ON_START_GET_AF_LFORTNOX",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{},
    FortNoxisLoading:true
  }
}
case ON_GET_AF_LFORTNOX:{
  console.log("ON_GET_AF_LFORTNOX",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    FortNox:action.payload.FortNox,
    FortNoxisLoading:false
  }
}
case ON_ERROR_GET_AF_LFORTNOX:{
  console.log("ON_ERROR_GET_AF_LFORTNOX",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:translate("Error.Account.Fortnox.update"),type:"error",loading:false},
    FortNoxisLoading:false
  }
}
//
case ON_START_GET_AF_FORTNOX_KUNDER:{
  console.log("ON_START_GET_AF_FORTNOX_KUNDER",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{},
    FortNoxisLoading:true
  }
}
case ON_GET_AF_FORTNOX_KUNDER:{
  console.log("ON_GET_AF_FORTNOX_KUNDER",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    FortNoxisLoading:false
  }
}
case ON_ERROR_GET_AF_FORTNOX_KUNDER:{
  console.log("ON_ERROR_GET_AF_FORTNOX_KUNDER",action)
  return {
    ...state,
    ResponseKontoMsg:{msg:isUndefined(action.payload)?"Error":action.payload,type:"error",loading:false},
    message:"",
    FortNoxisLoading:false
  }
}
//ON_START_GET_AF_FORTNOX_ARTIKLAR,ON_GET_AF_FORTNOX_ARTIKLAR,ON_ERROR_GET_AF_FORTNOX_ARTIKLAR,
case ON_START_GET_AF_FORTNOX_ARTIKLAR:{
  console.log("ON_START_GET_AF_FORTNOX_ARTIKLAR",action)
  return {
    ...state,
    ResponseKontoMsg:{},
    message:"",
    FortNoxisLoading:true
  }
}
case ON_GET_AF_FORTNOX_ARTIKLAR:{
  console.log("ON_GET_AF_FORTNOX_ARTIKLAR",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    FortNoxisLoading:false
  }
}
case ON_ERROR_GET_AF_FORTNOX_ARTIKLAR:{
  console.log("ON_ERROR_GET_AF_FORTNOX_ARTIKLAR",action)
  return {
    ...state,
    ResponseKontoMsg:{msg:isUndefined(action.payload.message)?translate("Error.Account.Fortnox.Items.fetch"):action.payload.message,type:"error",loading:false},
    message:"",
    FortNoxisLoading:false
  }
}
//ON_START_GET_AF_FORTNOX_ORDER,ON_GET_AF_FORTNOX_ORDER,ON_ERROR_GET_AF_FORTNOX_ORDER,
case ON_START_GET_AF_FORTNOX_ORDER:{
  console.log("ON_START_GET_AF_FORTNOX_ORDER",action)
  return {
    ...state,
    ResponseKontoMsg:{},
    message:"",
    FortNoxisLoading:true
  }
}
case ON_GET_AF_FORTNOX_ORDER:{
  console.log("ON_GET_AF_FORTNOX_ORDER",action)
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    message:"",
    FortNoxisLoading:false
  }
}
case ON_ERROR_GET_AF_FORTNOX_ORDER:{
  console.log("ON_ERROR_GET_AF_FORTNOX_ORDER",action)
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Fortnox.Orders.fetch"),type:"error",loading:false},
    message:"",
    FortNoxisLoading:false
  }
}
//ON_START_GET_AF_FORTNOX_OFFERT,ON_GET_AF_FORTNOX_OFFERT,ON_ERROR_GET_AF_FORTNOX_OFFERT,
case ON_START_GET_AF_FORTNOX_OFFERT:{
  console.log("ON_START_GET_AF_FORTNOX_OFFERT",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{},
    FortNoxisLoading:true
  }
}
case ON_GET_AF_FORTNOX_OFFERT:{
  console.log("ON_GET_AF_FORTNOX_OFFERT",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    FortNoxisLoading:false
  }
}
case ON_ERROR_GET_AF_FORTNOX_OFFERT:{
  console.log("ON_ERROR_GET_AF_FORTNOX_OFFERT",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{msg:translate("Error.Account.Fortnox.Offers.fetch"),type:"error",loading:false},
    FortNoxisLoading:false
  }
}
//ON_START_FORTNOX_CONNECT_KUND,ON_FORTNOX_CONNECT_KUND,ON_ERROR_FORTNOX_CONNECT_KUND,
case ON_START_FORTNOX_CONNECT_KUND:{
  console.log("ON_START_FORTNOX_CONNECT_KUND",action)
  return {
    ...state,
    message:"",
    ResponseKundMsg:{msg:translate("Action.Customer.Fortnox.fetching"),type:"info",loading:true},
    FortNoxisLoading:false
  }
}
case ON_FORTNOX_CONNECT_KUND:{
  console.log("ON_FORTNOX_CONNECT_KUND",action)
  let Kund = state.currentKund.Kund[0]
  let Kund2 = {
    ...Kund,
    FortnoxKundNR:action.payload.KundNummer
  }
  let KundArr=[]
  KundArr.push(Kund2)
  return {
    ...state,
    ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
    message:"",
    FortNoxUppgifter:action.payload.FortNoxUppgifter,
    currentKund:{
      ...state.currentKund,
      Kund:KundArr
    },
    FortNoxisLoading:false
  }
}
case ON_ERROR_FORTNOX_CONNECT_KUND:{
  console.log("ON_ERROR_FORTNOX_CONNECT_KUND",action)
  return {
    ...state,
    ResponseKundMsg:{msg:action.payload,type:"error",loading:false},
    message:action.payload,
    FortNoxisLoading:false
  }
}
//ON_START_FORTNOX_EDITKUND, ON_FORTNOX_EDITKUND, ON_ERROR_FORTNOX_EDITKUND,
case ON_START_FORTNOX_EDITKUND:{
  console.log("ON_START_FORTNOX_EDITKUND",action)
  return {
    ...state,
    message:"",
    ResponseKundMsg:{msg:translate("Action.Customer.Fortnox.saving"),type:"info",loading:true},
    FortNoxisLoading:false
  }
}
case ON_FORTNOX_EDITKUND:{
  console.log("ON_FORTNOX_NEWKUND",action)
  let Kund = state.currentKund.Kund[0]
  let Kund2 = {
    ...Kund,
    FortnoxKundNR:action.payload.KundNummer
  }
  let KundArr=[]
  KundArr.push(Kund2)
  return {
    ...state,
    ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
    message:"",
    FortNoxUppgifter:action.payload.FortNoxUppgifter,
    currentKund:{
      ...state.currentKund,
      Kund:KundArr
    },
    FortNoxisLoading:false
  }
}
case ON_ERROR_FORTNOX_EDITKUND:{
  console.log("ON_ERROR_FORTNOX_NEWKUND",action)
  return {
    ...state,
    ResponseKundMsg:{msg:action.payload,type:"error",loading:false},
    message:action.payload,
    FortNoxisLoading:false
  }
}
//ON_START_FORTNOX_NEWKUND, ON_FORTNOX_NEWKUND, ON_ERROR_FORTNOX_NEWKUND,
case ON_START_FORTNOX_NEWKUND:{
  console.log("ON_START_FORTNOX_NEWKUND",action)
  return {
    ...state,
    message:"",
    ResponseKundMsg:{msg:translate("Action.Customer.Fortnox.creating"),type:"info",loading:true},
    FortNoxisLoading:false
  }
}
case ON_FORTNOX_NEWKUND:{
  console.log("ON_FORTNOX_NEWKUND",action)
  let Kund = state.currentKund.Kund[0]
  let Kund2 = {
    ...Kund,
    FortnoxKundNR:action.payload.KundNummer
  }
  let KundArr=[]
  KundArr.push(Kund2)
  return {
    ...state,
    ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
    message:"",
    FortNoxUppgifter:action.payload.FortNoxUppgifter,
    currentKund:{
      ...state.currentKund,
      Kund:KundArr
    },
    FortNoxisLoading:false
  }
}
case ON_ERROR_FORTNOX_NEWKUND:{
  console.log("ON_ERROR_FORTNOX_NEWKUND",action)
  return {
    ...state,
    ResponseKundMsg:{msg:action.payload,type:"error",loading:false},
    message:action.payload,
    FortNoxisLoading:false
  }
}
//FortNoxisLoading
//ON_START_FORTNOX_DELKUND, ON_FORTNOX_DELKUND, ON_ERROR_FORTNOX_DELKUND,
case ON_START_FORTNOX_DELKUND:{
  console.log("ON_START_FORTNOX_DELKUND",action)
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Action.Customer.Fortnox.deleting"),type:"info",loading:true},
    message:"",
    FortNoxisLoading:false
  }
}
case ON_FORTNOX_DELKUND:{
  console.log("ON_FORTNOX_DELKUND",action)
  let Kund = state.currentKund.Kund[0]
  let Kund2 = {
    ...Kund,
    FortnoxKundNR:""
  }
  let KundArr=[]
  KundArr.push(Kund2)
  return {
    ...state,
    ResponseKundMsg:{msg:action.payload.message,type:"warning",loading:false},
    message:"",
    FortNoxUppgifter:{},
    currentKund:{
      ...state.currentKund,
      Kund:KundArr
    },
    FortNoxisLoading:false
  }
}
case ON_ERROR_FORTNOX_DELKUND:{
  console.log("ON_ERROR_FORTNOX_DELKUND",action)
  return {
    ...state,
    message:"",
    ResponseKundMsg:{msg:action.payload,type:"error",loading:false},
    FortNoxisLoading:false
  }
}
//ON_START_GET_AF_FORTNOX_KUND,ON_GET_AF_FORTNOX_KUND,ON_ERROR_GET_AF_FORTNOX_KUND,
case ON_START_GET_AF_FORTNOX_KUND:{
  console.log("ON_START_GET_AF_FORTNOX_KUND",action)
  return {
    ...state,
    message:"",
    ResponseKontoMsg:{},
    FortNoxisLoading:false
  }
}
case ON_GET_AF_FORTNOX_KUND:{
  console.log("ON_GET_AF_FORTNOX_KUND",action)
  return {
    ...state,
    FortNoxUppgifter:action.payload.FortNoxUppgifter,
    FortNoxisLoading:false
  }
}
case ON_ERROR_GET_AF_FORTNOX_KUND:{
  console.log("ON_ERROR_GET_AF_FORTNOX_KUND",action)
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"error",loading:false},
    FortNoxisLoading:false
  }
}
//ON_START_OFFICE_ALL_USERS, ON_OFFICE_ALL_USERS, ON_ERROR_OFFICE_ALL_USERS,
case ON_START_OFFICE_ALL_USERS:{
  console.log("ON_START_OFFICE_ALL_USERS",action)
  return {
    ...state,
    message:""
  }
}
case ON_OFFICE_ALL_USERS:{
  console.log("ON_OFFICE_ALL_USERS",action)
  return {
    ...state,
    OfficeUsers:action.payload.OfficeUsers,
  }
}
case ON_ERROR_OFFICE_ALL_USERS:{
  console.log("ON_ERROR_OFFICE_ALL_USERS",action)
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_OFFICE_UPDATE_USER, ON_OFFICE_UPDATE_USER, ON_ERROR_OFFICE_UPDATE_USER,
case ON_START_OFFICE_UPDATE_USER:{
  console.log("ON_START_OFFICE_UPDATE_USER",action)
  return {
    ...state,
    message:""
  }
}
case ON_OFFICE_UPDATE_USER:{
  console.log("ON_OFFICE_UPDATE_USER",action)
  return {
    ...state,
    message:translate("Action.save"),
    OfficeUsers:action.payload.OfficeUsers,
  }
}
case ON_ERROR_OFFICE_UPDATE_USER:{
  console.log("ON_ERROR_OFFICE_UPDATE_USER",action)
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//OfficeUsers
//
case ON_START_OFFICE_GET:{
  console.log("ON_START_OFFICE_GET",action)
  return {
    ...state,
    isLoading:true,
    Office:{},
    message:""
  }
}
case ON_OFFICE_GET:{
  console.log("ON_OFFICE_GET",action)
  return {
    ...state,
    message:"",
    isLoading:false,
    Office:action.payload.Office,
  }
}
case ON_ERROR_OFFICE_GET:{
  console.log("ON_ERROR_OFFICE_GET",action)
  return {
    ...state,
    isLoading:false,
    message: translate("Error.Customer"),
  }
}
//ON_START_BLACK_LIST, ON_BLACK_LIST, ON_ERROR_BLACK_LIST,
case ON_START_BLACK_LIST:{
  console.log("ON_START_BLACK_LIST",action)
  return {
    ...state,
    message:"",
    isLoading:true
  }
}
case ON_BLACK_LIST:{
  console.log("ON_BLACK_LIST",action)
  return {
    ...state,
    message:translate("Action.Done"),
    isLoading:false,
  }
}
case ON_ERROR_BLACK_LIST:{
  console.log("ON_ERROR_BLACK_LIST",action)
  return {
    ...state,
    isLoading:false,
    message: translate("Error.Customer"),
  }
}
//, , ,
case ON_START_FORTNOX_KUND_FAKTUROR:{
  console.log("ON_START_FORTNOX_KUND_FAKTUROR",action)
  return {
    ...state,
    message:"",
 //   KundFortnoxFak:[],
//    FortNoxisLoading:true
  }
}
case ON_RESET_FORTNOX_KUND_FAKTUROR:{
  console.log("ON_RESET_FORTNOX_KUND_FAKTUROR",action)
  return {
    ...state,
   // message:"",
    KundFortnoxFak:[],
//    FortNoxisLoading:true
  }
}
case ON_FORTNOX_KUND_FAKTUROR:{
  console.log("ON_FORTNOX_KUND_FAKTUROR",action)
  return {
    ...state,
    KundFortnoxFak:action.payload.KundFortnoxFak,
  //  FortNoxisLoading:false,
  }
}
case ON_ERROR_FORTNOX_KUND_FAKTUROR:{
  console.log("ON_ERROR_FORTNOX_KUND_FAKTUROR",action)
  return {
    ...state,
    //FortNoxisLoading:false,
    message:"",
  }
}
//,ON_FORTNOX_FAKTUROR_CONNECT,ON_ERROR_FORTNOX_FAKTUROR_CONNECT,
case ON_START_FORTNOX_FAKTUROR_CONNECT:{
  console.log("ON_START_FORTNOX_FAKTUROR_CONNECT",action)
  return {
    ...state,
    FortNoxisLoading:false,
  }
}
case ON_FORTNOX_FAKTUROR_CONNECT:{
  console.log("ON_FORTNOX_FAKTUROR_CONNECT",action)
  let newInvoices=[]
  for(let item of state.KundFortnoxFak){
    if(parseInt(item.DocumentNumber) === parseInt(action.payload.FakturaNr)){
      newInvoices.push( {...item,
        AvtalId:action.payload.AvtalId,
        SourceText:action.payload.SourceText,
        Source:action.payload.Source,
        OwnerID:action.payload.OwnerID,
        OwnerName:action.payload.OwnerName,
      })
    }else{
      newInvoices.push(item)
    }
  }
  return {
    ...state,
    KundFortnoxFak:newInvoices,
    ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
    message:"",
  }
}
case ON_ERROR_FORTNOX_FAKTUROR_CONNECT:{
  console.log("ON_ERROR_FORTNOX_FAKTUROR_CONNECT",action)
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Invoices.Contract"),type:"error",loading:false},
    message:"",
  }
}
//  ON_START_FORTNOX_FAKTUROR_DOWNLOAD,ON_FORTNOX_FAKTURO_DOWNLOAD,ON_ERROR_FORTNOX_FAKTUROR_DOWNLOAD,
case ON_START_FORTNOX_FAKTUROR_DOWNLOAD:{
  console.log("ON_START_FORTNOX_FAKTUROR_DOWNLOAD",action)
  return {
      ...state,  
    //  RapportFile:[] 
  }
}
case ON_FORTNOX_FAKTURO_DOWNLOAD:{
  console.log("ON_FORTNOX_FAKTURO_DOWNLOAD",action)
  return {
      ...state
    //  RapportFile:action.payload.AdminStatistik,
  }
}
case ON_ERROR_FORTNOX_FAKTUROR_DOWNLOAD:{
  console.log("ON_ERROR_FORTNOX_FAKTUROR_DOWNLOAD",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Invoices.download"),type:"error",loading:false},
      message:""
  }
}  
//ON_START_FORTNOX_FAKTUROR_CANCEL, ON_FORTNOX_FAKTUROR_CANCEL, ON_ERROR_FORTNOX_FAKTUROR_CANCEL,
case ON_START_FORTNOX_FAKTUROR_CANCEL:{
  console.log("ON_START_FORTNOX_FAKTUROR_CANCEL",action)
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Action.Account.Invoice.deleting"),type:"info",loading:true},
    FortNoxisLoading:false,
  }
}
case ON_FORTNOX_FAKTUROR_CANCEL:{
  console.log("ON_FORTNOX_FAKTUROR_CANCEL",action)
  let newInvoices=[]
  for(let item of state.KundFortnoxFak){
    if(parseInt(item.DocumentNumber) === parseInt(action.payload.FakturaNr)){
      newInvoices.push( {...item,
        Cancelled:true
      })
    }else{
      newInvoices.push(item)
    }
  }
  return {
    ...state,
    KundFortnoxFak:newInvoices,
    ResponseKundMsg:{msg:translate("Action.Account.Invoice.cancel",`Faktura ${action.payload.FakturaNr} har avbrytats`,{item:action.payload.FakturaNr}),type:"warning",loading:false},
    message:"",
  }
}
case ON_ERROR_FORTNOX_FAKTUROR_CANCEL:{
  console.log("ON_ERROR_FORTNOX_FAKTUROR_CANCEL",action)
  return {
    ...state,
    ResponseKundMsg:{msg:action.payload,type:"error",loading:false},
    message:"",
  }
}
//ON_START_FORTNOX_FAKTURA_GET, ON_FORTNOX_FAKTURA_GET, ON_ERROR_FORTNOX_FAKTURA_GET,
      case ON_START_FORTNOX_FAKTURA_GET: {
        console.log("ON_START_FORTNOX_FAKTURA_GET", action)
        return {
          ...state,
          CurrentFaktura:{}
        }
      }
      case ON_FORTNOX_FAKTURA_GET: {
        console.log("ON_FORTNOX_FAKTURA_GET", action)
        return {
          ...state,
          CurrentFaktura:action.payload.CurrentFaktura,
        }
      }
      case ON_ERROR_FORTNOX_FAKTURA_GET: {
        console.log("ON_ERROR_FORTNOX_FAKTURA_GET", action)
        return {
          ...state,
          ResponseKundMsg:{msg:translate("Error.Account.Invoices.fetch"),type:"error",loading:false},
          message: ""
        }
      }
//CurrentFaktura
//ON_START_FORTNOX_FAKTUROR_SEND,ON_FORTNOX_FAKTUROR_SEND,ON_ERROR_FORTNOX_FAKTUROR_SEND,
      case ON_START_FORTNOX_FAKTUROR_SEND: {
        console.log("ON_START_FORTNOX_FAKTUROR_SEND", action)
        return {
          ...state,
          ResponseKundMsg:{msg:translate("Action.Account.Invoices.sending"),type:"info",loading:true},
          FortNoxisLoading: false,
        }
      }
      case ON_FORTNOX_FAKTUROR_SEND: {
        console.log("ON_FORTNOX_FAKTUROR_SEND", action)
        let newInvoices = []
        for (let item of state.KundFortnoxFak) {
          if (parseInt(item.DocumentNumber) === parseInt(action.payload.FakturaNr)) {
            newInvoices.push({
              ...item,
              Sent: true
            })
          } else {
            newInvoices.push(item)
          }
        }
        return {
          ...state,
          KundFortnoxFak: newInvoices,
          ResponseKundMsg:{msg:translate("Action.Account.Invoices.send",`Faktura ${action.payload.FakturaNr} har skickats`,{item:action.payload.FakturaNr}),type:"success",loading:false},
          message: "",
        }
      }
      case ON_ERROR_FORTNOX_FAKTUROR_SEND: {
        console.log("ON_ERROR_FORTNOX_FAKTUROR_SEND", action)
        return {
          ...state,
          ResponseKundMsg:{msg:action.payload,type:"error",loading:false},
          message: "",
        }
      }
//ON_START_FORTNOX_FAKTUROR_EDIT,ON_FORTNOX_FAKTUROR_EDIT,ON_ERROR_FORTNOX_FAKTUROR_EDIT,
case ON_START_FORTNOX_FAKTUROR_EDIT: {
  console.log("ON_START_FORTNOX_FAKTUROR_EDIT", action)
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Action.Account.Invoices.saving"),type:"info",loading:true},
    FortNoxisLoading: false,
  }
}
case ON_FORTNOX_FAKTUROR_EDIT: {
  return {
    ...state,
    ResponseKundMsg:{msg:action.payload.message,type:"success",loading:true},
    CurrentFaktura:action.payload.CurrentFaktura,
  }
}
case ON_ERROR_FORTNOX_FAKTUROR_EDIT: {
  console.log("ON_ERROR_FORTNOX_FAKTUROR_EDIT", action)
  return {
    ...state,
    ResponseKundMsg:{msg:action.payload,type:"error",loading:false},
    message: "",
  }
}
//
case ON_START_FORTNOX_FAKTUROR_NEW: {
  console.log("ON_START_FORTNOX_FAKTUROR_NEW", action)
  return {
    ...state,
    FortnoxisActionDone:0,
    FortNoxisLoading: false,
    ResponseKundMsg:{msg:translate("Action.Customer.fetching"),type:"info",loading:true},
    message: "",
  }
}
case ON_FORTNOX_FAKTUROR_NEW: {
  return {
    ...state,
    FortnoxisActionDone:1,
    ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
    message: action.payload.message,
  }
}
case ON_ERROR_FORTNOX_FAKTUROR_NEW: {
  console.log("ON_ERROR_FORTNOX_FAKTUROR_NEW", action)
  return {
    ...state,
    FortnoxisActionDone:2,
    ResponseKundMsg:{msg:action.payload.error,type:"error",loading:false},
    message: action.payload.error,
  }
}
//ON_START_KUND_KALKYL_OPTIONS,ON_KUND_KALKYL_OPTIONS,ON_ERROR_KUND_KALKYL_OPTIONS,
case ON_START_KUND_KALKYL_OPTIONS: {
  console.log("ON_START_KUND_KALKYL_OPTIONS", action)
  return {
    ...state,
    KalkylOptions: [],    
  }
}
case ON_KUND_KALKYL_OPTIONS: {
  return {
    ...state,
    KalkylOptions: action.payload.KalkylOptions,
  }
}
case ON_ERROR_KUND_KALKYL_OPTIONS: {
  console.log("ON_ERROR_KUND_KALKYL_OPTIONS", action)
  return {
    ...state,
    message: "Error",
  }
}
//ON_START_DASHBORD_USERLIST, ON_DASHBORD_USERLIST, ON_ERROR_DASHBORD_USERLIST,
case ON_START_DASHBORD_USERLIST: {
  console.log("ON_START_DASHBORD_USERLIST", action)
  return {
    ...state,
    ResponseKontoMsg:{},
    KalkylOptions: [],    
  }
}
case ON_DASHBORD_USERLIST: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:action.payload.messagetype,loading:false},
    message: "",
    Userlista:action.payload.Users
  }
}
case ON_ERROR_DASHBORD_USERLIST: {
  console.log("ON_ERROR_DASHBORD_USERLIST", action)
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Dashboard.UserList"),type:"error",loading:false},
    message: "",
  }
}
//ON_START_GET_AF_LHOGIA,ON_GET_AF_LHOGIA,ON_ERROR_GET_AF_LHOGIA,


case ON_START_CONNECT_WOOCOMMERCE_WP_REST: {
  console.log("ON_START_CONNECT_WOOCOMMERCE_WP_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: true,
    ResponseKontoMsg:{},
    message: "",
  }
}
case ON_CONNECT_WOOCOMMERCE_WP_REST: {
  console.log("ON_CONNECT_WOOCOMMERCE_WP_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: false,
    Woocommerce: action.payload.Woocommerce,
    ResponseKontoMsg:{msg:translate("Action.Connect"),type:"success",loading:false},
    message: "",
  }
}
case ON_ERROR_CONNECT_WOOCOMMERCE_WP_REST: {
  console.log("ON_ERROR_CONNECT_WOOCOMMERCE_WP_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: false,
    ResponseKontoMsg:{msg:translate("Error.Account.Woocommerce.Connenct"),type:"error",loading:false},
    message: "",
  }
}
case ON_ERROR_DISCONNECT_WOOCOMMERCE_WP_REST: {
  console.log("ON_ERROR_DISCONNECT_WOOCOMMERCE_WP_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: false,
    ResponseKontoMsg:{msg:translate("Error.Account.Woocommerce.disconnect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message: "",
  }
}
case ON_START_DISCONNECT_WOOCOMMERCE_WP_REST: {
  console.log("ON_START_DISCONNECT_WOOCOMMERCE_WP_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: true,
    Woocommerce: [],
    ResponseKontoMsg:{},
    message: "",
  }
}
case ON_DISCONNECT_WOOCOMMERCE_WP_REST: {
  console.log("ON_DISCONNECT_WOOCOMMERCE_WP_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: false,
    Woocommerce: action.payload.Woocommerce,
    ResponseKontoMsg:{msg:translate("Action.disconnect"),type:"warning",loading:false},
    message: "",
  }
}

case ON_START_CONNECT_BITLOG_REST: {
  console.log("ON_START_CONNECT_BITLOG_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: true,
    ResponseKontoMsg:{},
    message: "",
  }
}
case ON_CONNECT_BITLOG_REST: {
  console.log("ON_CONNECT_BITLOG_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: false,
    Woocommerce: action.payload.Woocommerce,
    ResponseKontoMsg:{msg:translate("Action.Connect"),type:"success",loading:false},
    message: "",
  }
}
case ON_ERROR_CONNECT_BITLOG_REST: {
  console.log("ON_ERROR_CONNECT_BITLOG_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: false,
    ResponseKontoMsg:{msg:translate("Error.Account.Bitlog.Api"),type:"error",loading:false},
    message: "",
  }
}
case ON_ERROR_DISCONNECT_BITLOG_REST: {
  console.log("ON_ERROR_DISCONNECT_BITLOG_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: false,
    ResponseKontoMsg:{msg:translate("Error.Account.Bitlog.Api.disconnect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message: "",
  }
}
case ON_START_DISCONNECT_BITLOG_REST: {
  console.log("ON_START_DISCONNECT_BITLOG_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: true,
    Woocommerce: [],
    ResponseKontoMsg:{},
    message: "",
  }
}
case ON_DISCONNECT_BITLOG_REST: {
  console.log("ON_DISCONNECT_BITLOG_REST", action.payload)
  return {
    ...state,
    WoocommerceLoading: false,
    Woocommerce: action.payload.Woocommerce,
    ResponseKontoMsg:{msg:translate("Action.disconnect"),type:"warning",loading:false},
    message: "",
  }
}



case ON_START_CONNECT_WOOCOMMERCE: {
  console.log("ON_START_CONNECT_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: true,
    Woocommerce: [],
    ResponseKontoMsg:{},
    message: "",
  }
}
case ON_CONNECT_WOOCOMMERCE: {
  console.log("ON_CONNECT_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: false,
    Woocommerce: action.payload.Woocommerce,
    ResponseKontoMsg:{msg:translate("Action.Connect"),type:"success",loading:false},
    message: "",
  }
}
case ON_ERROR_CONNECT_WOOCOMMERCE: {
  console.log("ON_ERROR_CONNECT_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: false,
    ResponseKontoMsg:{msg:translate("Error.Account.Woocommerce.Connenct"),type:"error",loading:false},
    message: "",
  }
}
case ON_START_GET_WOOCOMMERCE: {
  console.log("ON_START_GET_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: true,
    Woocommerce: [],
    ResponseKontoMsg:{},
  }
}
case ON_GET_WOOCOMMERCE: {
  console.log("ON_START_GET_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: false,
    Woocommerce: action.payload.Woocommerce,
  }
}
case ON_ERROR_GET_WOOCOMMERCE: {
  console.log("ON_START_GET_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: false,
    Woocommerce: [],
    ResponseKontoMsg:{msg:translate("Error.Account.Woocommerce.get"),type:"error",loading:false},
    message: "",
  }
}
case ON_START_DISCONNECT_WOOCOMMERCE: {
  console.log("ON_START_DISCONNECT_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: true,
    Woocommerce: [],
    ResponseKontoMsg:{},
    message: "",
  }
}
case ON_DISCONNECT_WOOCOMMERCE: {
  console.log("ON_START_DISCONNECT_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: false,
    Woocommerce: action.payload.Woocommerce,
    ResponseKontoMsg:{msg:translate("Action.disconnect"),type:"warning",loading:false},
    message: "",
  }
}
case ON_ERROR_DISCONNECT_WOOCOMMERCE: {
  console.log("ON_START_DISCONNECT_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: false,
    ResponseKontoMsg:{msg:translate("Error.Account.Woocommerce.disconnect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message: "",
  }
}

case ON_START_CREATE_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_START_CREATE_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_CREATE_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_CREATE_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: false,
    currentKund: {...state.currentKund, Kund: action.payload.Kund},
    currentWoocommerceKund: action.payload.currentWoocommerceKund
  }
}
case ON_ERROR_CREATE_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_ERROR_CREATE_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: false,
    currentWoocommerceKund:[],
    ResponseKundMsg:{msg:translate("Error.Account.Woocommerce.Customer.Add","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message:"",
  }
}


case ON_START_CONNECT_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_START_CONNECT_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_CONNECT_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_CONNECT_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: false,
    currentKund: {...state.currentKund, Kund: action.payload.Kund},
    currentWoocommerceKund: action.payload.currentWoocommerceKund
  }
}
case ON_ERROR_CONNECT_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_ERROR_CONNECT_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: false,
    currentWoocommerceKund:[],
    ResponseKundMsg:{msg:translate("Error.Account.Woocommerce.Customer.Connect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message:"",
  }
}
case ON_START_DISCONNECT_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_START_DISCONNECT_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_DISCONNECT_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_DISCONNECT_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: false,
    currentKund: {...state.currentKund, Kund: action.payload.Kund},
    currentWoocommerceKund: action.payload.currentWoocommerceKund
  }
}
case ON_ERROR_DISCONNECT_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_ERROR_DISCONNECT_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: false,
    currentWoocommerceKund:[],
    ResponseKundMsg:{msg:translate("Error.Account.Woocommerce.Customer.disconnect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message:"" ,
  }
}
case ON_START_GET_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_START_GET_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_GET_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_GET_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: false,
    currentWoocommerceKund: action.payload.currentWoocommerceKund
  }
}
case ON_ERROR_GET_WOOCOMMERCE_CUSTOMER: {
  console.log("ON_ERROR_GET_WOOCOMMERCE_CUSTOMER", action)
  return {
    ...state,
    WoocommerceLoading: false,
    currentWoocommerceKund:[],
    ResponseKundMsg:{msg:translate("Error.Account.Woocommerce.Customer.fetch","Error: "+action.payload.message,{item:action.payload.message}),type:"error",loading:false},
    message:"",
  }
}

case ON_START_SYNC_WOOCOMMERCE_CUSTOMERS: {
  console.log("ON_START_SYNC_WOOCOMMERCE_CUSTOMERS", action)
  return {
    ...state,
    WoocommerceLoading: true,
  }
}
case ON_SYNC_WOOCOMMERCE_CUSTOMERS: {
  console.log("ON_SYNC_WOOCOMMERCE_CUSTOMERS", action)
  return {
    ...state,
    WoocommerceLoading: false,
  }
}
case ON_ERROR_SYNC_WOOCOMMERCE_CUSTOMERS: {
  console.log("ON_ERROR_SYNC_WOOCOMMERCE_CUSTOMERS", action)
  return {
    ...state,
    WoocommerceLoading: false,
    ResponseKundMsg:{msg:translate("Error.Account.Woocommerce.sync"),type:"error",loading:false},
    message: "",
  }
}

case ON_START_UPDATE_WOOCOMMERCE: {
  console.log("ON_START_UPDATE_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: true,
    // Woocommerce: [],
  }
}
case ON_UPDATE_WOOCOMMERCE: {
  console.log("ON_UPDATE_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: false,
    Woocommerce: action.payload.Woocommerce,
  }
}
case ON_ERROR_UPDATE_WOOCOMMERCE: {
  console.log("ON_ERROR_UPDATE_WOOCOMMERCE", action)
  return {
    ...state,
    WoocommerceLoading: false,
    ResponseKundMsg:{msg:translate("Error.Account.Woocommerce.update"),type:"error",loading:false},
    message: "",
  }
}

case ON_GET_WHOLESALESUTIE_ROLES: {
  return {
    ...state,
    WholesaleSuiteRoles:action.payload.WholesaleSuiteRoles,
  }
}
case ON_START_GET_WHOLESALESUTIE_ROLES: {
  return {
    ...state,
    WholesaleSuiteRoles:[]
  }
}
case ON_ERROR_GET_WHOLESALESUTIE_ROLES: {
  return {
    ...state,
    WholesaleSuiteRoles:[]
  }
}
case ON_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST: {
  return {
    ...state,
    WholesaleSuiteRoles:action.payload.WholesaleSuiteRoles,
    KundPrisListor: action.payload.KontoprisListor
  }
}
case ON_START_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST: {
  return {
    ...state,
  }
}
case ON_ERROR_CONNECT_WHOLESALESUTIE_ROLES_AFID_LIST: {
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Error.Account.Wholesalesutie.list.connect"),type:"error",loading:false},
  }
}
case ON_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Action.Account.Wholesalesutie.list"),type:"success",loading:false},
    WholesaleSuiteRoles:action.payload.WholesaleSuiteRoles,
    KundPrisListor: action.payload.KontoprisListor
  }
}
case ON_START_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST: {
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Action.Account.Wholesalesutie.list.creating"),type:"info",loading:true},
  }
}
case ON_ERROR_CREATE_WHOLESALESUTIE_ROLES_AFID_LIST: {
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Error.Account.Wholesalesutie.list.creating"),type:"error",loading:false},
  }
}

case ON_START_CONNECT_PYRAMID: {
  console.log("ON_START_CONNECT_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: true,
    Pyramid: [],
    ResponseKontoMsg:{},
    message: "",
  }
}
case ON_CONNECT_PYRAMID: {
  console.log("ON_CONNECT_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: false,
    Pyramid: action.payload.Pyramid,
    ResponseKontoMsg:{msg:translate("Action.Connect"),type:"success",loading:false},
    message: "",
  }
}
case ON_ERROR_CONNECT_PYRAMID: {
  console.log("ON_ERROR_CONNECT_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: false,
    ResponseKontoMsg:{msg:translate("Error.Account.Pyramid.connect"),type:"error",loading:false},
    message: "",
  }
}
case ON_START_GET_PYRAMID: {
  console.log("ON_START_GET_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: true,
    Pyramid: [],
    ResponseKontoMsg:{},
  }
}
case ON_GET_PYRAMID: {
  console.log("ON_START_GET_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: false,
    Pyramid: action.payload.Pyramid,
  }
}
case ON_ERROR_GET_PYRAMID: {
  console.log("ON_START_GET_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: false,
    Pyramid: [],
    ResponseKontoMsg:{msg:translate("Error.Account.Pyramid.connect.start"),type:"error",loading:false},
    message: "",
  }
}
case ON_START_DISCONNECT_PYRAMID: {
  console.log("ON_START_DISCONNECT_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: true,
    Pyramid: [],
    ResponseKontoMsg:{},
    message: "",
  }
}
case ON_DISCONNECT_PYRAMID: {
  console.log("ON_START_DISCONNECT_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: false,
    Pyramid: action.payload.Pyramid,
    ResponseKontoMsg:{msg:translate("Action.disconnect"),type:"warning",loading:false},
    message: "",
  }
}
case ON_ERROR_DISCONNECT_PYRAMID: {
  console.log("ON_START_DISCONNECT_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: false,
    ResponseKontoMsg:{msg:translate("Error.Account.Pyramid.disconnect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message: "",
  }
}
case ON_START_UPDATE_PYRAMID: {
  console.log("ON_START_UPDATE_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: true,
    // Woocommerce: [],
  }
}
case ON_UPDATE_PYRAMID: {
  console.log("ON_UPDATE_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: false,
    Pyramid: action.payload.Pyramid,
  }
}
case ON_ERROR_UPDATE_PYRAMID: {
  console.log("ON_ERROR_UPDATE_PYRAMID", action)
  return {
    ...state,
    PyramidLoading: false,
    ResponseKundMsg:{msg:translate("Error.Account.Pyramid.save"),type:"error",loading:false},
    message: "",
  }
}
case ON_START_CREATE_PYRAMID_CUSTOMER: {
  console.log("ON_START_CREATE_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_CREATE_PYRAMID_CUSTOMER: {
  console.log("ON_CREATE_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: false,
    currentKund: {...state.currentKund, Kund: action.payload.Kund},
    currentPyramidKund: action.payload.currentPyramidKund
  }
}
case ON_ERROR_CREATE_PYRAMID_CUSTOMER: {
  console.log("ON_ERROR_CREATE_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: false,
    currentPyramidKund:[],
    ResponseKundMsg:{msg:translate("Error.Account.Pyramid.Customer.Create","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message:"",
  }
}


case ON_START_CONNECT_PYRAMID_CUSTOMER: {
  console.log("ON_START_CONNECT_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_CONNECT_PYRAMID_CUSTOMER: {
  console.log("ON_CONNECT_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: false,
    currentKund: {...state.currentKund, Kund: action.payload.Kund},
    currentPyramidKund: action.payload.currentPyramidKund
  }
}
case ON_ERROR_CONNECT_PYRAMID_CUSTOMER: {
  console.log("ON_ERROR_CONNECT_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: false,
    currentPyramidKund:[],
    ResponseKundMsg:{msg:translate("Error.Account.Pyramid.Customer.Connect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message:"",
  }
}
case ON_START_DISCONNECT_PYRAMID_CUSTOMER: {
  console.log("ON_START_DISCONNECT_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_DISCONNECT_PYRAMID_CUSTOMER: {
  console.log("ON_DISCONNECT_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: false,
    currentKund: {...state.currentKund, Kund: action.payload.Kund},
    currentPyramidKund: action.payload.currentPyramidKund
  }
}
case ON_ERROR_DISCONNECT_PYRAMID_CUSTOMER: {
  console.log("ON_ERROR_DISCONNECT_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: false,
    currentPyramidKund:[],
    ResponseKundMsg:{msg:translate("Error.Account.Pyramid.Customer.disConnect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message:"" ,
  }
}
case ON_START_GET_PYRAMID_CUSTOMER: {
  console.log("ON_START_GET_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_GET_PYRAMID_CUSTOMER: {
  console.log("ON_GET_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: false,
    currentPyramidKund: action.payload.currentPyramidKund
  }
}
case ON_ERROR_GET_PYRAMID_CUSTOMER: {
  console.log("ON_ERROR_GET_PYRAMID_CUSTOMER", action)
  return {
    ...state,
    PyramidLoading: false,
    currentPyramidKund:[],
    ResponseKundMsg:{msg:translate("Error.Account.Pyramid.Customer.get","Error: "+action.payload.message,{item:action.payload.message}),type:"error",loading:false},
    message:"",
  }
}
case ON_START_CREATE_PYRAMID_CONTACT: {
  console.log("ON_START_CREATE_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_CREATE_PYRAMID_CONTACT: {
  console.log("ON_CREATE_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: false,
    KontakterList:action.payload.Kontakter,
    currentKund: {
      ...state.currentKund,
      Kontakter:action.payload.Kontakter 
    },
    currentPyramidKontakt: action.payload.currentPyramidKontakt
  }
}
case ON_ERROR_CREATE_PYRAMID_CONTACT: {
  console.log("ON_ERROR_CREATE_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: false,
    currentPyramidKontakt:[],
    ResponseKundMsg:{msg:translate("Error.Account.Pyramid.Contact.Create","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message:"",
  }
}


case ON_START_CONNECT_PYRAMID_CONTACT: {
  console.log("ON_START_CONNECT_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_CONNECT_PYRAMID_CONTACT: {
  console.log("ON_CONNECT_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: false,
    KontakterList:action.payload.Kontakter,
    currentKund: {
      ...state.currentKund,
      Kontakter:action.payload.Kontakter 
    },
    currentPyramidKontakt: action.payload.currentPyramidKontakt
  }
}
case ON_ERROR_CONNECT_PYRAMID_CONTACT: {
  console.log("ON_ERROR_CONNECT_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: false,
    currentPyramidKontakt:[],
    ResponseKundMsg:{msg:translate("Error.Account.Pyramid.Contact.Connect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message:"",
  }
}
case ON_START_DISCONNECT_PYRAMID_CONTACT: {
  console.log("ON_START_DISCONNECT_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_DISCONNECT_PYRAMID_CONTACT: {
  console.log("ON_DISCONNECT_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: false,
    KontakterList:action.payload.Kontakter,
    currentKund: {
      ...state.currentKund,
      Kontakter:action.payload.Kontakter 
    },
    currentPyramidKontakt: action.payload.currentPyramidKontakt
  }
}
case ON_ERROR_DISCONNECT_PYRAMID_CONTACT: {
  console.log("ON_ERROR_DISCONNECT_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: false,
    currentPyramidKontakt:[],
    ResponseKundMsg:{msg:translate("Error.Account.Pyramid.Contact.disConnect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message:"" ,
  }
}
case ON_START_GET_PYRAMID_CONTACT: {
  console.log("ON_START_GET_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: true,
    ResponseKundMsg:{}
  }
}
case ON_GET_PYRAMID_CONTACT: {
  console.log("ON_GET_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: false,
    currentPyramidKontakt: action.payload.currentPyramidKontakt
  }
}
case ON_ERROR_GET_PYRAMID_CONTACT: {
  console.log("ON_ERROR_GET_PYRAMID_CONTACT", action)
  return {
    ...state,
    PyramidLoading: false,
    currentPyramidKontakt:[],
    ResponseKundMsg:{msg:translate("Error.Account.Pyramid.Contact.get","Error: "+action.payload.message,{item:action.payload.message}),type:"error",loading:false},
    message:"",
  }
}

case ON_START_CONNECT_ZENDESK: {
  console.log("ON_START_CONNECT_ZENDESK", action)
  return {
    ...state,
    ZendeskLoading: true,
    Zendesk:[],
    ResponseKontoMsg:{},
    message: "",
  }
}
case ON_CONNECT_ZENDESK: {
  console.log("ON_CONNECT_ZENDESK", action)
  return {
    ...state,
    ZendeskLoading: false,
    Zendesk:action.payload.Zendesk,
    ResponseKontoMsg:{msg:translate("Action.Connect"),type:"success",loading:false},
    message: "",
  }
}
case ON_ERROR_CONNECT_ZENDESK: {
  console.log("ON_ERROR_CONNECT_ZENDESK", action)
  return {
    ...state,
    ZendeskLoading: false,
    Zendesk:[],
    ResponseKundMsg:{msg:action.payload,type:"error",loading:false},
    message: "",
  }
}
case ON_START_DISCONNECT_ZENDESK: {
  console.log("ON_START_DISCONNECT_ZENDESK", action)
  return {
    ...state,
    ZendeskLoading: true,
    Zendesk:[],
    ResponseKontoMsg:{},
    message: "",
  }
}
case ON_DISCONNECT_ZENDESK: {
  console.log("ON_DISCONNECT_ZENDESK", action)
  return {
    ...state,
    ZendeskLoading: false,
    Zendesk:[],
    ResponseKontoMsg:{msg:translate("Action.disconnect"),type:"warning",loading:false},
    message: "",
  }
}
case ON_ERROR_DISCONNECT_ZENDESK: {
  console.log("ON_ERROR_DISCONNECT_ZENDESK", action)
  return {
    ...state,
    ZendeskLoading: false,
    Zendesk:[],
    ResponseKundMsg:{msg:translate("Error.Account.Zenddesk.Diconnect","Error: "+action.payload,{item:action.payload}),type:"error",loading:false},
    message: "",
  }
}
case ON_GET_ZENDESK: {
  console.log("ON_GET_ZENDESK", action)
  return {
    ...state,
    ZendeskLoading: false,
    Zendesk:action.payload.Zendesk,
  }
}
case ON_ERROR_GET_ZENDESK: {
  console.log("ON_ERROR_GET_ZENDESK", action)
  return {
    ...state,
    ZendeskLoading: false,
    Zendesk:[],
  }
}
case ON_START_GET_ZENDESK: {
  console.log("ON_START_GET_ZENDESK", action)
  return {
    ...state,
    ZendeskLoading: true,
    Zendesk:[],
  }
}

case ON_START_GET_AF_LHOGIA: {
  console.log("ON_START_GET_AF_LHOGIA", action)
  return {
    ...state,
    HogiaisLoading:true,
    ResponseKontoMsg:{},
    HogiaParameters: [],    
  }
}
case ON_GET_AF_LHOGIA: {
  return {
    ...state,
    HogiaisLoading:false,
    HogiaParameters:action.payload.HogiaParameters
  }
}
case ON_GET_AF_LHOGIA_STORE: {
  return {
    ...state,
    HogiaisLoading:false,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    HogiaParameters:action.payload.HogiaParameters
  }
}
case ON_GET_AF_LHOGIA_DELETE_STORE: {
  return {
    ...state,
    HogiaisLoading:false,
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
    HogiaParameters:action.payload.HogiaParameters
  }
}
case ON_ERROR_GET_AF_LHOGIA: {
  console.log("ON_ERROR_GET_AF_LHOGIA", action)
  return {
    ...state,
    HogiaisLoading:false,
    ResponseKontoMsg:{msg:action.payload.message,type:"error",loading:false},
    message: "",
  }
}
//ON_START_BESTALLA_HOGIA, ON_BESTALLA_HOGIA, ON_ERROR_BESTALLA_HOGIA,
case ON_START_BESTALLA_HOGIA: {
  console.log("ON_START_BESTALLA_HOGIA", action)
  return {
    ...state,
    HogiaisLoading:true,
    ResponseKontoMsg:{},
    HogiaParameters: [],    
  }
}
case ON_BESTALLA_HOGIA: {
  return {
    ...state,
    message: "",
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    HogiaisLoading:false,
    HogiaParameters:action.payload.HogiaParameters
  }
}
case ON_ERROR_BESTALLA_HOGIA: {
  console.log("ON_ERROR_BESTALLA_HOGIA", action)
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Hogia.start"),type:"error",loading:false},
    HogiaisLoading:false,
    message: "",
  }
}
//ON_START_FLYTTA_INAKTIV_USER, ON_FETCH_FLYTTA_INAKTIV_USER, ON_ERROR_FLYTTA_INAKTIV_USER,
case ON_START_FLYTTA_INAKTIV_USER: {
  console.log("ON_START_FLYTTA_INAKTIV_USER", action)
  return {
    ...state,
    userLoading:true, 
  }
}
case ON_FETCH_FLYTTA_INAKTIV_USER: {
  return {
    ...state,
    message: translate("Action.move"),
    userLoading:false
  }
}
case ON_ERROR_FLYTTA_INAKTIV_USER: {
  console.log("ON_ERROR_FLYTTA_INAKTIV_USER", action)
  return {
    ...state,
    userLoading:false,
    message: translate("Error.Account.InactivUser.move"),
  }
}
//ON_START_GET_MINA_DOCUMENT_LIST,ON_GET_MINA_DOCUMENT_LIST,ON_ERROR_GET_MINA_DOCUMENT_LIST,
case ON_START_GET_MINA_DOCUMENT_LIST: {
  console.log("ON_START_GET_MINA_DOCUMENT_LIST", action)
  return {
    ...state,
    message: "",
    MinaDokument:[],
    KundsDokument:[],
    OrgnrKund:"",
    TotalKundList:0,
    isLoadingMD:true,
    TotalList:0
  }
}
case ON_GET_MINA_DOCUMENT_LIST: {
  return {
    ...state,
    message: "",
    MinaDokument:action.payload.MinaDokument,
    isLoadingMD:false,
    TotalList:action.payload.TotalList
  }
}
case ON_ERROR_GET_MINA_DOCUMENT_LIST: {
  console.log("ON_ERROR_GET_MINA_DOCUMENT_LIST", action)
  return {
    ...state,
    isLoadingMD:false,
    message: translate("Error.Account.Document.list.fetch"),
  }
}
//MinaDokument
//ON_START_GET_MINA_DOCUMENT_KUND_LIST,ON_GET_MINA_DOCUMENT_KUND_LIST,ON_ERROR_GET_MINA_DOCUMENT_KUND_LIST,
case ON_START_GET_MINA_DOCUMENT_KUND_LIST: {
  return {
    ...state,
    message: "",
    KundsDokument:[],
    OrgnrKund:"",
    isLoadingMD:true,
    TotalKundList:0
  }
}
case ON_GET_MINA_DOCUMENT_KUND_LIST: {
  return {
    ...state,
    message: "",
    KundsDokument:action.payload.KundsDokument,
    OrgnrKund:action.payload.OrgnrKund,
    isLoadingMD:false,
    TotalKundList:action.payload.TotalKundList
  }
}
case ON_ERROR_GET_MINA_DOCUMENT_KUND_LIST: {
  return {
    ...state,
    isLoadingMD:false,
    message: translate("Error.Account.Document.list.fetch"),
  }
}
case ON_RESET_CURRENT_OBJEKT_FALT: {
  return {
    ...state,
    CurrentObjekt:[]
  }
}
//ON_START_NEW_ORDER_STATUS, ON_NEW_ORDER_STATUS, ON_ERROR_ORDER_STATUS,
case ON_START_NEW_ORDER_STATUS:{
  console.log("ON_START_NEW_ORDER_STATUS",action)
  return {
      ...state,
  }
} 
case ON_NEW_ORDER_STATUS:{
  console.log("ON_NEW_ORDER_STATUS",action)
  return {
      ...state,
      message: translate("Action.Customer.save"),
      OrderStatusList:action.payload.OrderStatusList
  }
} 
case ON_ERROR_ORDER_STATUS:{
  console.log("ON_ERROR_ORDER_STATUS",action)
  return {
      ...state,
      message: translate("Error.Customer")
  }
} 
//ON_START_DELETE_ORDER_STATUS, ON_DELETE_ORDER_STATUS, ON_ERROR_DELETE_ORDER_STATUS,
case ON_START_DELETE_ORDER_STATUS:{
  console.log("ON_START_DELETE_ORDER_STATUS",action)
  return {
      ...state,
  }
} 
case ON_DELETE_ORDER_STATUS:{
  console.log("ON_DELETE_ORDER_STATUS",action)
  return {
      ...state,
      message:translate("Action.Account.Order.status.delete"),
      OrderStatusList:action.payload.OrderStatusList
  }
} 
case ON_ERROR_DELETE_ORDER_STATUS:{
  console.log("ON_ERROR_DELETE_ORDER_STATUS",action)
  return {
      ...state,
      message: translate("Error.Customer")
  }
} 
//, , ,
case ON_START_UPDATE_ORDER_STATUS:{
  console.log("ON_START_UPDATE_ORDER_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_UPDATE_ORDER_STATUS:{
  console.log("ON_UPDATE_ORDER_STATUS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      OrderStatusList:action.payload.OrderStatusList
  }
} 
case ON_ERROR_UPDATE_ORDER_STATUS:{
  console.log("ON_ERROR_UPDATE_ORDER_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Order.Status.Update"),type:"error",loading:false},
      message:""
  }
} 
//,,,
case ON_START_GET_ORDER_STATUS:{
  console.log("ON_START_GET_ORDER_STATUS",action)
  return {
      ...state,
      OrderStatusList:state.OrderStatusList
  }
} 
case ON_GET_ORDER_STATUS:{
  console.log("ON_GET_ORDER_STATUS",action)
  return {
      ...state,
      OrderStatusList:action.payload.OrderStatusList
  }
} 

case ON_START_NEW_PROJEKT_STATUS:{
  console.log("ON_START_NEW_PROJEKT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_NEW_PROJEKT_STATUS:{
  console.log("ON_NEW_PROJEKT_STATUS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ProjectStatusList:action.payload.ProjectStatusList
  }
} 
case ON_ERROR_PROJEKT_STATUS:{
  console.log("ON_ERROR_PROJEKT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:isUndefined(action.payload.error)?translate("Error.Account.Project"):translate("Error.Account.Project1",action.payload.error,{item:action.payload.error}),type:"error",loading:false},
      message:""
  }
} 
//ON_START_DELETE_ORDER_STATUS, ON_DELETE_ORDER_STATUS, ON_ERROR_DELETE_ORDER_STATUS,
case ON_START_DELETE_PROJEKT_STATUS:{
  console.log("ON_START_DELETE_PROJEKT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_DELETE_PROJEKT_STATUS:{
  console.log("ON_DELETE_PROJEKT_STATUS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      ProjectStatusList:action.payload.ProjectStatusList
  }
} 
case ON_ERROR_DELETE_PROJEKT_STATUS:{
  console.log("ON_ERROR_DELETE_PROJEKT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Project.Status.delete"),type:"error",loading:false},
      message:""
  }
} 
//, , ,
case ON_START_UPDATE_PROJEKT_STATUS:{
  console.log("ON_START_UPDATE_PROJEKT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_UPDATE_PROJEKT_STATUS:{
  console.log("ON_UPDATE_PROJEKT_STATUS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ProjectStatusList:action.payload.ProjectStatusList
  }
} 
case ON_ERROR_UPDATE_PROJEKT_STATUS:{
  console.log("ON_ERROR_UPDATE_PROJEKT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Project.Status.update"),type:"error",loading:false},
      message:""
  }
} 

//Arende
case ON_START_NEW_ARENDE_STATUS:{
  console.log("ON_START_NEW_ARENDE_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_NEW_ARENDE_STATUS:{
  console.log("ON_NEW_ARENDE_STATUS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ArendeStatusList:action.payload.ArendeStatusList
  }
} 
case ON_ERROR_ARENDE_STATUS:{
  console.log("ON_ERROR_ARENDE_STATUS",action)
  return {
      ...state,      
      ResponseKontoMsg:{msg:isUndefined(action.payload.error)?translate("Error.Account.Cases"):
        translate("Error.Account.Cases1",action.payload.error,{item:action.payload.error})
        ,type:"error",loading:false},
      message:""
  }
} 
//ON_START_DELETE_ORDER_STATUS, ON_DELETE_ORDER_STATUS, ON_ERROR_DELETE_ORDER_STATUS,
case ON_START_DELETE_ARENDE_STATUS:{
  console.log("ON_START_DELETE_ARENDE_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_DELETE_ARENDE_STATUS:{
  console.log("ON_DELETE_ARENDE_STATUS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      ArendeStatusList:action.payload.ArendeStatusList
  }
} 
case ON_ERROR_DELETE_ARENDE_STATUS:{
  console.log("ON_ERROR_DELETE_ARENDE_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Cases.Status.delete"),type:"error",loading:false},
      message:""
  }
} 
//, , ,
case ON_START_UPDATE_ARENDE_STATUS:{
  console.log("ON_START_UPDATE_ARENDE_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_UPDATE_ARENDE_STATUS:{
  console.log("ON_UPDATE_ARENDE_STATUS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ArendeStatusList:action.payload.ArendeStatusList
  }
} 
case ON_ERROR_UPDATE_ARENDE_STATUS:{
  console.log("ON_ERROR_UPDATE_ARENDE_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Cases.Status.update"),type:"error",loading:false},
      message:""
  }
} 
//End arende

case ON_START_GET_PROJEKT_FAS_LIST: {
  console.log("ON_START_GET_PROJEKT_FAS_LIST", action)
  return {
    ...state,
    ResponseKontoMsg:{},
    ProjectFasList:[]
  }
}
case ON_GET_PROJEKT_FAS_LIST: {
  console.log("ON_GET_PROJEKT_FAS_LIST", action)
  return {
    ...state,
    ResponseKontoMsg:{},
    ProjectFasList:action.payload.ProjectFasList
  }
}
case ON_ERROR_GET_PROJEKT_FAS_LIST: {
  console.log("ON_ERROR_GET_PROJEKT_FAS_LIST", action)
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Porject.fas.fetch"),type:"error",loading:false},
  }
}


case ON_START_NEW_PROJEKT_FAS:{
  console.log("ON_START_NEW_PROJEKT_FAS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_NEW_PROJEKT_FAS:{
  console.log("ON_NEW_PROJEKT_FAS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ProjectFasList:action.payload.ProjectFasList
  }
} 
case ON_ERROR_PROJEKT_FAS:{
  console.log("ON_ERROR_PROJEKT_FAS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Porject.fas.create"),type:"error",loading:false},
      message:""
  }
} 
//ON_START_DELETE_ORDER_STATUS, ON_DELETE_ORDER_STATUS, ON_ERROR_DELETE_ORDER_STATUS,
case ON_START_DELETE_PROJEKT_FAS:{
  console.log("ON_START_DELETE_PROJEKT_FAS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
      ProjectFasList:[]
  }
} 
case ON_DELETE_PROJEKT_FAS:{
  console.log("ON_DELETE_PROJEKT_FAS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      ProjectFasList:action.payload.ProjectFasList
  }
} 
case ON_ERROR_DELETE_PROJEKT_FAS:{
  console.log("ON_ERROR_DELETE_PROJEKT_FAS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Porject.fas.delete"),type:"error",loading:false},
      message:""
  }
} 


case ON_START_NEW_PROJEKT_FAS_VIEW: {
  return {
    ...state,
    ResponseKontoMsg:{},

  }
}
case ON_NEW_PROJEKT_FAS_VIEW: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    ProjectFasViewList: action.payload.FasViewList,
    ProjectFasList:action.payload.ProjectFasList
  }
}
case ON_ERROR_NEW_PROJEKT_FAS_VIEW: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Project.Fas.View.Create"),type:"error",loading:false},

  }
}
case ON_START_DELETE_PROJEKT_FAS_VIEW: {
  return {
    ...state,
    ResponseKontoMsg:{},

  }
}
case ON_DELETE_PROJEKT_FAS_VIEW: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
    ProjectFasViewList: action.payload.FasViewList,
    ProjectFasList:action.payload.ProjectFasList
  }
}
case ON_ERROR_DELETE_PROJEKT_FAS_VIEW: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Project.Fas.View.Delete"),type:"error",loading:false},

  }
}
case ON_START_UPDATE_PROJEKT_FAS_VIEW: {
  return {
    ...state,
    ResponseKontoMsg:{},

  }
}
case ON_UPDATE_PROJEKT_FAS_VIEW: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    ProjectFasViewList: action.payload.FasViewList
  }
}
case ON_ERROR_UPDATE_PROJEKT_FAS_VIEW: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Project.Fas.View.update"),type:"error",loading:false},

  }
}
//, , ,
case ON_START_UPDATE_PROJEKT_FAS:{
  console.log("ON_START_UPDATE_PROJEKT_FAS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_UPDATE_PROJEKT_FAS:{
  console.log("ON_UPDATE_PROJEKT_FAS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
     // ProjectFasList:action.payload.ProjectFasList
  }
} 
case ON_ERROR_UPDATE_PROJEKT_FAS:{
  console.log("ON_ERROR_UPDATE_PROJEKT_FAS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Project.Fas.update"),type:"error",loading:false},
      message:""
  }
} 
//,,,
case ON_START_GET_PROJEKT_STATUS:{
  console.log("ON_START_GET_PROJEKT_STATUS",action)
  return {
      ...state,
  }
} 
case ON_GET_PROJEKT_STATUS:{
  console.log("ON_GET_PROJEKT_STATUS",action)
  return {
      ...state,
      ProjectStatusList:action.payload.ProjectStatusList
  }
} 
case ON_START_GET_ARENDE_STATUS:{
  console.log("ON_START_GET_ARENDE_STATUS",action)
  return {
      ...state,
  }
} 
case ON_GET_ARENDE_STATUS:{
  console.log("ON_GET_ARENDE_STATUS",action)
  return {
      ...state,
      ArendeStatusList:action.payload.ArendeStatusList
  }
} 
//FETCH_START_SAVE_NEW_CHILD,ON_SAVE_NEW_CHILD,ON_ERROR_SAVE_NEW_CHILD,
case FETCH_START_SAVE_NEW_CHILD:{
  console.log("FETCH_START_SAVE_NEW_CHILD",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_SAVE_NEW_CHILD:{
  console.log("ON_SAVE_NEW_CHILD",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ChildList:action.payload.ChildList
  }
} 
case ON_ERROR_SAVE_NEW_CHILD:{
  console.log("ON_ERROR_SAVE_NEW_CHILD",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Underkonto.Add"),type:"error",loading:false},
      message:""
  }
} 
//ON_START_GET_CHILD,  ON_GET_CHILD,  ON_ERROR_GET_CHILD,
case ON_START_GET_CHILD:{
  console.log("ON_START_GET_CHILD",action)
  return {
      ...state,
      ChildList:[]
  }
} 
case ON_GET_CHILD:{
  console.log("ON_GET_CHILD",action)
  return {
      ...state,
      ChildList:action.payload.ChildList
  }
} 
case ON_ERROR_GET_CHILD:{
  console.log("ON_ERROR_GET_CHILD",action)
  return {
      ...state,
      message: translate("Error.Customer")
  }
} 
//ON_START_DELETE_AFID_CHILD, ON_DELETE_AFID_CHILD,  ON_ERROR_DELETE_AFID_CHILD,
case ON_START_DELETE_AFID_CHILD:{
  console.log("ON_START_DELETE_AFID_CHILD",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_DELETE_AFID_CHILD:{
  console.log("ON_DELETE_AFID_CHILD",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      ChildList:action.payload.ChildList
  }
} 
case ON_ERROR_DELETE_AFID_CHILD:{
  console.log("ON_ERROR_DELETE_AFID_CHILD",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Underkonto.Delete"),type:"error",loading:false},
      message:""
  }
} 
//FETCH_START_SAVE_BLTYPE_CHILD,ON_SAVE_BLTYPE_CHILD,ON_ERROR_SAVE_BLTYPE_CHILD,
case FETCH_START_SAVE_BLTYPE_CHILD:{
  console.log("FETCH_START_SAVE_BLTYPE_CHILD",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_SAVE_BLTYPE_CHILD:{
  console.log("ON_SAVE_BLTYPE_CHILD",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ChildList:action.payload.ChildList
  }
} 
case ON_SAVE_CCTYPE_CHILD:{
  console.log("ON_SAVE_CCTYPE_CHILD",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ChildList:action.payload.ChildList
  }
} 
case ON_ERROR_SAVE_BLTYPE_CHILD:{
  console.log("ON_ERROR_SAVE_BLTYPE_CHILD",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Underkonto.Update"),type:"error",loading:false},
      message:""
  }
} 
//ON_START_CHILD_KONTO_KONTOR_GET, ON_CHILD_KONTO_KONTOR_GET, ON_ERROR_CHILD_KONTO_KONTOR_GET,
case ON_START_CHILD_KONTO_GET:{
  console.log("ON_START_CHILD_KONTO_GET",action)
  return {
    ...state,
    message:""
  }
}
case ON_CHILD_KONTO_KONTOR_GET:{
  console.log("ON_CHILD_KONTO_KONTOR_GET",action)
  return {
    ...state,
    UndekontoKontor:action.payload.Offices,
    message:""
  }
}
case ON_ERROR_CHILD_KONTO_KONTOR_GET:{
  console.log("ON_ERROR_CHILD_KONTO_KONTOR_GET",action)
  return {
    ...state,
    message:""
  }
}
//
case ON_START_CHILD_KONTO_GET:{
  console.log("ON_START_CHILD_KONTO_GET",action)
  return {
    ...state,
    isLoading:true,
    ChildKonto:{},
    ChildKontoOffices:[],
    ChildKontoUsers:[],
    message:""
  }
}
case ON_CHILD_KONTO_GET:{
  console.log("ON_CHILD_KONTO_GET",action)
  return {
    ...state,
    message:"",
    isLoading:false,
    ChildKonto:action.payload.Account,
    ChildKontoOffices:action.payload.Offices,
    ChildKontoUsers:action.payload.Users,
  }
}
case ON_ERROR_CHILD_KONTO_GET:{
  console.log("ON_ERROR_CHILD_KONTO_GET",action)
  return {
    ...state,
    isLoading:false,
    message: translate("Error.Customer"),
  }
}
//ChildKonto
//ON_START_CHILD_KONTO_OFFICES_GET, ON_CHILD_KONTO_OFFICES_GET, ON_ERROR_CHILD_KONTO_OFFICES_GET,
case ON_START_CHILD_KONTO_OFFICES_GET:{
  console.log("ON_START_CHILD_KONTO_OFFICES_GET",action)
  return {
    ...state,
    isLoading:true,
    ChildKontoOffices:[],
    message:""
  }
}
case ON_CHILD_KONTO_OFFICES_GET:{
  console.log("ON_CHILD_KONTO_OFFICES_GET",action)
  return {
    ...state,
    message:"",
    isLoading:false,
    ChildKontoOffices:action.payload.Offices,
  }
}
case ON_ERROR_CHILD_KONTO_OFFICES_GET:{
  console.log("ON_ERROR_CHILD_KONTO_OFFICES_GET",action)
  return {
    ...state,
    isLoading:false,
    message: translate("Error.Customer"),
  }
}
//ON_START_CHILD_KONTO_TEAM_SGET_ALL,ON_CHILD_KONTO_TEAMS_GET_ALL,ON_ERROR_CHILD_KONTO_TEAMS_GET_ALL
case ON_START_CHILD_KONTO_TEAM_SGET_ALL:{
  console.log("ON_START_CHILD_KONTO_TEAM_SGET_ALL",action)
  return {
    ...state,
    ChildKontoTeamsAll:[],
    message:""
  }
}
case ON_CHILD_KONTO_TEAMS_GET_ALL:{
  console.log("ON_CHILD_KONTO_TEAMS_GET_ALL",action)
  return {
    ...state,
    message:"",
    ChildKontoTeamsAll:action.payload.Teams,
  }
}
case ON_ERROR_CHILD_KONTO_TEAMS_GET_ALL:{
  console.log("ON_ERROR_CHILD_KONTO_TEAMS_GET_ALL",action)
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_CHILD_KONTO_TEAMS_GET, ON_CHILD_KONTO_TEAMS_GET, ON_ERROR_CHILD_KONTO_TEAMS_GET,
case ON_START_CHILD_KONTO_TEAMS_GET:{
  console.log("ON_START_CHILD_KONTO_TEAMS_GET",action)
  return {
    ...state,
    isLoading:true,
    ChildKontoTeams:[],
    message:""
  }
}
case ON_CHILD_KONTO_TEAMS_GET:{
  console.log("ON_CHILD_KONTO_TEAMS_GET",action)
  return {
    ...state,
    message:"",
    isLoading:false,
    ChildKontoTeams:action.payload.Teams,
  }
}
case ON_ERROR_CHILD_KONTO_TEAMS_GET:{
  console.log("ON_ERROR_CHILD_KONTO_TEAMS_GET",action)
  return {
    ...state,
    isLoading:false,
    message: translate("Error.Customer"),
  }
}
//ON_START_CHILD_KONTO_USERS_GET, ON_CHILD_KONTO_USERS_GET, ON_ERROR_CHILD_KONTO_USERS_GET,
case ON_START_CHILD_KONTO_USERS_GET:{
  console.log("ON_START_CHILD_KONTO_USERS_GET",action)
  return {
    ...state,
    isLoading:true,
    ChildKontoUsers:[],
    message:""
  }
}
case ON_CHILD_KONTO_USERS_GET:{
  console.log("ON_CHILD_KONTO_USERS_GET",action)
  return {
    ...state,
    message:"",
    isLoading:false,
    ChildKontoUsers:action.payload.Users,
  }
}
case ON_ERROR_CHILD_KONTO_USERS_GET:{
  console.log("ON_ERROR_CHILD_KONTO_USERS_GET",action)
  return {
    ...state,
    isLoading:false,
    message: translate("Error.Customer"),
  }
}

// ON_START_CHILD_KONTO_USERS_ALL_GET,
// ON_CHILD_KONTO_USERS_ALL_GET,
// ON_ERROR_CHILD_KONTO_ALL_USERS_GET,

case ON_START_CHILD_KONTO_USERS_ALL_GET:{
  console.log("ON_START_CHILD_KONTO_USERS_ALL_GET",action)
  return {
    ...state,
    isLoading:true,
    AllChildKontoUsers:[],
    message:""
  }
}
case ON_CHILD_KONTO_USERS_ALL_GET:{
  console.log("ON_CHILD_KONTO_USERS_ALL_GET",action)
  return {
    ...state,
    message:"",
    isLoading:false,
    AllChildKontoUsers:action.payload.Users,
  }
}
case ON_ERROR_CHILD_KONTO_ALL_USERS_GET:{
  console.log("ON_ERROR_CHILD_KONTO_ALL_USERS_GET",action)
  return {
    ...state,
    isLoading:false,
    message: translate("Error.Customer"),
  }
}


//ON_GET_KUNDER_PAGE_BASIC
case ON_GET_KUNDER_PAGE_BASIC:{
  return {
    ...state,
    KundPage:action.payload.Page
  }
}
//ON_GET_KUNDER_PAGE_ROWS_BASIC
case ON_GET_KUNDER_PAGE_ROWS_BASIC:{
  console.log("ASD123123",action)
  localStorage.removeItem("KundPagerows");
  localStorage.setItem("KundPagerows", action.payload.Page);
  return {
    ...state,
    KundPagerows:action.payload.Page
  }
}
//ON_GET_KUNDER_SEARCH_BASIC
case ON_GET_KUNDER_SEARCH_BASIC:{
  return {
    ...state,
    KundSearchText:action.payload.KundSearch
  }
}
//ON_GET_KONTAKT_PAGE_BASIC
case ON_GET_KONTAKT_PAGE_BASIC:{
  return {
    ...state,
    KontaktPage:action.payload.Page
  }
}
//ON_GET_KUND_TABINDEX
case ON_GET_KUND_TABINDEX:{
  return {
    ...state,
    TabIndex:action.payload.TabIndex
  }
}
case ON_GET_KUND_SORTOBJ:{
  return {
    ...state,
    SortByObej:action.payload.SortObj
  }
}
//FETCH_START_SAVE_CATYPE_CHILD,ON_SAVE_CATYPE_CHILD,ON_ERROR_SAVE_CATYPE_CHILD,
case FETCH_START_SAVE_CATYPE_CHILD:{
  console.log("FETCH_START_SAVE_CLTYPE_CHILD",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_SAVE_CATYPE_CHILD:{
  console.log("ON_SAVE_CLTYPE_CHILD",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ChildList:action.payload.ChildList
  }
} 
case ON_ERROR_SAVE_CATYPE_CHILD:{
  console.log("ON_ERROR_SAVE_CLTYPE_CHILD",action)
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//FETCH_START_SAVE_CLTYPE_CHILD,ON_SAVE_CLTYPE_CHILD,ON_ERROR_SAVE_CLTYPE_CHILD,
case FETCH_START_SAVE_CLTYPE_CHILD:{
  console.log("FETCH_START_SAVE_CLTYPE_CHILD",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_SAVE_CLTYPE_CHILD:{
  console.log("ON_SAVE_CLTYPE_CHILD",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ChildList:action.payload.ChildList
  }
} 
case ON_ERROR_SAVE_CLTYPE_CHILD:{
  console.log("ON_ERROR_SAVE_CLTYPE_CHILD",action)
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//FETCH_START_SAVE_FNTYPE_CHILD,ON_SAVE_FNTYPE_CHILD,ON_ERROR_SAVE_FNTYPE_CHILD,
case FETCH_START_SAVE_FNTYPE_CHILD:{
  console.log("FETCH_START_SAVE_FNTYPE_CHILD",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_SAVE_FNTYPE_CHILD:{
  console.log("ON_SAVE_FNTYPE_CHILD",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      ChildList:action.payload.ChildList
  }
} 
case ON_ERROR_SAVE_FNTYPE_CHILD:{
  console.log("ON_ERROR_SAVE_FNTYPE_CHILD",action)
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_CHILD_KONTO_AVTALTYPER_GET, ON_CHILD_KONTO_AVTALTYPER_GET, ON_ERROR_CHILD_KONTO_AVTALTYPER_GET,
case ON_START_CHILD_KONTO_AVTALTYPER_GET:{
  console.log("ON_START_CHILD_KONTO_AVTALTYPER_GET",action)
  return {
    ...state,
    AvtalTyp:[],
    message:""
  }
}
case ON_CHILD_KONTO_AVTALTYPER_GET:{
  console.log("ON_CHILD_KONTO_AVTALTYPER_GET",action)
  return {
    ...state,
    message:"",
    AvtalTyp:action.payload.AvtalTyp,
  }
}
case ON_ERROR_CHILD_KONTO_AVTALTYPER_GET:{
  console.log("ON_ERROR_CHILD_KONTO_AVTALTYPER_GET",action)
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_DELETE_HANDELSE_LOGG, ON_DELETE_HANDELSE_LOGG, ON_ERROR_DELETE_HANDELSE_LOGG,
case ON_START_DELETE_HANDELSE_LOGG:{
  console.log("ON_START_DELETE_HANDELSE_LOGG",action)
  return {
    ...state,
    CHisLoading:true
  }
}
case ON_DELETE_HANDELSE_LOGG:{
  console.log("ON_DELETE_HANDELSE_LOGG",action)
  return {
    ...state,
    message: translate("Action.delete"),
    handelseLog:action.payload.Log,
    CHisLoading:false
  }
}
case ON_ERROR_DELETE_HANDELSE_LOGG:{
  console.log("ON_ERROR_DELETE_HANDELSE_LOGG",action)
  return {
    ...state,
    message: translate("Error.Customer"),
    CHisLoading:false
  }
}
//
case ON_START_EDIT_HANDELSE_LOGG:{
  console.log("ON_START_EDIT_HANDELSE_LOGG",action)
  return {
    ...state,
    CHisLoading:false
  }
}
case ON_EDIT_HANDELSE_LOGG:{
  console.log("ON_EDIT_HANDELSE_LOGG",action)
  return {
    ...state,
    message: translate("Action.Customer.save"),
    handelseLog:action.payload.Log,
    CHisLoading:false
  }
}
case ON_ERROR_START_EDIT_HANDELSE_LOGG:{
  console.log("ON_ERROR_START_EDIT_HANDELSE_LOGG",action)
  return {
    ...state,
    message: translate("Error.Customer"),
    CHisLoading:false
  }
}//
//ON_START_GET_DONT_HA_PL_CHILD,ON_GET_DONT_HA_PL_CHILD,ON_ERROR_GET_DONT_HA_PL_CHILD,
case ON_START_GET_DONT_HA_PL_CHILD:{
  console.log("ON_START_GET_DONT_HA_PL_CHILD",action)
  return {
    ...state,
    ChildListWOPList:[]
  }
}
case ON_GET_DONT_HA_PL_CHILD:{
  console.log("ON_GET_DONT_HA_PL_CHILD",action)
  return {
    ...state,
    ChildListWOPList:action.payload.ChildListWOPList
  }
}
case ON_ERROR_GET_DONT_HA_PL_CHILD:{
  console.log("ON_ERROR_GET_DONT_HA_PL_CHILD",action)
  return {
    ...state,
  }
}
//ON_START_FORTNOX_TEMPLATE_GET,   ON_FORTNOX_TEMPLATE_GET,   ON_ERROR_FORTNOX_TEMPLATE_GET,
case ON_START_FORTNOX_TEMPLATE_GET:{
  console.log("ON_START_FORTNOX_TEMPLATE_GET",action)
  return {
    ...state
  }
}
case ON_FORTNOX_TEMPLATE_GET:{
  console.log("ON_FORTNOX_TEMPLATE_GET",action)
  return {
    ...state,
    FortNoxMall:action.payload.FortNoxMall,
    FortnoxdefaultMall:action.payload.FortnoxdefaultMall,    
  }
}
case ON_ERROR_FORTNOX_TEMPLATE_GET:{
  console.log("ON_ERROR_FORTNOX_TEMPLATE_GET",action)
  return {
    ...state,
  }
}
//ON_START_FORTNOX_TERMOFPAYMENTS_GET,   ON_FORTNOX_TERMOFPAYMENTS_GET,   ON_ERROR_FORTNOX_TERMOFPAYMENTS_GET,
case ON_START_FORTNOX_TERMOFPAYMENTS_GET:{
  console.log("ON_START_FORTNOX_TERMOFPAYMENTS_GET",action)
  return {
    ...state
  }
}
case ON_FORTNOX_TERMOFPAYMENTS_GET:{
  console.log("ON_FORTNOX_TERMOFPAYMENTS_GET",action)
  return {
    ...state,
    FortNoxTermOfPayments:action.payload.FortNoxTermOfPayments  
  }
}
case ON_ERROR_FORTNOX_TERMOFPAYMENTS_GET:{
  console.log("ON_ERROR_FORTNOX_TERMOFPAYMENTS_GET",action)
  return {
    ...state,
  }
}
//ON_START_FORTNOX_ATTACHMENTS_GET,   ON_FORTNOX_ATTACHMENTS_GET,   ON_ERROR_FORTNOX_ATTACHMENTS_GET,
case ON_START_FORTNOX_ATTACHMENTS_GET:{
  console.log("ON_START_FORTNOX_ATTACHMENTS_GET",action)
  return {
    ...state
  }
}
case ON_FORTNOX_ATTACHMENTS_GET:{
  console.log("ON_FORTNOX_ATTACHMENTS_GET",action)
  return {
    ...state,
    FortnoxAttachments:action.payload.FortnoxAttachments,  
    FortnoxFolder:action.payload.FortnoxFolder,  
    Fortnoxbreadcrumbs:action.payload.Fortnoxbreadcrumbs,  
  }
}
case ON_ERROR_FORTNOX_ATTACHMENTS_GET:{
  console.log("ON_ERROR_FORTNOX_ATTACHMENTS_GET",action)
  return {
    ...state,
  }
}
//FortnoxAttachments
case ON_START_FORTNOX_PROJEKT_GET:{
  console.log("ON_START_FORTNOX_PROJEKT_GET",action)
  return {
    ...state
  }
}
case ON_FORTNOX_PROJEKT_GET:{
  console.log("ON_FORTNOX_PROJEKT_GET",action)
  return {
    ...state,
    FortNoxProjekt:action.payload.FortNoxProjekt,   
    FortNoxProjektCurrent:action.payload.FortNoxProjektCurrent,   
  }
}
case ON_ERROR_FORTNOX_PROJEKT_GET:{
  console.log("ON_ERROR_FORTNOX_PROJEKT_GET",action)
  return {
    ...state,
  }
}
//ON_START_CHECK_FORTNOX,ON_GET_CHECK_FORTNOX,ON_ERROR_GET_CHECK_FORTNOX,
case ON_START_CHECK_FORTNOX:{
  console.log("ON_START_CHECK_FORTNOX",action)
  return {
    ...state,
    message:""
  }
}
case ON_GET_CHECK_FORTNOX:{
  console.log("ON_GET_CHECK_FORTNOX",action)
  return {
    ...state,
  }
}
case ON_ERROR_GET_CHECK_FORTNOX:{
  console.log("ON_ERROR_GET_CHECK_FORTNOX",action)
  return {
    ...state,
  }
}
//ON_UPDATE_PROSPEKT_KUND_PARAMETERS
case ON_UPDATE_PROSPEKT_KUND_PARAMETERS:{
  console.log("ON_ERROR_GET_CHECK_FORTNOX",action)
  return {
    ...state,
    currentKund:{
      ...state.currentKund,
      numProspekt:[{numProspekt:action.payload.Antal[0].total}]
    }
  }
}
    
    case ON_START_ADD_NEW_TAG : {
      console.log("ON_START_ADD_NEW_TAG", action.payload)
      return {...state,
        ResponseKontoMsg:{},
        ResponseKundMsg:{},
        // AccountTags: []
      }
    }
    case ON_ADD_NEW_TAG : {
      console.log("ON_ADD_NEW_TAG", action.payload)
      return {...state,
        AccountTags: action.payload.Taggar,
        currentKund: isEmpty(state.currentKund) ? state.currentKund : {
          ...state.currentKund,
          Taggar:action.payload.SourceTaggar
        },
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
        ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
      }
    }
    case ON_ERROR_ADD_NEW_TAG: {
      console.log("ON_ERROR_ADD_NEW_TAG", action.payload)
      return {...state,
        ResponseKontoMsg:{msg:translate("Error.Account.Tag.new"),type:"error",loading:false},
        ResponseKundMsg:{msg:translate("Error.Account.Tag.new"),type:"error",loading:false},
       // AccountTags: []
      }
    }

    case ON_START_REMOVE_TAG_FROM_ACCOUNT: {
      return {
        ...state,
        ResponseKontoMsg:{},
        ResponseKundMsg:{},
        // AccountTags: []
      }
    }
    case ON_REMOVE_TAG_FROM_ACCOUNT: {
      return {
        ...state,
        AccountTags: action.payload.Taggar,
        ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
        ResponseKundMsg:{msg:action.payload.message,type:"warning",loading:false},
      }
    }
    case ON_ERROR_REMOVE_TAG_FROM_ACCOUNT: {
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Account.Tag.delete"),type:"error",loading:false},
        ResponseKundMsg:{msg:translate("Error.Account.Tag.delete"),type:"error",loading:false},
        //AccountTags: []
      }
    }
    case ON_START_UPDATE_TAG_FROM_ACCOUNT: {
      return {
        ...state,
        ResponseKontoMsg:{},
        // AccountTags: []
      }
    }
    case ON_UPDATE_TAG_FROM_ACCOUNT: {
      return {
        ...state,
        AccountTags: action.payload.Taggar,
        ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      }
    }
    case ON_ERROR_UPDATE_TAG_FROM_ACCOUNT: {
      return {
        ...state,
        ResponseKontoMsg:{msg:translate("Error.Account.Tag.save"),type:"error",loading:false},
      //  AccountTags: []
      }
    }
    //ON_START_FORTNOX_TERMOFPAY_GET, ON_FORTNOX_TERMOFPAY_GET, ON_ERROR_FORTNOX_TERMOFPAY_GET,
    case ON_START_FORTNOX_TERMOFPAY_GET: {
      return {
        ...state,
      }
    }
    case ON_FORTNOX_TERMOFPAY_GET: {
      return {
        ...state,
        TermOfPayment: action.payload.TermOfPayment,
        FortnoxdefaultMoms:action.payload.FortnoxdefaultMoms,
      }
    }
    case ON_ERROR_FORTNOX_TERMOFPAY_GET: {
      return {
        ...state,
      }
    }
    //ON_START_FORTNOX_PRISLISTOR_GET,ON_FORTNOX_PRISLISTOR_GET,ON_ERROR_FORTNOX_PRISLISTOR_GET,
    case ON_START_FORTNOX_PRISLISTOR_GET: {
      return {
        ...state,
      }
    }
    case ON_FORTNOX_PRISLISTOR_GET: {
      return {
        ...state,
        FortNoxPrisListors: action.payload.FortNoxPrisListors,
      }
    }
    case ON_ERROR_FORTNOX_PRISLISTOR_GET: {
      return {
        ...state,
      }
    }
    //ON_START_FORTNOX_WAYOFDELIVERY_GET, ON_FORTNOX_WAYOFDELIVERY_GET, ON_ERROR_FORTNOX_WAYOFDELIVERY_GET,
    case ON_START_FORTNOX_WAYOFDELIVERY_GET: {
      return {
        ...state,
      }
    }
    case ON_FORTNOX_WAYOFDELIVERY_GET: {
      return {
        ...state,
        WayOfDelivery: action.payload.WayOfDelivery,
      }
    }
    case ON_ERROR_FORTNOX_WAYOFDELIVERY_GET: {
      return {
        ...state,
      }
    }
    //ON_START_FORTNOX_TERMSOFDELIVERY_GET, ON_FORTNOX_TERMSOFDELIVERY_GET, ON_ERROR_FORTNOX_TERMSOFDELIVERY_GET,
    case ON_START_FORTNOX_TERMSOFDELIVERY_GET: {
      return {
        ...state,
      }
    }
    case ON_FORTNOX_TERMSOFDELIVERY_GET: {
      return {
        ...state,
        TermsOfDelivery: action.payload.termsofdeliveries,
      }
    }
    case ON_ERROR_FORTNOX_TERMSOFDELIVERY_GET: {
      return {
        ...state,
      }
    }
    //ON_START_GET_HOGIA_OFFICES,ON_GET_HOGIA_OFFICES,ON_ERROR_GET_HOGIA_OFFICES,
    case ON_START_GET_HOGIA_OFFICES: {
      return {
        ...state,
        HogiaStoreId:[]
      }
    }
    case ON_GET_HOGIA_OFFICES: {
      return {
        ...state,
        HogiaStoreId: action.payload.HogiaStoreId,
      }
    }
    case ON_ERROR_GET_HOGIA_OFFICES: {
      return {
        ...state,
      }
    }
    //ON_START_GET_DOWN_FILE,ON_GET_DOWN_FILE,ON_ERROR_GET_DOWN_FILE,
    case ON_START_GET_DOWN_FILE: {
      return {
        ...state,
      }
    }
    case ON_GET_DOWN_FILE: {
      return {
        ...state,
      }
    }
    case ON_ERROR_GET_DOWN_FILE: {
      return {
        ...state,
      }
    }
    //ON_START_STATISTIC_TOTALORDER, GET_STATISTIC_TOTALORDER, ERROR_STATISTIC_TOTALORDER,
    case ON_START_STATISTIC_TOTALORDER: {
      return {
        ...state,
      }
    }
    case GET_STATISTIC_TOTALORDER: {
      return {
        ...state,
        AntalStatistikOrder:action.payload.AntalStatistikOrder
      }
    }
    case ERROR_STATISTIC_TOTALORDER: {
      return {
        ...state,
      }
    }
   //ON_START_STATISTIC_TOTALMOTEN,GET_STATISTIC_TOTALMOTE,ERROR_STATISTIC_TOTALMOTE,
   case ON_START_STATISTIC_TOTALMOTEN: {
      return {
        ...state,
      }
    }
    case GET_STATISTIC_TOTALMOTE: {
      return {
        ...state,
        AntalStatistikMote:action.payload.AntalStatistikMote
      }
    }
    case ERROR_STATISTIC_TOTALMOTE: {
      return {
        ...state,
      }
    }
    //ON_START_STATISTIC_TOTALAKTIVITETER, GET_STATISTIC_TOTALAKTIVITETER, ERROR_STATISTIC_TOTALAKTIVITETER
    case ON_START_STATISTIC_TOTALAKTIVITETER: {
      return {
        ...state,
      }
    }
    case GET_STATISTIC_TOTALAKTIVITETER: {
      return {
        ...state,
        AntalStatistikAktivitet:action.payload.AntalStatistikAktivitet
      }
    }
    case ERROR_STATISTIC_TOTALAKTIVITETER: {
      return {
        ...state,
      }
    }
    //ON_START_STATISTIC_TOTALOFFERT,GET_STATISTIC_TOTALOFFERT,ERROR_STATISTIC_TOTALOFFERT
    case ON_START_STATISTIC_TOTALOFFERT: {
      return {
        ...state
      }
    }
    case GET_STATISTIC_TOTALOFFERT: {
      return {
        ...state,
        AntalStatistikOffert:action.payload.AntalStatistikOffert
      }
    }
    case ERROR_STATISTIC_TOTALOFFERT: {
      return {
        ...state,
      }
    }
    
    //ON_START_STATISTIC_LOPANDEINTAKT_TOTAL, GET_STATISTIC_LOPANDEINTAKT_TOTAL, ERROR_STATISTIC_LOPANDEINTAKT_TOTAL
    case ON_START_STATISTIC_LOPANDEINTAKT_TOTAL: {
      return {
        ...state
      }
    }
    case GET_STATISTIC_LOPANDEINTAKT_TOTAL: {
      return {
        ...state,
        AntalLopandeIntakt:action.payload.AntalLopandeIntakt
      }
    }
    case ERROR_STATISTIC_LOPANDEINTAKT_TOTAL: {
      return {
        ...state,
      }
    }
    //ON_START_STATISTIC_ORDERTYP_TOTAL, GET_STATISTIC_ORDERTYP_TOTAL, ERROR_STATISTIC_ORDERTYP_TOTAL,
    case ON_START_STATISTIC_ORDERTYP_TOTAL: {
      return {
        ...state
      }
    }
    case GET_STATISTIC_ORDERTYP_TOTAL: {
      return {
        ...state,
        AntalOrderTyp:action.payload.AntalOrderTyp
      }
    }
    case ERROR_STATISTIC_ORDERTYP_TOTAL: {
      return {
        ...state,
      }
    }
    // ON_START_STATISTIC_SALES_TOTAL, GET_STATISTIC_SALES_TOTAL, ERROR_STATISTIC_SALES_TOTAL
    case ON_START_STATISTIC_SALES_TOTAL: {
      return {
        ...state
      }
    }
    case GET_STATISTIC_SALES_TOTAL: {
      return {
        ...state,
        AntalSales:action.payload.AntalSales
      }
    }
    case ERROR_STATISTIC_SALES_TOTAL: {
      return {
        ...state,
      }
    }
//ON_START_BESTALLA_SVEACREDIT, ON_BESTALLA_SVEACREDIT, ON_ERROR_BESTALLA_SVEACREDIT,
case ON_START_BESTALLA_SVEACREDIT: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_BESTALLA_SVEACREDIT: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    CreditSafeInfo:action.payload.SveaCreditSafeInfo
  }
}
case ON_ERROR_BESTALLA_SVEACREDIT: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate( "Error.Account.SVEA.start"),type:"error",loading:false},
  }
}
//ON_START_BESTALLA_CREDITSAFE, ON_BESTALLA_CREDITSAFE, ON_ERROR_BESTALLA_CREDITSAFE,
case ON_START_BESTALLA_CREDITSAFE: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_BESTALLA_CREDITSAFE: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    CreditSafeInfo:action.payload.CreditSafeInfo
  }
}
case ON_ERROR_BESTALLA_CREDITSAFE: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.CreditSafe.start"),type:"error",loading:false},
  }
}
//ON_START_GET_SVEACREDIT,ON_GET_SVEACREDIT,ON_ERROR_GET_SVEACREDIT,
case ON_START_GET_SVEACREDIT: {
  return {
    ...state,
    ResponseKontoMsg:{},
    SveaCreditSafeInfo:{}
  }
}
case ON_GET_SVEACREDIT: {
  return {
    ...state,
    SveaCreditSafeInfo:action.payload.SveaCreditSafeInfo
  }
}
case ON_ERROR_GET_SVEACREDIT: {
  return {
    ...state,
  }
}

//   ON_START_GET_CREDITSAFE,ON_GET_CREDITSAFE,ON_ERROR_GET_CREDITSAFE,
case ON_START_GET_CREDITSAFE: {
  return {
    ...state,
    ResponseKontoMsg:{},
    CreditSafeInfo:{}
  }
}
case ON_GET_CREDITSAFE: {
  return {
    ...state,
    CreditSafeInfo:action.payload.CreditSafeInfo
  }
}
case ON_ERROR_GET_CREDITSAFE: {
  return {
    ...state,
  }
}
//ON_START_SEND_SVEACREDIT, ON_SEND_SVEACREDIT, ON_ERROR_SEND_SVEACREDIT,
case ON_START_SEND_SVEACREDIT: {
  return {
    ...state,
    SveaCreditResult:{}
    
  }
}
case ON_SEND_CREDITSAFE: {
  return {
    ...state,
    LastSveaCreditResult:JSON.parse(action.payload.SveaCreditResult),
    LastSveadate:action.payload.LastSveadate
  }
}
case ON_ERROR_SEND_SVEACREDIT: {
  return {
    ...state,
    SveaCreditResult:{}
  }
}
//ON_START_SEND_CREDITSAFE, ON_SEND_CREDITSAFE, ON_ERROR_SEND_CREDITSAFE,
case ON_START_SEND_CREDITSAFE: {
  return {
    ...state,
    CreditSafeResult:{}
    
  }
}
case ON_SEND_CREDITSAFE: {
  return {
    ...state,
    CreditSafeResult:{}
  }
}
case ON_ERROR_SEND_CREDITSAFE: {
  return {
    ...state,
    CreditSafeResult:{}
  }
}
//ON_START_SVEACREDIT_ALLOW_USER, ON_SVEACREDIT_ALLOW_USER, ON_ERROR_SVEACREDIT_ALLOW_USER,
case ON_START_SVEACREDIT_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_SVEACREDIT_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    ALlowedSveaUsers:action.payload.ALlowedSveaUsers
  }
}
case ON_ERROR_SVEACREDIT_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.SVEA.Allow.User"),type:"error",loading:false},
  }
}
//ON_START_CREDITSAFE_ALLOW_USER, ON_CREDITSAFE_ALLOW_USER, ON_ERROR_CREDITSAFE_ALLOW_USER,
case ON_START_CREDITSAFE_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_CREDITSAFE_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    ALlowedUsers:action.payload.ALlowedUsers
  }
}
case ON_ERROR_CREDITSAFE_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.CreditSafe.Allow.User"),type:"error",loading:false},
  }
}
//ON_START_GET_ALL_SVEACREDIT_ALLOW_USER,ON_GET_ALL_SVEACREDIT_ALLOW_USER,ON_ERROR_GET_ALL_SVEACREDIT_ALLOW_USER,
case ON_START_GET_ALL_SVEACREDIT_ALLOW_USER: {
  return {
    ...state,
    ALlowedSveaUsers:[]
  }
}
case ON_GET_ALL_SVEACREDIT_ALLOW_USER: {
  return {
    ...state,
    ALlowedSveaUsers:action.payload.ALlowedSveaUsers
  }
}
case ON_ERROR_GET_ALL_SVEACREDIT_ALLOW_USER: {
  return {
    ...state,
  }
}
//
case ON_START_GET_ALL_CREDITSAFE_ALLOW_USER: {
  return {
    ...state,
    ALlowedUsers:[]
  }
}
case ON_GET_ALL_CREDITSAFE_ALLOW_USER: {
  return {
    ...state,
    ALlowedUsers:action.payload.ALlowedUsers
  }
}
case ON_ERROR_GET_ALL_CREDITSAFE_ALLOW_USER: {
  return {
    ...state,
  }
}
//ON_START_SVEACREDIT_AKTIVE_ALLOW_USER, ON_SVEACREDIT_AKTIVE_ALLOW_USER, ON_ERROR_SVEACREDIT_AKTIVE_ALLOW_USER,
case ON_START_SVEACREDIT_AKTIVE_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_SVEACREDIT_AKTIVE_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    ALlowedSveaUsers:action.payload.ALlowedSveaUsers
  }
}
case ON_ERROR_SVEACREDIT_AKTIVE_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.SVEA.Allow.User.Active"),type:"error",loading:false},
  }
}
//ON_START_CREDITSAFE_AKTIVE_ALLOW_USER, ON_CREDITSAFE_AKTIVE_ALLOW_USER, ON_ERROR_CREDITSAFE_AKTIVE_ALLOW_USER,
case ON_START_CREDITSAFE_AKTIVE_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_CREDITSAFE_AKTIVE_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    ALlowedUsers:action.payload.ALlowedUsers
  }
}
case ON_ERROR_CREDITSAFE_AKTIVE_ALLOW_USER: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.CreditSafe.Allow.User.Active"),type:"error",loading:false},
  }
}
//ON_START_GET_ALL_CREDITSAFE_CREDIT_RES,ON_GET_ALL_CREDITSAFE_CREDIT_RES,ON_ERROR_GET_ALL_CREDITSAFE_CREDIT_RES,
case ON_RESET_CREDITSAFE: {
  return {
    ...state,
    CreditSafeResult:{},
    ResultId:0,
    CreditSafeResultisWaiting:false
  }
}
case ON_START_GET_ALL_CREDITSAFE_CREDIT_RES: {
  return {
    ...state,
    CreditSafeResult:{},
    ResultId:0,
    CreditSafeResultisWaiting:true
  }
}
case ON_GET_ALL_CREDITSAFE_CREDIT_RES: {
  return {
    ...state,
    CreditSafeResult:action.payload.CreditSafeResult,
    ResultId:action.payload.ResultId,
    CreditSafeResultisWaiting:false
  }
}
case ON_ERROR_GET_ALL_CREDITSAFE_CREDIT_RES: {
  return {
    ...state,
    CreditSafeResultisWaiting:false
  }
}
//
case ON_START_SEND_CREDITSAFE_CR: {
  return {
    ...state,
  }
}
case ON_ERROR_SEND_CREDITSAFE_CR: {
  return {
    ...state,
  }
}

case ON_GET_AKTIVAKUND_KONTAKTER: {
  console.log("ON_GET_AKTIVAKUND_KONTAKTER", action.payload)
  return {
    ...state,
   AktivaKundKontakter: action.payload,
  }
}
case ON_START_GET_AKTIVAKUND_KONTAKTER: {
  console.log("ON_START_GET_AKTIVAKUND_KONTAKTER", action.payload)
  return {
    ...state,
    // AktivaKundKontakter:[],
  }
}
case ON_ERROR_GET_AKTIVAKUND_KONTAKTER: {
  console.log("ON_ERROR_GET_AKTIVAKUND_KONTAKTER", action.payload)
  return {
    ...state,
    AktivaKundKontakter:[],
  }
}
//ON_START_GET_LAST_SVEACREDIT, ON_GET_LAST_SVEACREDIT, ON_ERROR_GET_LAST_SVEACREDIT,
case ON_START_GET_LAST_SVEACREDIT: {
  return {
    ...state,
    LastSveaCreditResult:{},
    LastSveadate:""
  }
}
case ON_GET_LAST_SVEACREDIT: {
  console.log("ON_GET_LAST_CREDIT",action.payload)
  return {
    ...state,
    LastSveaCreditResult:JSON.parse(action.payload.LastSveaCreditResult),
    LastSveadate:action.payload.date
  }
}
case ON_ERROR_GET_LAST_SVEACREDIT: {
  return {
    ...state
  }
}
//ON_START_GET_LAST_CREDIT, ON_GET_LAST_CREDIT, ON_ERROR_GET_LAST_CREDIT,
case ON_START_GET_LAST_CREDIT: {
  return {
    ...state,
    LastCreditSafeResult:{},
    Lastdate:""
  }
}
case ON_GET_LAST_CREDIT: {
  return {
    ...state,
    LastCreditSafeResult:JSON.parse(action.payload.CreditSafeResult),
    Lastdate:action.payload.date
  }
}
case ON_ERROR_GET_LAST_CREDIT: {
  return {
    ...state
  }
}
//ON_START_GET_RPS_CREDIT, ON_GET_RPS_CREDIT, ON_ERROR_GET_RPS_CREDIT,
case ON_START_GET_RPS_CREDIT: {
  return {
    ...state,
    CreditSafeRapports:[]
  }
}
case ON_GET_RPS_CREDIT: {
  return {
    ...state,
    CreditSafeRapports:action.payload.CreditSafeRapports
  }
}
case ON_ERROR_GET_RPS_CREDIT: {
  return {
    ...state
  }
}
      case ON_START_CREATE_API_TOKEN : {
        console.log("ON_START_CREATE_API_TOKEN", action.payload)
        return {...state,
          ResponseKontoMsg:{},
          // AccountTags: []
        }
      }
      case ON_CREATE_API_TOKEN : {
        console.log("ON_CREATE_API_TOKEN", action.payload)
        return {...state,
          ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
          RestAPITokenList: action.payload.RestAPITokenList
        }
      }
      case ON_ERROR_CREATE_API_TOKEN: {
        console.log("ON_ERROR_CREATE_API_TOKEN", action.payload)
        return {...state,
          ResponseKontoMsg:{msg:translate("Error.Account.Api.Token.Create"),type:"error",loading:false},
          RestAPITokenList: []
        }
      }
      case ON_START_REVOKE_API_TOKEN : {
        console.log("ON_START_REVOKE_API_TOKEN", action.payload)
        return {...state,
          ResponseKontoMsg:{},
          // AccountTags: []
        }
      }
      case ON_REVOKE_API_TOKEN : {
        console.log("ON_REVOKE_API_TOKEN", action.payload)
        return {...state,
          ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
          RestAPITokenList: action.payload.RestAPITokenList
        }
      }
      case ON_ERROR_REVOKE_API_TOKEN: {
        console.log("ON_ERROR_REVOKE_API_TOKEN", action.payload)
        return {...state,
          ResponseKontoMsg:{msg:translate("Error.Account.Api.Token.Delete"),type:"error",loading:false},
          RestAPITokenList: []
        }
      }

      case ON_START_GET_AF_NOTIS: {
            console.log('ON_START_GET_AF_NOTIS', action.payload)
            return {
                ...state,
            }
        }
        case ON_GET_AF_NOTIS: {
            console.log('ON_GET_AF_NOTIS', action.payload)
            return {
                ...state,
                AFNotis: action.payload.AFNotis
            }
        }
        case ON_ERROR_GET_AF_NOTIS: {
            console.log('ON_ERROR_GET_AF_NOTIS', action.payload)
            return {
                ...state,
                AFNotis: []
            }
        }
        case ON_START_SET_AF_NOTIS_SEEN: {
            return {
                ...state,
            }
        }
        case ON_SET_AF_NOTIS_SEEN: {
            return {
                ...state,
            }
        }
        case ON_ERROR_SET_AF_NOTIS_SEEN: {
            return {
                ...state,
            }
        }
//ON_GET_KUND_MOTE_ANTAL
        case ON_GET_KUND_MOTE_ANTAL:{
          console.log('ON_GET_KUND_MOTE_ANTAL', action.payload)
          return {
            ...state,
            currentKund:{
              ...state.currentKund,
              numMote:[ {"numMote":action.payload.Antal.total} ]
            }
          }
        }
        //ON_START_GET_LOBBY_SETTING_AF,   ON_GET_LOBBY_SETTING_AF,   ON_ERROR_GET_LOBBY_SETTING_AF,
        case ON_START_GET_LOBBY_SETTING_AF:{
          return {
            ...state,
          }
        }
        case ON_GET_LOBBY_SETTING_AF:{
          return {
            ...state,
            LobbySetting:action.payload.LobbySetting
          }
        }
        case ON_ERROR_GET_LOBBY_SETTING_AF:{
          return {
            ...state,

          }
        }
        //ON_START_GET_ORDER_SETTING_AF, ON_GET_ORDER_SETTING_AF, ON_ERROR_GET_ORDER_SETTING_AF,
        case ON_START_GET_ORDER_SETTING_AF:{
          return {
            ...state,
          }
        }
        case ON_GET_ORDER_SETTING_AF:{
          return {
            ...state,
            OrderSetting:action.payload.OrderSetting
          }
        }
        case ON_ERROR_GET_ORDER_SETTING_AF:{
          return {
            ...state,

          }
        }
        //ON_START_UPDATE_ORDER_SETTING_AF, ON_UPDATE_ORDER_SETTING_AF, ON_ERROR_UPDATE_ORDER_SETTING_AF,
        case ON_START_UPDATE_ORDER_SETTING_AF:{
          return {
            ...state,
            ResponseKontoMsg:{},
          }
        }
        case ON_UPDATE_ORDER_SETTING_AF:{
          return {
            ...state,
            ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
            OrderSetting:action.payload.OrderSetting
          }
        }
        case ON_ERROR_UPDATE_ORDER_SETTING_AF:{
          return {
            ...state,
            ResponseKontoMsg:{msg:translate("Error.Account.Order.Setting.save"),type:"error",loading:false},

          }
        }
        //ON_START_UPDATE_LOBBY_SETTING_AF, ON_UPDATE_LOBBY_SETTING_AF, ON_ERROR_UPDATE_LOBBY_SETTING_AF,
        case ON_START_UPDATE_LOBBY_SETTING_AF:{
          return {
            ...state,
            ResponseKontoMsg:{},
          }
        }
        case ON_UPDATE_LOBBY_SETTING_AF:{
          return {
            ...state,
            ResponseKontoMsg:{msg:action.payload.message,type:action.payload.messagetype,loading:false},
            LobbySetting:action.payload.LobbySetting
          }
        }
        case ON_ERROR_UPDATE_LOBBY_SETTING_AF:{
          return {
            ...state,
            ResponseKontoMsg:{msg:translate("Error.Account.Lobby.Setting.save"),type:"error",loading:false},
          }
        }
        //ON_START_KUND_KUNDDATA_GET, ON_KUND_KUNDDATA_GET, ON_ERROR_KUND_KUNDDATA_GET,
        case ON_START_KUND_KUNDDATA_GET:{
          return {
            ...state,
          }
        }
        case ON_KUND_KUNDDATA_GET:{
          return {
            ...state,
            KundSKundData:action.payload.KundSKundData
          }
        }
        case ON_ERROR_KUND_KUNDDATA_GET:{
          return {
            ...state,

          }
        }


        //   AfDistrikt: [],
        //  currentAfDistrikt: {},
        //  DistriktResponse: {},

        case ON_START_ADD_NEW_DISTRIKT: {
          console.log("ON_START_ADD_NEW_DISTRIKT",action.payload)
          return {
            ...state,
            DistriktResponse: {},
            DistriktLoading: true
          }
        }
        case ON_ERROR_ADD_NEW_DISTRIKT: {
          console.log("ON_ERROR_ADD_NEW_DISTRIKT",action.payload)
          return {
            ...state,
            DistriktResponse: {
              success: false,
              show: true,
              msg: action.payload,
              type: 'error',
              func: 'add'
            },
            DistriktLoading: false
          }
        }
        case ON_ADD_NEW_DISTRIKT: {
          console.log("ON_ADD_NEW_DISTRIKT",action.payload)
          return {
            ...state,
            AfDistrikt: action.payload.AfDistrikt,
            DistriktResponse: {
              success: true,
              show: true,
              msg: translate("Action.Created"),
              type: 'success',
              func: 'add'
            },
            DistriktLoading: false
          }
        }

        case ON_START_UPDATE_DISTRIKT: {
          console.log("ON_START_UPDATE_DISTRIKT",action.payload)
          return {
            ...state,
            DistriktResponse: {},
            DistriktLoading: true
          }
        }
        case ON_ERROR_UPDATE_DISTRIKT: {
          console.log("ON_ERROR_UPDATE_DISTRIKT",action.payload)
          return {
            ...state,
            DistriktResponse: {
              success: false,
              show: true,
              msg: action.payload,
              type: 'error',
              func: 'update'
            },
            DistriktLoading: false
          }
        }
        case ON_UPDATE_DISTRIKT: {
          console.log("ON_UPDATE_DISTRIKT",action.payload)
          return {
            ...state,
            currentAfDistrikt: action.payload.currentAfDistrikt,
            AfDistrikt: action.payload.AfDistrikt,
            DistriktResponse: {
              success: true,
              show: true,
              msg: translate("Action.Updated"),
              type: 'success',
              func: 'update'
            },
            DistriktLoading: false
          }
        }

        case ON_START_DELETE_DISTRIKT: {
          console.log("ON_START_DELETE_DISTRIKT",action.payload)
          return {
            ...state,
            DistriktResponse: {},
            DistriktLoading: true
          }
        }
        case ON_ERROR_DELETE_DISTRIKT: {
          console.log("ON_ERROR_DELETE_DISTRIKT",action.payload)
          return {
            ...state,
            DistriktResponse: {
              success: false,
              show: true,
              msg: action.payload,
              type: 'error'
            },
            DistriktLoading: false
          }
        }
        case ON_DELETE_DISTRIKT: {
          console.log("ON_DELETE_DISTRIKT",action.payload)
          return {
            ...state,
            AfDistrikt: action.payload.AfDistrikt,
            DistriktResponse: {
              success: true,
              show: true,
              msg: translate("Action.Deleted"),
              type: 'warning'
            },
            DistriktLoading: false
          }
        }

        case ON_START_GET_DISTRIKT: {
          console.log("ON_START_GET_DISTRIKT",action.payload)
          return {
            ...state,
            AfDistrikt: [],
            DistriktResponse: {},
            DistriktLoading: true
          }
        }
        case ON_ERROR_GET_DISTRIKT: {
          console.log("ON_ERROR_GET_DISTRIKT",action.payload)
          return {
            ...state,
            AfDistrikt: [],
            DistriktResponse: {
              success: false,
              show: true,
              msg: translate("Action.Error"),
              type: 'error'
            },
            DistriktLoading: false
          }
        }
        case ON_GET_DISTRIKT: {
          console.log("ON_GET_DISTRIKT",action.payload)
          return {
            ...state,
            AfDistrikt: action.payload.AfDistrikt,
            DistriktLoading: false
          }
        }

        case ON_START_GET_THIS_DISTRIKT: {
          console.log("ON_START_GET_THIS_DISTRIKT",action.payload)
          return {
            ...state,
            currentAfDistrikt: {},
            DistriktResponse: {},
            DistriktLoading: true
          }
        }
        case ON_ERROR_GET_THIS_DISTRIKT: {
          console.log("ON_ERROR_GET_THIS_DISTRIKT",action.payload)
          return {
            ...state,
            currentAfDistrikt: {},
            DistriktResponse: {
              success: false,
              show: true,
              msg: action.payload,
              type: 'error'
            },
            DistriktLoading: false
          }
        }
        case ON_GET_THIS_DISTRIKT: {
          console.log("ON_GET_THIS_DISTRIKT",action.payload)
          return {
            ...state,
            currentAfDistrikt: action.payload.currentAfDistrikt,
            DistriktResponse: {
              success: true,
              show: false,
              msg: translate("Action.fetched")
            },
            DistriktLoading: false
          }
        }
//
        case ON_START_GET_MINA_DISTRIKT_POSTNR: {
          console.log("ON_START_GET_MINA_DISTRIKT_POSTNR", action.payload)
          return {
            ...state,
            DistriktLoading: true,
            MinaDistrikt: []
          }
        }
        case ON_ERROR_GET_MINA_DISTRIKT_POSTNR: {
          console.log("ON_ERROR_GET_MINA_DISTRIKT_POSTNR", action.payload)
          return {
            ...state,
            DistriktLoading: false,
            MinaDistrikt: []
          }
        }
        case ON_GET_MINA_DISTRIKT_POSTNR: {
          console.log("ON_GET_MINA_DISTRIKT_POSTNR", action.payload)
          return {
            ...state,
            DistriktLoading: false,
            MinaDistrikt: action.payload.minaDistrikt
          }
        }

        case ON_SET_NUMAKTIVITETER_KUND: {
          console.log("ON_SET_NUMAKTIVITETER_KUND",action.payload)
          return {
            ...state,
            currentKund: {
              ...state.currentKund,
              numAktiviteter: action.payload.numAktiviteter
            }
          }
        }
        
//ON_START_GET_NOTYFILE_USERS, ON_GET_NOTYFILE_USERS, ON_ERROR_GET_NOTYFILE_USERS,
case ON_START_GET_NOTYFILE_USERS: {
  return {
    ...state,

  }
}
case ON_GET_NOTYFILE_USERS: {
  return {
    ...state,
    NotyfileUsers:action.payload.NotyfileUsers

  }
}
case ON_ERROR_GET_NOTYFILE_USERS: {
  return {
    ...state,

  }
}
//ON_START_NEW_ESIGNERING_FREE_SETTING_AF, ON_NEW_ESIGNERING_FREE_SETTING_AF, ON_ERROR_NEW_ESIGNERING_FREE_SETTING_AF,
case ON_START_NEW_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_NEW_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    StandardEsiFree:action.payload.StandardEsiFree,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    message:"",
  }
}
case ON_ERROR_NEW_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Esinging.free.create"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_ESIGNERING_FREE_SETTING_AF, ON_GET_ESIGNERING_FREE_SETTING_AF, ON_ERROR_GET_ESIGNERING_FREE_SETTING_AF,
case ON_START_GET_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
  }
}
case ON_GET_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    StandardEsiFree:action.payload.StandardEsiFree

  }
}
case ON_ERROR_GET_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Esinging.free.fetch"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_DELETE_ESIGNERING_FREE_SETTING_AF,ON_DELETE_ESIGNERING_FREE_SETTING_AF,ON_ERROR_DELETE_ESIGNERING_FREE_SETTING_AF,
case ON_START_DELETE_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_DELETE_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    StandardEsiFree:action.payload.StandardEsiFree,
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
    message:""
  }
}
case ON_ERROR_DELETE_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Esinging.free.delete"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_UPDATE_ESIGNERING_FREE_SETTING_AF, ON_UPDATE_ESIGNERING_FREE_SETTING_AF, ON_ERROR_UPDATE_ESIGNERING_FREE_SETTING_AF,
case ON_START_UPDATE_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_UPDATE_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    StandardEsiFree:action.payload.StandardEsiFree,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    message:""
  }
}
case ON_ERROR_UPDATE_ESIGNERING_FREE_SETTING_AF: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Esinging.free.update"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_ORGNR_FORDON, ON_GET_ORGNR_FORDON, ON_ERROR_GET_ORGNR_FORDON,
case ON_START_GET_ORGNR_FORDON: {
  return {
    ...state,
  }
}
case ON_GET_ORGNR_FORDON: {
  return {
    ...state,
    FordonDataOrgnr:action.payload.FordonDataOrgnr
  }
}
case ON_ERROR_GET_ORGNR_FORDON: {
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_NEW_USER_VAXLE, ON_NEW_USER_VAXLE, ON_ERROR_NEW_USER_VAXLE,
case ON_START_NEW_USER_VAXLE: {
  return {
    ...state,
  }
}
case ON_START_GET_USER_VAXLE: {
  return {
    ...state,
    VaxleUSer:[]
  }
}
case ON_NEW_USER_VAXLE: {
  return {
    ...state,
    VaxleUSer:action.payload.VaxleUSer
  }
}
case ON_ERROR_NEW_USER_VAXLE: {
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_SET_KUNDLIST_TAG,ON_SET_KUNDLIST_TAG,ON_ERROR_SET_KUNDLIST_TAG
case ON_START_SET_KUNDLIST_TAG: {
  return {
    ...state,
    ResponseKundMsg:{}
  }
}
case ON_SET_KUNDLIST_TAG: {
  return {
    ...state,
    message:"",
    ResponseKundMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_ERROR_SET_KUNDLIST_TAG: {
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Error.Accout.Clintlist.Tag"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_KUNDDATA_HEADER, ON_GET_KUNDDATA_HEADER, ON_ERROR_GET_KUNDDATA_HEADER,
case ON_START_GET_KUNDDATA_HEADER: {
  return {
    ...state,
    KdLoading:true,
    KundDataHeader:[]
  }
}
case ON_GET_KUNDDATA_HEADER: {
  return {
    ...state,
    KundDataHeader:action.payload.KundDataHeader,
  }
}
case ON_ERROR_GET_KUNDDATA_HEADER: {
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_GET_KUNDDATA_BYTYPE, ON_GET_KUNDDATA_BYTYPE, ON_ERROR_GET_KUNDDATA_BYTYPE,
case ON_START_GET_KUNDDATA_BYTYPE: {
  return {
    ...state,
    KdLoading:false,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.fetching"),type:"info",loading:true},
    KundSKundDataType:[]
  }
}
case ON_GET_KUNDDATA_BYTYPE: {
  return {
    ...state,
    KdLoading:false,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.fetch"),type:"success",loading:false},
    KundSKundDataType:action.payload.KundSKundDataType,
  }
}
case ON_ERROR_GET_KUNDDATA_BYTYPE: {
  return {
    ...state,
    KdLoading:false,
    ResponseKundMsg:{msg:translate("Error.Customers.Data.fetch"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_DELETE_ROW_KUNDDATA_BYTYPE,ON_DELETE_ROW_KUNDDATA_BYTYPE,ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE,
case ON_START_DELETE_ROW_KUNDDATA_BYTYPE: {
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.deleting"),type:"info",loading:true},
    KundSKundDataType:[]
  }
}
case ON_DELETE_ROW_KUNDDATA_BYTYPE: {
  return {
    ...state,
    KundSKundDataType:action.payload.KundSKundDataType,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.delete"),type:"warning",loading:false},
    message:"",
  }
}
case ON_ERROR_DELETE_ROW_KUNDDATA_BYTYPE: {
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Error.Customers.Data.delete"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_DELETE_ROW_ALL_KUNDDATA_BYTYPE,ON_DELETE_ROW_ALL_KUNDDATA_BYTYPE,
case ON_START_DELETE_ROW_ALL_KUNDDATA_BYTYPE: {
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.all.deleting"),type:"info",loading:true},
  }
}
case ON_DELETE_ROW_ALL_KUNDDATA_BYTYPE: {
  let KundSKundDataType2 = state.ALLKundDataType.filter(item=>{return item.radId !== action.DelRad})
  return {
    ...state,
    ALLKundDataType:KundSKundDataType2,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.all.delete"),type:"warning",loading:false},
    message:"",
  }
}
//ON_START_SAVE_ROW_KUNDDATA_DIALER_BYTYPE, ON_SAVE_All_ROW_KUNDDATA_DIALER_BYTYPE, ON_ERROR_GET_KUNDDATA_ALL_DIALER_BYTYPE,
case ON_START_SAVE_ROW_KUNDDATA_DIALER_BYTYPE: {
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.Saving"),type:"info",loading:true},
  }
}
case ON_SAVE_All_ROW_KUNDDATA_DIALER_BYTYPE: {
  //Rad
  console.log(action,"@@")
  let KundSKundDataType2 = state.ALLDialerKundDataType
  if(!isUndefined(action.payload.Rad)){  
  let index = state.ALLDialerKundDataType.findIndex(item=>{return item.radId === action.payload.Rad.radId})
  KundSKundDataType2[index]=action.payload.Rad
  console.log(KundSKundDataType2,"@@")
  console.log(index,"@@")
  }
  //
  return {
    ...state,
    ALLDialerKundDataType:KundSKundDataType2,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.Save"),type:"warning",loading:false},
    message:""
  }
}
case ON_ERROR_GET_KUNDDATA_ALL_DIALER_BYTYPE: {
  return {
    ...state,
    KdLoading:false,
    message: translate("Error.Customer"),
  }
}

//
case ON_START_SAVE_ROW_KUNDDATA_BYTYPE: {
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.Saving"),type:"info",loading:true},
  }
}
case ON_SAVE_All_ROW_KUNDDATA_BYTYPE: {
  //Rad
  console.log(action,"@@")
  let KundSKundDataType2 = state.ALLKundDataType
  if(!isUndefined(action.payload.Rad)){  
  let index = state.ALLKundDataType.findIndex(item=>{return item.radId === action.payload.Rad.radId})
  KundSKundDataType2[index]=action.payload.Rad
  console.log(KundSKundDataType2,"@@")
  console.log(index,"@@")
  }
  //
  return {
    ...state,
    ALLKundDataType:KundSKundDataType2,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.Save"),type:"warning",loading:false},
    message:""
  }
}
case ON_SAVE_ROW_KUNDDATA_BYTYPE: {
  return {
    ...state,
    KundSKundDataType:action.payload.KundSKundDataType,
    ResponseKundMsg:{msg:translate("Action.Customers.Data.Save"),type:"warning",loading:false},
    message:"",
  }
}
//
case ON_START_GET_KUNDDATA_ALL_HEADER: {
  return {
    ...state,
    KdLoading:true,
    KundDataALLHeader:[]
  }
}
case ON_GET_KUNDDATA_ALL_HEADER: {
  return {
    ...state,
    KundDataALLHeader:action.payload.KundDataHeader,
  }
}
case ON_ERROR_GET_KUNDDATA_ALL_HEADER: {
  return {
    ...state,
    KdLoading:false,
    message: translate("Error.Customer"),
  }
}
//ON_START_GET_KUNDDATA_ALL_BYTYPE,ON_GET_KUNDDATA_ALL_BYTYPE,ON_ERROR_GET_KUNDDATA_ALL_BYTYPE,
case ON_START_GET_KUNDDATA_ALL_BYTYPE: {
  return {
    ...state,
    KdLoading:true,
    ALLKundDataType:[]
  }
}
case ON_GET_KUNDDATA_ALL_BYTYPE: {
  return {
    ...state,   
    KdLoading:false, 
    ALLKundDataType:action.payload.ALLKundDataType,
  }
}
case ON_ERROR_GET_KUNDDATA_ALL_BYTYPE: {
  return {
    ...state,
    KdLoading:false, 
    message: translate("Error.Customer"),
  }
}
//ON_START_GET_KUNDDATA_DIALER_ALL_BYTYPE,ON_GET_KUNDDATA_DIALER_ALL_BYTYPE,ON_ERROR_GET_KUNDDATA_DIALER_ALL_BYTYPE,
case ON_START_GET_KUNDDATA_DIALER_ALL_BYTYPE: {
  return {
    ...state,
    ALLDialerKundDataType:[]
  }
}
case ON_GET_KUNDDATA_DIALER_ALL_BYTYPE: {
  return {
    ...state,
    KdLoading:false,
    ALLDialerKundDataType:action.payload.ALLKundDataType,
  }
}
case ON_ERROR_GET_KUNDDATA_DIALER_ALL_BYTYPE: {
  return {
    ...state,
    KdLoading:false,
    message: translate("Error.Customer"),
  }
}
//ON_START_DELETE_ALL_ROW_KUNDDATA_BYTYPE,ON_DELETE_ALL_ROW_KUNDDATA_BYTYPE,ON_ERROR_DELETE_ALL_ROW_KUNDDATA_BYTYPE
case ON_START_DELETE_ALL_ROW_KUNDDATA_BYTYPE: {
  return {
    ...state,
  }
}
case ON_DELETE_ALL_ROW_KUNDDATA_BYTYPE: {
  return {
    ...state,
    ALLKundDataType:action.payload.ALLKundDataType,
  }
}
case ON_ERROR_DELETE_ALL_ROW_KUNDDATA_BYTYPE: {
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_CREATE_RINGLIST_FROM_KUNDDATA, ON_CREATE_RINGLIST_FROM_KUNDDATA, ON_ERROR_CREATE_RINGLIST_FROM_KUNDDATA,
case ON_START_CREATE_RINGLIST_FROM_KUNDDATA: {
  return {
    ...state,
  }
}
case ON_CREATE_RINGLIST_FROM_KUNDDATA: {
  return {
    ...state,
    message:translate("Action.Created"),
  }
}
case ON_ERROR_CREATE_RINGLIST_FROM_KUNDDATA: {
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//
case ON_START_CREATE_RINGLIST_FROM_AVTALSTID: {
  return {
    ...state,
  }
}
case ON_CREATE_RINGLIST_FROM_AVTALSTID: {
  return {
    ...state,
    message:translate("Action.Created"),
  }
}
case ON_ERROR_CREATE_RINGLIST_FROM_AVTALSTID: {
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_SAVE_NEW_TYPE_ARTIKEL, ON_SAVE_SAVE_NEW_TYPE_ARTIKEL, ON_ERROR_SAVE_NEW_TYPE_ARTIKEL,
case ON_START_SAVE_NEW_TYPE_ARTIKEL: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_SAVE_SAVE_NEW_TYPE_ARTIKEL: {
  return {
    ...state,
    ArticleTypes:action.payload.ArticleTypes,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_DELETE_SAVE_NEW_TYPE_ARTIKEL: {
  return {
    ...state,
    ArticleTypes:action.payload.ArticleTypes,
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
    message:"",
  }
}
case ON_ERROR_SAVE_NEW_TYPE_ARTIKEL: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Item.type.create"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_TYPE_ARTIKEL_AFID,ON_GET_TYPE_ARTIKEL_AFID,ON_ERROR_TYPE_ARTIKEL_AFID,
case ON_START_GET_TYPE_ARTIKEL_AFID: {
  return {
    ...state,
    ArticleTypes:[]
  }
}
case ON_GET_TYPE_ARTIKEL_AFID: {
  return {
    ...state,
    ArticleTypes:action.payload.ArticleTypes,
  }
}
case ON_ERROR_TYPE_ARTIKEL_AFID: {
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//
case ON_START_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT: {
  return {
    ...state,
    ArticleTypesFreeInputs:action.payload.ArticleTypesFreeInputs,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    message:"",
  }
}
case ON_ERROR_SAVE_NEW_TYPE_ARTIKEL_FREEINPUT: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Item.type.input.create"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST, ON_GET_FREEINPUT_ARTIKEL_AFID_LIST, ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST,
case ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST: {
  return {
    ...state,
    ArticleTypesFreeInputsList:[]
  }
}
case ON_GET_FREEINPUT_ARTIKEL_AFID_LIST: {
  return {
    ...state,
    ArticleTypesFreeInputsList:action.payload.ArticleTypesFreeInputsList,
  }
}
case ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Item.type.fetch"),type:"error",loading:false},
    message:"",
  }
}
case ON_START_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS: {
  return {
    ...state,
    ArticleTypesFreeInputsListFilterOptions:[]
  }
}
case ON_GET_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS: {
  return {
    ...state,
    ArticleTypesFreeInputsListFilterOptions:action.payload.ArticleTypesFreeInputsListFilterOptions,
  }
}
case ON_ERROR_FREEINPUT_ARTIKEL_AFID_LIST_FILTER_OPTIONS: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.item.filter.option"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_FREEINPUT_ARTIKEL_AFID,ON_GET_FREEINPUT_ARTIKEL_AFID,ON_ERROR_FREEINPUT_ARTIKEL_AFID,
case ON_START_GET_FREEINPUT_ARTIKEL_AFID: {
  return {
    ...state,
    ArticleTypesFreeInputs:[]
  }
}
case ON_GET_FREEINPUT_ARTIKEL_AFID: {
  return {
    ...state,
    ArticleTypesFreeInputs:action.payload.ArticleTypesFreeInputs,
  }
}
case ON_DELETE_TYPE_ARTIKEL_FREEINPUT: {
  return {
    ...state,
    ArticleTypesFreeInputs:action.payload.ArticleTypesFreeInputs,
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
    message:"",
  }
}
case ON_ERROR_FREEINPUT_ARTIKEL_AFID: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.item.filter.fetch"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_FREEINPUT_ARTIKEL_ALL_AFID,ON_GET_FREEINPUT_ARTIKEL_ALL_AFID,
case ON_START_GET_FREEINPUT_ARTIKEL_ALL_AFID: {
  return {
    ...state,
  }
}
case ON_GET_FREEINPUT_ARTIKEL_ALL_AFID: {
  return {
    ...state,
    AfidArticleTypesFreeInputs:action.payload.AfidArticleTypesFreeInputs,
  }
}
//ON_START_FETCH_ORDER_IMPORT_FILE,ON_FETCH_ORDER_IMPORT_FILE,
case ON_START_FETCH_ORDER_IMPORT_FILE: {
  return {
    ...state,
  }
}
case ON_FETCH_ORDER_IMPORT_FILE: {
  return {
    ...state,
  //  message: translate("Error.Customer"),
  }
}
//ON_CLOSE_KONTO_TOASTR
case ON_CLOSE_KONTO_TOASTR: {
  return {...state,
    ResponseKontoMsg:{},
  }
}
//ON_START_ADD_PROJEKT_TIME_TYPE,ON_ADD_PROJEKT_TIME_TYPE,ON_ERROR_ADD_PROJEKT_TIME_TYPE,
case ON_START_ADD_PROJEKT_TIME_TYPE: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_DELETE_AKTIVITET: {
  return {
    ...state,    
    ResponseKundMsg:{msg:action.payload,type:"warning",loading:false},
  }
}
case ON_ADD_PROJEKT_TIME_TYPE: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_UPPDATE_PROJEKT_TIME_TYPE: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_DELETE_PROJEKT_TIME_TYPE: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
  }
}
case ON_DELETE_PROJEKT_TIME_TYPE_CATEGORY: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
  }
}
case ON_NEW_PROJEKT_TIME_TYPE_CATEGORY: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_ADD_PROJEKT_NEW_TEMPLATE_BOARD: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_UPDATE_PROJEKT_TEMPLATE_BOARD: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_DELETE_PROJEKT_TEMPLATE_BOARD: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
  }
}
case ON_ERROR_ADD_PROJEKT_TIME_TYPE: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.project.time.type.Add"),type:"error",loading:false},
    message:"",
  }
}
case ON_ERROR_UPDATE_PROJEKT_TIME_TYPE: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
    message:"",
  }
}
//ON_START_NEW_ARTIKEL_TAGG,ON_NEW_ARTIKEL_TAGG,ON_ERROR_NEW_ARTIKEL_TAGG,
case ON_START_NEW_ARTIKEL_TAGG: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_NEW_ARTIKEL_TAGG: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_UPPDATE_ARTIKEL_TAGG: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_DELETE_ARTIKEL_TAGG: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
  }
}
case ON_ERROR_NEW_ARTIKEL_TAGG: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
    message:"",
  }
}
//ON_START_FETCH_SAVED_ANPASSAD,ON_FETCH_SAVED_ANPASSAD,ON_ERROR_FETCH_SAVED_ANPASSAD,
case ON_START_FETCH_SAVED_ANPASSAD: {
  return {
    ...state,
    SavedAnRapport:[]
  }
}
case ON_START_FETCH_UPDATE_ANPASSAD: {
  return {
    ...state,
  }
}
case ON_FETCH_SAVED_ANPASSAD: {
  return {
    ...state,
    SavedAnRapport:action.payload.SavedAnRapport,
  }
}
case ON_ERROR_FETCH_SAVED_ANPASSAD: {
  return {
    ...state
  }
}
//ON_CLOSE_KUND_TOASTR
case ON_CLOSE_KUND_TOASTR: {
  console.log("ON_CLOSE_KUND_TOASTR")
  return {...state,
    ResponseKundMsg:{}
  }
}
case ON_SET_CURRENT_KONTO_TAB_INDEX: {
  console.log("ON_SET_CURRENT_KONTO_TAB_INDEX", action) 
  return {
    ...state,
    currentKontoTabIndex: action.payload
  }
}
//ON_CLOSE_RAPPORT_TOASTR
case ON_CLOSE_RAPPORT_TOASTR: {
  console.log("ON_CLOSE_RAPPORT_TOASTR")
  return {...state,
    ResponseRapportMsg:{}
  }
}
//ON_START_MESSAGE_KUND,  ON_MESSAGE_KUND,  ON_ERROR_MESSAGE_KUND,
case ON_START_MESSAGE_KUND: {
  console.log("ON_CLOSE_KUND_TOASTR")
  return {...state,
    ResponseKundMsg:{msg:action.payload,type:"info",loading:true},
  }
}
case ON_MESSAGE_KUND: {
  console.log("ON_MESSAGE_KUND",action.payload)
  return {...state,
    ResponseKundMsg:{msg:action.payload,type:"success",loading:false},
  }
}
case ON_ERROR_MESSAGE_KUND: {
  console.log("ON_CLOSE_KUND_TOASTR")
  return {...state,
    ResponseKundMsg:{msg:action.payload,type:"error",loading:false},
  }
}
//ON_START_SAVE_NEW_PRISLISTA,ON_SAVE_NEW_PRISLISTA,ON_ERROR_SAVE_NEW_PRISLISTA,
case ON_START_SAVE_NEW_PRISLISTA: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_SAVE_NEW_PRISLISTA: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    KundPrisListor:action.payload.PrisListor
  }
}
//ON_DELETE_DELETE_AFID_PRISLISTA
case ON_DELETE_DELETE_AFID_PRISLISTA: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
    KundPrisListor:action.payload.PrisListor
  }
}
//ON_UPDATE_AFID_PRISLISTA
case ON_UPDATE_AFID_PRISLISTA: {
  return {
    ...state,    
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    KundPrisListor:action.payload.PrisListor
  }
}
case ON_ERROR_SAVE_NEW_PRISLISTA: {
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload,type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_AFID_PRISLISTA,ON_GET_AFID_PRISLISTA,ON_ERROR_GET_AFID_PRISLISTA,
case ON_START_GET_AFID_PRISLISTA: {
  return {
    ...state,
    ResponseKontoMsg:{},
    KundPrisListor:[]
  }
}
case ON_GET_AFID_PRISLISTA: {
  return {
    ...state,    
    KundPrisListor:action.payload.PrisListor
  }
}
case ON_ERROR_GET_AFID_PRISLISTA: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.priceList.fetch"),type:"error",loading:false},
    message:"",
  }
}


case ON_GET_ONEDRIVE_ROOT: {
  console.log("ON_GET_ONEDRIVE_ROOT", action.payload)
  return {
    ...state,
    OneDriveRoot: action.payload.rootDrives
  }
}
case ON_ERROR_GET_ONEDRIVE_ROOT: {
  console.log("ON_ERROR_GET_ONEDRIVE_ROOT", action.payload)
  return {
    ...state,
    OneDriveRoot:[]
  }
}
case ON_START_GET_ONEDRIVE_ROOT: {
  console.log("ON_START_GET_ONEDRIVE_ROOT", action.payload)
  return {
    ...state,
    OneDriveRoot:[]
  }
}

case ON_ADD_ONEDRIVE_ROOT: {
  console.log("ON_ADD_ONEDRIVE_ROOT", action.payload)
  return {
    ...state,
    OneDriveRoot: action.payload.rootDrives

  }
}
case ON_ERROR_ADD_ONEDRIVE_ROOT: {
  console.log("ON_ERROR_ADD_ONEDRIVE_ROOT", action.payload)
  return {
    ...state,
    OneDriveRoot:[]

  }
}
case ON_START_ADD_ONEDRIVE_ROOT: {
  console.log("ON_START_ADD_ONEDRIVE_ROOT", action.payload)
  return {
    ...state,
    OneDriveRoot:[]
  }
}
//ON_START_GET_KUND_MESSAGE,ON_GET_KUND_MESSAGE,ON_ERROR_GET_KUND_MESSAGE,
case ON_START_GET_KUND_MESSAGE: {
  console.log("ON_START_GET_KUND_MESSAGE")
  return {
    ...state,
    KundMessageP:""
  }
}
case ON_GET_KUND_MESSAGE: {
  console.log("ON_GET_KUND_MESSAGE", action.payload)
  return {
    ...state,
    KundMessageP:action.payload.KundMessageP
  }
}
case ON_START_GET_KUND_MESSAGE: {
  console.log("ON_START_GET_KUND_MESSAGE")
  return {
    ...state
  }
}
//ON_START_GET_ORDER_FREE_INPUTS,ON_GET_ORDER_FREE_INPUTS,ON_ERROR_GET_ORDER_FREE_INPUTS,
case ON_START_GET_ORDER_FREE_INPUTS:{
  console.log("ON_START_GET_ORDER_FREE_INPUTS",action)
  return {
      ...state,
      message:"",
      OrderFreeInputsList:[]
  }
} 
case ON_GET_ORDER_FREE_INPUTS:{
  console.log("ON_GET_ORDER_FREE_INPUTS",action)
  return {
      ...state,
      message:"",
      AFOrderFreeInputsList:action.payload.OrderFreeInputsList
  }
} 
case ON_ERROR_GET_ORDER_FREE_INPUTS:{
  console.log("ON_ERROR_GET_ORDER_FREE_INPUTS",action)
  return {
      ...state,
      message:""
  }
} 
//ON_START_GET_AVTALS_AVSLUTNING,ON_GET_AVTALS_AVSLUTNING,ON_ERROR_GET_AVTALS_AVSLUTNING,
case ON_START_GET_AVTALS_AVSLUTNING:{
  console.log("ON_START_GET_AVTALS_AVSLUTNING",action)
  return {
      ...state,
      message:"",
      AvtalAvslutning:[]
  }
} 
case ON_GET_AVTALS_AVSLUTNING:{
  console.log("ON_GET_AVTALS_AVSLUTNING",action)
  return {
      ...state,
      message:"",
      AvtalAvslutning:action.payload.AvtalAvslutning
  }
} 
case ON_ERROR_GET_AVTALS_AVSLUTNING:{
  console.log("ON_ERROR_GET_AVTALS_AVSLUTNING",action)
  return {
      ...state,
      message:""
  }
} 
//ON_START_SAVE_NEW_AVTAL_AVSLUTNING,ON_SAVE_NEW_AVTAL_AVSLUTNING,ON_ERROR_SAVE_NEW_AVTAL_AVSLUTNING,
case ON_START_SAVE_NEW_AVTAL_AVSLUTNING:{
  console.log("ON_START_SAVE_NEW_AVTAL_AVSLUTNING",action)
  return {
      ...state,
      ResponseKundMsg:{},
      message:""
  }
} 
case ON_SAVE_NEW_AVTAL_AVSLUTNING:{
  console.log("ON_SAVE_NEW_AVTAL_AVSLUTNING",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      AvtalAvslutning:action.payload.AvtalAvslutning
  }
} 
case ON_ERROR_SAVE_NEW_AVTAL_AVSLUTNING:{
  console.log("ON_ERROR_SAVE_NEW_AVTAL_AVSLUTNING",action)
  return {
      ...state,
      ResponseKundMsg:{msg:translate("Error.Account.Contract.closing.add"),type:"error",loading:false},
      message:""
  }
}
//ON_START_DELETE_AVTAL_AVSLUTNING,ON_DELETE_DELETE_AVTAL_AVSLUTNING,ON_ERROR_DELETE_AVTAL_AVSLUTNING 
case ON_START_DELETE_AVTAL_AVSLUTNING:{
  console.log("ON_START_DELETE_AVTAL_AVSLUTNING",action)
  return {
      ...state,
      ResponseKundMsg:{},
      message:""
  }
} 
case ON_DELETE_DELETE_AVTAL_AVSLUTNING:{
  console.log("ON_DELETE_DELETE_AVTAL_AVSLUTNING",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      AvtalAvslutning:action.payload.AvtalAvslutning
  }
} 
case ON_ERROR_DELETE_AVTAL_AVSLUTNING:{
  console.log("ON_ERROR_DELETE_AVTAL_AVSLUTNING",action)
  return {
      ...state,
      ResponseKundMsg:{msg:translate("Error.Account.Contract.closing.delete"),type:"error",loading:false},
      message:""
  }
}
//ON_SAVE_PAGE_ANV
case ON_SAVE_PAGE_ANV:{
  console.log("ON_SAVE_PAGE_ANV",action)
  return {
      ...state,
      AnvPage:action.payload.page
  }
}
//ON_START_GET_AVTALS_FORTNOX_SETTINGS,ON_GET_AVTALS_FORTNOX_SETTINGSG,ON_ERROR_GET_AVTALS_FORTNOX_SETTINGS,
case ON_START_GET_AVTALS_FORTNOX_SETTINGS:{
  console.log("ON_START_GET_AVTALS_FORTNOX_SETTINGS",action)
  return {
      ...state,
  }
} 
case ON_GET_AVTALS_FORTNOX_SETTINGSG:{
  console.log("ON_GET_AVTALS_FORTNOX_SETTINGSG",action)
  return {
      ...state,
      message:"",
      SettingsAvtalFortnox:action.payload.SettingsAvtalFortnox
  }
} 
case ON_ERROR_GET_AVTALS_FORTNOX_SETTINGS:{
  console.log("ON_ERROR_GET_AVTALS_FORTNOX_SETTINGS",action)
  return {
      ...state,
      message:""
  }
} 
//ON_START_UPDATE_AVTALS_FORTNOX_SETTING,ON_UPDATE_AVTALS_FORTNOX_SETTING,ON_ERROR_UPDATE_AVTALS_FORTNOX_SETTING,
case ON_START_UPDATE_AVTALS_FORTNOX_SETTING:{
  console.log("ON_START_UPDATE_AVTALS_FORTNOX_SETTING",action)
  return {
      ...state,
  }
} 
case ON_UPDATE_AVTALS_FORTNOX_SETTING:{
  console.log("ON_UPDATE_AVTALS_FORTNOX_SETTING",action)
  return {
      ...state,
      message:"",
      SettingsAvtalFortnox:action.payload.SettingsAvtalFortnox
  }
} 
case ON_ERROR_UPDATE_AVTALS_FORTNOX_SETTING:{
  console.log("ON_ERROR_UPDATE_AVTALS_FORTNOX_SETTING",action)
  return {
      ...state,
      message:""
  }
} 
//SettingsAvtalFortnox
//  ON_START_GET_EVENT_SETTING_AF,ON_GET_EVENT_SETTING_AF,ON_ERROR_GET_EVENT_SETTING_AF,
case ON_START_GET_EVENT_SETTING_AF:{
  return {
    ...state,
  }
}
case ON_GET_EVENT_SETTING_AF:{
  return {
    ...state,
    EventsSetting:action.payload.EventsSetting
  }
}
case ON_ERROR_GET_EVENT_SETTING_AF:{
  return {
    ...state,
  }
}
//ON_START_UPDATE_EVENT_SETTING_AF, ON_UPDATE_EVENT_SETTING_AF, ON_ERROR_UPDATE_EVENT_SETTING_AF,
case ON_START_UPDATE_EVENT_SETTING_AF:{
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_UPDATE_EVENT_SETTING_AF:{
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    EventsSetting:action.payload.EventsSetting
  }
}
case ON_ERROR_UPDATE_EVENT_SETTING_AF:{
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Event.Setting.save"),type:"error",loading:false},

  }
}
//ON_START_GET_AKTIVITETE_TYPE, ON_GET_AKTIVITETE_TYPE, ON_ERROR_GET_AKTIVITETE_TYPE,
case ON_START_GET_AKTIVITETE_TYPE:{
  console.log("ON_START_GET_AKTIVITETE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_GET_AKTIVITETE_TYPE:{
  console.log("ON_NEW_AKTIVITETE_TYPE",action)
  return {
      ...state,
      AktivitetTypeList:action.payload.AktivitetTypeList
  }
} 
case ON_ERROR_GET_AKTIVITETE_TYPE:{
  console.log("ON_ERROR_GET_AKTIVITETE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Activity.type.fetch"),type:"error",loading:false},
      message:""
  }
} 
case ON_START_NEW_AKTIVITETE_TYPE:{
  console.log("ON_START_NEW_AKTIVITETE_TYPE",action)
  return {
      ...state,
      AktivitetTypeList:[],
      ResponseKontoMsg:{},
  }
} 
case ON_NEW_AKTIVITETE_TYPE:{
  console.log("ON_NEW_AKTIVITETE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      AktivitetTypeList:action.payload.AktivitetTypeList
  }
} 
case ON_ERROR_AKTIVITETE_TYPE:{
  console.log("ON_ERROR_AKTIVITETE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:isUndefined(action.payload.error)?translate("Error.Account.Activity.type.create"):
        translate("Error.Account.Activity.type.create1",action.payload.error,{item:action.payload.error}),
        type:"error",loading:false},
      message:""
  }
} 
//ON_START_DELETE_AKTIVITETE_TYPE, ON_DELETE_AKTIVITETE_TYPE, ON_ERROR_DELETE_AKTIVITETE_TYPE,
case ON_START_DELETE_AKTIVITETE_TYPE:{
  console.log("ON_START_DELETE_AKTIVITETE_TYPE",action)
  return {
      ...state,
      AktivitetTypeList:[],
      ResponseKontoMsg:{},
  }
} 
case ON_DELETE_AKTIVITETE_TYPE:{
  console.log("ON_DELETE_AKTIVITETE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      AktivitetTypeList:action.payload.AktivitetTypeList
  }
} 
case ON_ERROR_DELETE_AKTIVITETE_TYPE:{
  console.log("ON_ERROR_DELETE_AKTIVITETE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Activity.type.delete"),type:"error",loading:false},
      message:""
  }
} 
case ON_START_UPDATE_AKTIVITETE_TYPE:{
  console.log("ON_START_UPDATE_AKTIVITETE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_UPDATE_AKTIVITETE_TYPE:{
  console.log("ON_UPDATE_AKTIVITETE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      AktivitetTypeList:action.payload.AktivitetTypeList
  }
} 
case ON_ERROR_UPDATE_AKTIVITETE_TYPE:{
  console.log("ON_ERROR_UPDATE_AKTIVITETE_TYPE",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Activity.type.save"),type:"error",loading:false},
      message:""
  }
} 
//ON_START_NEW_EVENT_STATUS, ON_NEW_EVENT_STATUS, ON_ERROR_EVENT_STATUS,
case ON_START_NEW_EVENT_STATUS:{
  console.log("ON_START_NEW_EVENT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_NEW_EVENT_STATUS:{
  console.log("ON_NEW_EVENT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      EventStatusList:action.payload.EventStatusList
  }
} 
case ON_ERROR_EVENT_STATUS:{
  console.log("ON_ERROR_EVENT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:isUndefined(action.payload.error)?translate("Error.Account.Event.Status.add"):
        translate("Error.Account.Event.Status.add1",action.payload.error,{item:action.payload.error})
        ,type:"error",loading:false},
      message:""
  }
} 
//ON_START_GET_EVENT_STATUS,  ON_GET_EVENT_STATUS,  
case ON_START_GET_EVENT_STATUS:{
  console.log("ON_START_GET_EVENT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_GET_EVENT_STATUS:{
  console.log("ON_GET_EVENT_STATUS",action)
  return {
      ...state,
      EventStatusList:action.payload.EventStatusList
  }
} 
//ON_START_DELETE_EVENT_STATUS, ON_DELETE_EVENT_STATUS, ON_ERROR_DELETE_EVENT_STATUS,
case ON_START_DELETE_EVENT_STATUS:{
  console.log("ON_START_DELETE_EVENT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_DELETE_EVENT_STATUS:{
  console.log("ON_DELETE_EVENT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
      EventStatusList:action.payload.EventStatusList
  }
} 
case ON_ERROR_DELETE_EVENT_STATUS:{
  console.log("ON_ERROR_DELETE_ORDER_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Event.Status.delete"),type:"error",loading:false},
      message:""
  }
} 
//ON_START_UPDATE_EVENT_STATUS, ON_UPDATE_EVENT_STATUS, ON_ERROR_UPDATE_EVENT_STATUS,
case ON_START_UPDATE_EVENT_STATUS:{
  console.log("ON_START_UPDATE_EVENT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_UPDATE_EVENT_STATUS:{
  console.log("ON_UPDATE_EVENT_STATUS",action)
  return {
      ...state,
      message:"",
      ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
      EventStatusList:action.payload.EventStatusList
  }
} 
case ON_ERROR_UPDATE_EVENT_STATUS:{
  console.log("ON_ERROR_UPDATE_EVENT_STATUS",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Event.Status.save"),type:"error",loading:false},
      message:""
  }
} 
//ON_START_GET_AVTALFORMULA, ON_GET_AVTALFORMULA, ON_ERROR_AVTALFORMULA,
case ON_START_GET_AVTALFORMULA:{
  console.log("ON_START_GET_AVTALFORMULA",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_GET_AVTALFORMULA:{
  console.log("ON_GET_AVTALFORMULA",action)
  return {
      ...state,
      AvtalFormula:action.payload.AvtalFormula
  }
} 
case ON_ERROR_AVTALFORMULA:{
  console.log("ON_ERROR_AVTALFORMULA",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Contract.formula.fetch"),type:"error",loading:false},
      message:""
  }
} 
//ON_START_UPDATE_AVTALFORMULA,  ON_UPDATE_AVTALFORMULA,  ON_ERROR_UPDATE_AVTALFORMULA,
case ON_START_UPDATE_AVTALFORMULA:{
  console.log("ON_START_UPDATE_AVTALFORMULA",action)
  return {
      ...state,
      ResponseKontoMsg:{},
  }
} 
case ON_UPDATE_AVTALFORMULA:{
  console.log("ON_UPDATE_AVTALFORMULA",action)
  return {
      ...state,
      ResponseKontoMsg:{msg: translate("Action.updated"),type:"success",loading:false},
      AvtalFormula:action.payload.AvtalFormula
  }
} 
case ON_ERROR_UPDATE_AVTALFORMULA:{
  console.log("ON_ERROR_UPDATE_AVTALFORMULA",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Contract.formula.save"),type:"error",loading:false},
      message:""
  }
} 
//AvtalFormula
//ON_START_CHECK_FORTNOX_KUNDNAME,ON_GET_CHECK_FORTNOX_KUNDNAME,ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME,
case ON_START_CHECK_FORTNOX_KUNDNAME:{
  console.log("ON_START_CHECK_FORTNOX_KUNDNAME",action)
  return {
      ...state,
  }
} 
case ON_GET_CHECK_FORTNOX_KUNDNAME:{
  console.log("ON_GET_CHECK_FORTNOX_KUNDNAME",action)
  if(isUndefined(state.currentKund.Kund)){
    return {
      ...state,
    }
  }
  if(isEmpty(String(action.payload.KundNummer))){
    return {
      ...state,
    }
  }
  let Kund = state.currentKund.Kund[0]
  let Kund2 = {
    ...Kund,
    FortnoxKundNR:action.payload.KundNummer
  }
  let KundArr=[]
  KundArr.push(Kund2)
  return {
      ...state,
      currentKund:{
        ...state.currentKund,
        Kund:KundArr
      },
  }
} 
case ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME:{
  console.log("ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME",action)
  
  return {
      ...state,
  }
} 
//ON_START_CHECK_FORTNOX_KUNDNAME1,ON_GET_CHECK_FORTNOX_KUNDNAME1,ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME1,
case ON_START_CHECK_FORTNOX_KUNDNAME1:{
  console.log("ON_START_CHECK_FORTNOX_KUNDNAME1",action)
  return {
      ...state,
      FortnoxKundNrFortnox:0,
  }
}
case ON_GET_CHECK_FORTNOX_KUNDNAME1:{
  console.log("ON_GET_CHECK_FORTNOX_KUNDNAME1",action)
  return {
      ...state,
      FortnoxKundNrFortnox:action.payload.KundNummer
  }
}
case ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME1:{
  console.log("ON_ERROR_GET_CHECK_FORTNOX_KUNDNAME1",action)
  return {
      ...state,
  }
}
//ON_START_GET_PRISLISTA_BY_ORGNR,ON_GET_PRISLISTA_BY_ORGNR,ON_ERROR_GET_PRISLISTA_BY_ORGNR,
case ON_START_GET_PRISLISTA_BY_ORGNR:{
  console.log("ON_START_GET_PRISLISTA_BY_ORGNR",action)
  return {
      ...state,
      KundFornoxPrislist:0,
  }
}
case ON_GET_PRISLISTA_BY_ORGNR:{
  console.log("ON_GET_PRISLISTA_BY_ORGNR",action)
  return {
      ...state,
      KundFornoxPrislist:action.payload.KundFornoxPrislist
  }
}
case ON_ERROR_GET_PRISLISTA_BY_ORGNR:{
  console.log("ON_ERROR_GET_PRISLISTA_BY_ORGNR",action)
  return {
      ...state,
  }
}
//ON_START_SAVE_NEW_TYP_AV_AFFAR,ON_SAVE_NEW_TYP_AV_AFFAR,ON_ERROR_SAVE_NEW_TYP_AV_AFFAR,
case ON_START_SAVE_NEW_TYP_AV_AFFAR:{
  console.log("ON_START_SAVE_NEW_TYP_AV_AFFAR",action)
  return {
      ...state
  }
}
case ON_SAVE_NEW_TYP_AV_AFFAR:{
  console.log("ON_SAVE_NEW_TYP_AV_AFFAR",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Action.save"),type:"success",loading:false},
      TypAvAffarR:action.payload.TypAvAffarR
  }
}
case ON_ERROR_SAVE_NEW_TYP_AV_AFFAR:{
  console.log("ON_ERROR_SAVE_NEW_TYP_AV_AFFAR",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Contract.newSales.add"),type:"error",loading:false},
  }
}
//ON_START_GET_TYP_AV_AFFAR,  ON_GET_TYP_AV_AFFAR,  ON_ERROR_GET_TYP_AV_AFFAR,
case ON_START_GET_TYP_AV_AFFAR:{
  console.log("ON_START_SAVE_NEW_TYP_AV_AFFAR",action)
  return {
      ...state
  }
}
case ON_GET_TYP_AV_AFFAR:{
  console.log("ON_GET_TYP_AV_AFFAR",action)
  return {
      ...state,
      TypAvAffarR:action.payload.TypAvAffarR
  }
}
case ON_ERROR_GET_TYP_AV_AFFAR:{
  console.log("ON_ERROR_GET_TYP_AV_AFFAR",action)
  return {
      ...state,
  }
}
//ON_START_AKTIVE_TYP_AV_AFFAR,ON_AKTIVE_TYP_AV_AFFAR,ON_ERROR_AKTIVE_TYP_AV_AFFAR,
case ON_START_AKTIVE_TYP_AV_AFFAR:{
  console.log("ON_START_AKTIVE_TYP_AV_AFFAR",action)
  return {
      ...state
  }
}
case ON_AKTIVE_TYP_AV_AFFAR:{
  console.log("ON_AKTIVE_TYP_AV_AFFAR",action)
  return {
      ...state,
      TypAvAffarR:action.payload.TypAvAffarR
  }
}
case ON_ERROR_AKTIVE_TYP_AV_AFFAR:{
  console.log("ON_ERROR_AKTIVE_TYP_AV_AFFAR",action)
  return {
      ...state,
  }
}
//ON_START_DELETE_TYP_AV_AFFAR,   ON_DELETE_TYP_AV_AFFAR,   ON_ERROR_DELETE_TYP_AV_AFFAR,
case ON_START_DELETE_TYP_AV_AFFAR:{
  console.log("ON_START_DELETE_TYP_AV_AFFAR",action)
  return {
      ...state
  }
}
case ON_DELETE_TYP_AV_AFFAR:{
  console.log("ON_DELETE_TYP_AV_AFFAR",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:"Raderats",type:"warning",loading:false},
      TypAvAffarR:action.payload.TypAvAffarR
  }
}
case ON_ERROR_DELETE_TYP_AV_AFFAR:{
  console.log("ON_ERROR_DELETE_TYP_AV_AFFAR",action)
  return {
      ...state,
      ResponseKontoMsg:{msg:translate("Error.Account.Contract.newSales.delete"),type:"error",loading:false},
  }
}
//ON_START_GET_FAKTURA_INTERVALL_AFID,  ON_GET_FAKTURA_INTERVALL_AFID,  ON_ERROR_GET_FAKTURA_INTERVALL_AFID,
case ON_START_GET_FAKTURA_INTERVALL_AFID:{
  console.log("ON_START_GET_FAKTURA_INTERVALL_AFID",action)
  return {
      ...state
  }
}
case ON_GET_FAKTURA_INTERVALL_AFID:{
  console.log("ON_GET_FAKTURA_INTERVALL_AFID",action)
  return {
      ...state,
      FakturaIntervall:action.payload.FakturaIntervall
  }
}
case ON_ERROR_GET_FAKTURA_INTERVALL_AFID:{
  console.log("ON_ERROR_GET_FAKTURA_INTERVALL_AFID",action)
  return {
      ...state,
  }
}
//ON_START_GET_FBADS,ON_GET_FBADS,ON_ERROR_GET_FBADS,
case ON_START_GET_FBADS:{
  console.log("ON_START_GET_FBADS",action)
  return {
      ...state,
      KundFacebookAdds:[]
  }
}
case ON_GET_FBADS:{
  console.log("ON_GET_FBADS",action)
  return {
      ...state,
      KundFacebookAdds:action.payload.KundFacebookAdds
  }
}
case ON_ERROR_GET_FBADS:{
  console.log("ON_ERROR_GET_FBADS",action)
  return {
      ...state,
  }
}
//ON_START_GET_ADS,ON_GET_ADS,ON_ERROR_GET_ADS,
case ON_START_GET_ADS:{
  console.log("ON_START_GET_ADS",action)
  return {
      ...state,
      KundgoogleAdds:[]
  }
}
case ON_GET_ADS:{
  console.log("ON_GET_ADS",action)
  return {
      ...state,
      KundgoogleAdds:action.payload.KundgoogleAdds
  }
}
case ON_ERROR_GET_ADS:{
  console.log("ON_ERROR_GET_ADS",action)
  return {
      ...state,
  }
}
//
case ON_START_GET_DOWN_FILE_NO_SAVE:{
  console.log("ON_START_GET_DOWN_FILE_NO_SAVE",action)
  return {
      ...state,
      FileBlod:{}
  }
}
case ON_GET_DOWN_FILE_NO_SAVE:{
  console.log("ON_GET_DOWN_FILE_NO_SAVE",action)
  return {
      ...state,
      FileBlod:action.payload,
  }
}
case ON_ERROR_GET_DOWN_FILE_NO_SAVE:{
  console.log("ON_ERROR_GET_DOWN_FILE_NO_SAVE",action)
  return {
      ...state,
  }
}
case ON_GET_UPDATE_DASHBOARD:{
  console.log("ON_GET_UPDATE_DASHBOARD",action)
  return {
      ...state,
      updatedashboard:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_BOKATV:{
  console.log("ON_GET_UPDATE_DASHBOARD_BOKATV",action)
  return {
      ...state,
      updatedashboardBokaTY:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_ORDERTV:{
  console.log("ON_GET_UPDATE_DASHBOARD_ORDERTV",action)
  return {
      ...state,
      updatedashboardOrderTY:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_DIALER:{
  console.log("ON_GET_UPDATE_DASHBOARD_DIALER",action)
  return {
      ...state,
      updatedashboardDialer:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_AKTIVITET:{
  console.log("ON_GET_UPDATE_DASHBOARD_AKTIVITET",action)
  return {
      ...state,
      updatedashboardAktivitet:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_PROSPEKT:{
  console.log("ON_GET_UPDATE_DASHBOARD_PROSPEKT",action)
  return {
      ...state,
      updatedashboardProspekt:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_OFFERT:{
  console.log("ON_GET_UPDATE_DASHBOARD_OFFERT",action)
  return {
      ...state,
      updatedashboardOffert:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_PROJEKT:{
  console.log("ON_GET_UPDATE_DASHBOARD_PROJEKT",action)
  return {
      ...state,
      updatedashboardProjekt:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_TIDPROJEKT:{
  console.log("ON_GET_UPDATE_DASHBOARD_TIDPROJEKT",action)
  return {
      ...state,
      updatedashboardTidProjekt:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_ARENDE:{
  console.log("ON_GET_UPDATE_DASHBOARD_ARENDE",action)
  return {
      ...state,
      updatedashboardArende:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_AVTAL:{
  console.log("ON_GET_UPDATE_DASHBOARD_AVTAL",action)
  return {
      ...state,
      updatedashboardAvtal:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_LYNES:{
  console.log("ON_GET_UPDATE_DASHBOARD_LYNES",action)
  return {
      ...state,
      updatedashboardLynes:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_DEVICE:{
  console.log("ON_GET_UPDATE_DASHBOARD_DEVICE",action)
  return {
      ...state,
      updatedashboardDevice:action.payload.set
  }
}
case ON_GET_UPDATE_DASHBOARD_ISMESSAGE:{
  console.log("ON_GET_UPDATE_DASHBOARD_ISMESSAGE",action)
  return {
      ...state,
      updatedashboardisMessage:action.payload.set
  }
}
//ON_START_GET_VALITIVE,ON_GET_VALITIVE,ON_ERROR_GET_VALITIVE,
case ON_START_GET_VALITIVE:{
  console.log("ON_START_GET_VALITIVE",action)
  return {
      ...state,
      KundValitive:[]
  }
}
case ON_GET_VALITIVE:{
  console.log("ON_GET_VALITIVE",action)
  return {
      ...state,
      KundValitive:isUndefined(JSON.parse(action.payload.KundValitive).results)?[]:JSON.parse(action.payload.KundValitive).results[0]
  }
}
case ON_ERROR_GET_VALITIVE:{
  console.log("ON_ERROR_GET_VALITIVE",action)
  return {
      ...state,
      KundValitive:[]
  }
}
//ON_START_GET_IMPORTERAD_RINGLISTOR,ON_GET_IMPORTERAD_RINGLISTOR,ON_ERROR_GET_IMPORTERAD_RINGLISTOR,
case ON_START_GET_IMPORTERAD_RINGLISTOR:{
  console.log("ON_START_GET_IMPORTERAD_RINGLISTOR",action)
  return {
      ...state,
      ImporteradRinglistor:[]
  }
}
case ON_GET_IMPORTERAD_RINGLISTOR:{
  console.log("ON_GET_IMPORTERAD_RINGLISTOR",action)
  return {
      ...state,
      ImporteradRinglistor:action.payload.ImporteradRinglistor
  }
}
case ON_ERROR_GET_IMPORTERAD_RINGLISTOR:{
  console.log("ON_ERROR_GET_IMPORTERAD_RINGLISTOR",action)
  return {
      ...state,
      ImporteradRinglistor:[]
  }
}
//ON_START_CREATE_RINGLIST_FROM_KUNDLIST, ON_CREATE_RINGLIST_FROM_KUNDLIST, ON_ERROR_CREATE_RINGLIST_FROM_KUNDLIST,
case ON_START_CREATE_RINGLIST_FROM_KUNDLIST: {
  return {
    ...state,
  }
}
case ON_CREATE_RINGLIST_FROM_KUNDLIST: {
  return {
    ...state,
    message:translate("Action.Created"),
  }
}
case ON_ERROR_CREATE_RINGLIST_FROM_KUNDLIST: {
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}
//ON_START_GET_CATE_ARENDE_AFID,ON_GE_CATE_ARENDE_AFID,ON_ERROR_CATE_ARENDE_AFID,
case ON_START_GET_CATE_ARENDE_AFID: {
  return {
    ...state,
    ArendeCategori:[]
  }
}
case ON_GE_CATE_ARENDE_AFID: {
  return {
    ...state,
    ArendeCategori:action.payload.ArendeCategori,
  }
}
case ON_ERROR_CATE_ARENDE_AFID: {
  return {
    ...state,
    message: translate("Error.Customer"),
  }
}


case ON_START_ADD_WOOCOMMERCE_WEBHOOK: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_ADD_WOOCOMMERCE_WEBHOOK: {
  return {
    ...state,
    WoocommerceWebhooks: action.payload.WoocommerceWebhooks,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},

  }
}
case ON_ERROR_ADD_WOOCOMMERCE_WEBHOOK: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Woocomrce.Hook.add"),type:"error",loading:false},

  }
}
case ON_START_GET_WOOCOMMERCE_WEBHOOK: {
  return {
    ...state,
    ResponseKontoMsg:{},

  }
}
case ON_GET_WOOCOMMERCE_WEBHOOK: {
  return {
    ...state,
    WoocommerceWebhooks: action.payload.WoocommerceWebhooks
  }
}
case ON_ERROR_GET_WOOCOMMERCE_WEBHOOK: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Woocomrce.Hook.fetch"),type:"error",loading:false},

  }
}
case ON_START_DELETE_WOOCOMMERCE_WEBHOOK: {
  return {
    ...state,
    ResponseKontoMsg:{},

  }
}
case ON_DELETE_WOOCOMMERCE_WEBHOOK: {
  return {
    ...state,
    WoocommerceWebhooks: action.payload.WoocommerceWebhooks,
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},

  }
}
case ON_ERROR_DELETE_WOOCOMMERCE_WEBHOOK: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Woocomrce.Hook.delete"),type:"error",loading:false},

  }
}

  
// CurrentWpWebhookUrl: null,
// loadingCurrentWpWebhookUrl: false,
case ON_START_FETCH_WP_WOOCOMMERCE_WEBHOOK: {
  console.log("ON_START_FETCH_WP_WOOCOMMERCE_WEBHOOK", action.payload)
  
  return {
    ...state,
    CurrentWpWebhookUrl: null,
    loadingCurrentWpWebhookUrl: true,
  }
}
case ON_FETCH_WP_WOOCOMMERCE_WEBHOOK: {
  console.log("ON_FETCH_WP_WOOCOMMERCE_WEBHOOK", action.payload)
  
  return {
    ...state,
    CurrentWpWebhookUrl: action.payload,
    loadingCurrentWpWebhookUrl: false,
  }
}
case ON_ERROR_FETCH_WP_WOOCOMMERCE_WEBHOOK: {
  console.log("ON_ERROR_FETCH_WP_WOOCOMMERCE_WEBHOOK", action.payload)
  
  return {
    ...state,
    CurrentWpWebhookUrl: null,
    loadingCurrentWpWebhookUrl: false,
  }
}

//ON_START_SAVE_NEW_CATE_ARENDE, ON_SAVE_SAVE_NEW_CATE_ARENDE, ON_ERROR_SAVE_NEW_CATE_ARENDE,
case ON_START_SAVE_NEW_CATE_ARENDE: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_SAVE_SAVE_NEW_CATE_ARENDE: {
  return {
    ...state,
    ArendeCategori:action.payload.ArendeCategori,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_DELETE_SAVE_NEW_CATE_ARENDE: {
  return {
    ...state,
    ArendeCategori:action.payload.ArendeCategori,
    message:"",
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
  }
}
case ON_ERROR_SAVE_NEW_CATE_ARENDE: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Cases.Cate.add"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_FREEINPUT_ARENDE_AFID,ON_GET_FREEINPUT_ARENDE_AFID,ON_ERROR_FREEINPUT_ARENDE_AFID,
case ON_START_GET_FREEINPUT_ARENDE_AFID: {
  return {
    ...state,
    ArendeCateFreeInputs:[]
  }
}
case ON_GET_FREEINPUT_ARENDE_AFID: {
  return {
    ...state,
    ArendeCateFreeInputs:action.payload.ArendeCatesFreeInputs,
  }
}
case ON_ERROR_FREEINPUT_ARENDE_AFID: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Cases.FreeFields.get"),type:"error",loading:false},
    message:"",
  }
}


case ON_ADD_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Action.Account.Add.Domain"),type:"success",loading:false},
    message:"",
    SendGridAuthData: action.payload.SendGridAuthData,
  }
}
case ON_ERROR_ADD_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Add.Domain"),type:"error",loading:false},
    message:"",
  }
}
case ON_START_ADD_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Action.Account.Adding.Domain"),type:"success",loading:true},
    message:"",
  }
}

//  ON_VALIDATE_AUTH_MAIL_DOMAIN,
//  ON_ERROR_VALIDATE_AUTH_MAIL_DOMAIN,
//  ON_START_VALIDATE_AUTH_MAIL_DOMAIN,
case ON_VALIDATE_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Action.Account.Varify.Domain"),type:"success",loading:false},
    message:"",
    SendGridAuthData: action.payload.SendGridAuthData,
  }
}
case ON_ERROR_VALIDATE_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Varify.Domain"),type:"error",loading:false},
    message:"",
  }
}
case ON_START_VALIDATE_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Action.Account.Varifying.Domain"),type:"success",loading:true},
    message:"",
  }
}
case ON_GET_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    SendGridAuthData: action.payload.SendGridAuthData,
  }
}
case ON_ERROR_GET_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.get.Domain"),type:"error",loading:false},
    message:"",
  }
}
case ON_START_GET_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
  }
}
case ON_REMOVE_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Action.Account.delete.Domain"),type:"warning",loading:false},
    SendGridAuthData: {},
    message:"",
  }
}
case ON_ERROR_REMOVE_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.delete.Domain"),type:"error",loading:false},
    message:"",
  }
}
case ON_START_REMOVE_AUTH_MAIL_DOMAIN: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Action.Account.deleting.Domain"),type:"warning",loading:true},
    message:"",
  }
}
//ON_START_SAVE_NEW_ARENDE_CATE_FREEINPUT, ON_SAVE_NEW_NEW_ARENDE_CATE_FREEINPUT, ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT,
case ON_START_SAVE_NEW_ARENDE_CATE_FREEINPUT: {
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_SAVE_NEW_NEW_ARENDE_CATE_FREEINPUT: {
  return {
    ...state,
    ArendeCateFreeInputs:action.payload.ArendeCatesFreeInputs,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
    message:"",
  }
}
case ON_DELETE_ARENDE_CATE_FREEINPUT: {
  return {
    ...state,
    ArendeCateFreeInputs:action.payload.ArendeCatesFreeInputs,
    ResponseKontoMsg:{msg:action.payload.message,type:"warning",loading:false},
    message:"",
  }
}
case ON_ERROR_SAVE_NEW_ARENDE_CATE_FREEINPUT: {
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Cases.FreeFields.Cate.add"),type:"error",loading:false},
    message:"",
  }
}
//ON_START_GET_FI_AFID_ARENDE,ON_GET_FI_AFID_ARENDE,ON_ERROR_FI_AFID_ARENDE,
case ON_START_GET_FI_AFID_ARENDE: {
  return {
    ...state,
    KontoArendeFI:[]
  }
}
case ON_GET_FI_AFID_ARENDE: {
  console.log("ON_GET_FI_AFID_ARENDE",action)
  return {
    ...state,
    KontoArendeFI:action.payload.KontoArendeFI,
  }
}
case ON_ERROR_FI_AFID_ARENDE: {
  return {
    ...state,
  }
}
case KALKYL_ALLREADY_SAVED:{
  console.log("DDDASD")
  return {
    ...state,
    ResponseKundMsg:{msg:translate("Action.Account.Calc.save"),type:"success",loading:false}
  }
}
//ON_START_GET_KONTO_STORAGE,ON_GET_KONTO_STORAGE,ON_ERROR_GET_KONTO_STORAGE,
case ON_START_GET_KONTO_STORAGE: {
  return {
    ...state,
    usingStorage:0
  }
}
case ON_GET_KONTO_STORAGE: {
  console.log("ON_GET_KONTO_STORAGE",action)
  return {
    ...state,
    usingStorage:action.payload.usingStorage,
  }
}
case ON_ERROR_GET_KONTO_STORAGE: {
  return {
    ...state
  }
}
//ON_START_GET_LOGG_RAPPORTV2,ON_GET_LOGG_RAPPORTV2,ON_ERROR_GET_LOGG_RAPPORTV2,
case ON_START_GET_LOGG_RAPPORTV2: {
  return {
    ...state
  }
}
case ON_GET_LOGG_RAPPORTV2: {
  console.log("ON_GET_LOGG_RAPPORTV2",action)
  return {
    ...state,
    LoggRapportV2:action.payload.LoggRapportV2
  }
}
case ON_ERROR_GET_LOGG_RAPPORTV2: {
  console.log("ON_ERROR_GET_LOGG_RAPPORTV2",action)
  return {
    ...state
  }
}

case ON_START_GET_SPARAD_RAPPORTV2: {
  return {
    ...state
  }
}
case ON_GET_SPARAD_RAPPORTV2: {
  console.log("ON_GET_SPARAD_RAPPORTV2",action)
  return {
    ...state,
    SparadRapportV2:action.payload.SparadRapportV2
  }
}
case ON_ERROR_GET_SPARAD_RAPPORTV2: {
  console.log("ON_ERROR_GET_SPARAD_RAPPORTV2",action)
  return {
    ...state
  }
}
//ON_START_DELETE_AFID_RAPPORTV2, ON_DELETE_AFID_RAPPORTV2, ON_ERROR_DELETE_AFID_RAPPORTV2,
case ON_START_DELETE_AFID_RAPPORTV2: {
  return {
    ...state,
    ImportSamplesMessage:{Message:translate("Action.RapportV2.Deleting"),status:"info"}
  }
}
case ON_DELETE_AFID_RAPPORTV2: {
  return {
    ...state,
    ImportSamplesMessage:{Message:translate("Action.RapportV2.Delete"),status:"warning"}
  }
}
case ON_ERROR_DELETE_AFID_RAPPORTV2: {
  return {
    ...state,
  }
}
//ON_START_UPDATE_RAPPORTV2, ON_UPDATE_RAPPORTV2, ON_ERROR_UPDATE_RAPPORTV2,
case ON_START_UPDATE_RAPPORTV2: {
  return {
    ...state,
    ImportSamplesMessage:{Message:translate("Action.RapportV2.Saving"),status:"info"}
  }
}
case ON_UPDATE_RAPPORTV2: {
  return {
    ...state,
    ImportSamplesMessage:{Message:translate("Action.RapportV2.Save"),status:"warning"}
  }
}
case ON_ERROR_UPDATE_RAPPORTV2: {
  return {
    ...state,
  }
}
//
case ON_START_FETCH_RAPPORTV2: {
  return {
    ...state,
    ImportSamplesMessage:{Message:translate("Action.RapportV2.Creating"),status:"info"}
  }
}
case ON_FETCH_RAPPORTV2: {
  console.log("ON_FETCH_RAPPORTV2",action)
  return {
    ...state,
    ImportSamplesMessage:{Message:translate("Action.RapportV2.Create"),status:"info"}
  }
}
case ON_SET_TO_NULL_IMPORTSAMPLE: {
  console.log("ON_SET_TO_NULL_IMPORTSAMPLE",action)
  return {
    ...state,
    ImportSamplesMessage:{}
  }
}
case ON_ERROR_FETCH_RAPPORTV2: {
  console.log("ON_ERROR_FETCH_RAPPORTV2",action)
  return {
    ...state,
    ImportSamplesMessage:{Message:translate("Error.RapportV2.get"),status:"error"}
  }
}
case ON_START_GET_IMPORT_SAMPLE: {
  return {
    ...state,
    ImportSamples:[],
    ImportSamplesFlag:true,
    ImportSamplesMessage:{Message:translate("Action.RapportV2.geting.Choosen"),status:"info"}
  }
}
case ON_GET_IMPORT_SAMPLE: {
  console.log("ON_GET_IMPORT_SAMPLE",action)
  return {
    ...state,
    ImportSamples:action.payload.ImportSamples,
    ImportSamplesFlag:false,
    ImportSamplesMessage:{}
  }
}
case ON_ERROR_GET_IMPORT_SAMPLE: {
  console.log("ON_ERROR_GET_IMPORT_SAMPLE",action)
  return {
    ...state,
    ImportSamplesFlag:false,
    ImportSamplesMessage:{Message:translate("Error.RapportV2.geting.Choosen",`Fel vid hämtning urval ${isUndefined(action.error)?action.payload:action.error}!`,{item:isUndefined(action.error)?action.payload:action.error}),status:"error"}
  }
}
//ImportSamples
//ON_START_GET_UNDERKONTO_KUNDER,ON_GET_UNDERKONTO_KUNDER,ON_ERROR_GET_UNDERKONTO_KUNDER,
case ON_START_GET_UNDERKONTO_KUNDER: {
  return {
    ...state,
    UnderKontoKunder:[]
  }
}
case ON_GET_UNDERKONTO_KUNDER: {
  console.log("ON_GET_UNDERKONTO_KUNDER",action)
  return {
    ...state,
    UnderKontoKunder:action.payload.UnderKontoKunder
  }
}
case ON_ERROR_GET_UNDERKONTO_KUNDER: {
  return {
    ...state,
  }
}
//ON_START_SEARCH_KOMMENTAR,ON_SEARCH_KOMMENTAR,ON_ERROR_SEARCH_KOMMENTAR,
case ON_START_SEARCH_KOMMENTAR: {
  return {
    ...state,
    isLoadingResult:true,
    KommentarResult:[]
  }
}
case ON_SEARCH_KOMMENTAR: {
  console.log("ON_SEARCH_KOMMENTAR",action)
  return {
    ...state,
    isLoadingResult:false,
    KommentarResult:action.payload.KommentarResult
  }
}
case ON_ERROR_SEARCH_KOMMENTAR: {
  return {
    ...state,
    isLoadingResult:false,
  }
}
//ON_START_CHECH_KUNDNR,ON_CHECH_KUNDNR,ON_ERROR_CHECH_KUNDNR,
case ON_START_CHECH_KUNDNR: {
  return {
    ...state,
    isCheckedOk:2,
    KommentarResult:[]
  }
}
case ON_CHECH_KUNDNR: {
  console.log("ON_CHECH_KUNDNR",action)
  return {
    ...state,
    isCheckedOk:action.payload.isCheckedOk
  }
}
case ON_ERROR_CHECH_KUNDNR: {
  return {
    ...state,
    isCheckedOk:2
  }
}
//ON_START_FLODE_LIKES,ON_FLODE_LIKES,ON_ERROR_FLODE_LIKES,
case ON_START_FLODE_LIKES: {
  return {
    ...state,
    likeList:[]
  }
}
case ON_FLODE_LIKES: {
  console.log("ON_FLODE_LIKES",action)
  return {
    ...state,
    likeList:action.payload.likeList
  }
}
case ON_ERROR_FLODE_LIKES: {
  return {
    ...state,
  }
}
//ON_START_ORGNR_FAMILY_TREE,ON_ORGNR_FAMILY_TREE,ON_ERROR__ORGNR_FAMILY_TREE,
case ON_START_ORGNR_FAMILY_TREE: {
  return {
    ...state,
    OrgnrTree:[]
  }
}
case ON_ORGNR_FAMILY_TREE: {
  console.log("ON_ORGNR_FAMILY_TREE",action)
  return {
    ...state,
    OrgnrTree:action.payload.OrgnrTree
  }
}
case ON_ERROR__ORGNR_FAMILY_TREE: {
  console.log("ON_ORGNR_FAMILY_TREE",action)
  return {
    ...state,
  }
}
//ON_START_ADD_ORGNR_FAMILY_TREE, ON_ADD_ORGNR_FAMILY_TREE, ON_ERROR_ADD_ORGNR_FAMILY_TREE,
case ON_START_ADD_ORGNR_FAMILY_TREE: {
  console.log("ON_START_ADD_ORGNR_FAMILY_TREE",action)
  return {
    ...state,
  }
}
case ON_ADD_ORGNR_FAMILY_TREE: {
  console.log("ON_ADD_ORGNR_FAMILY_TREE",action)
  return {
    ...state,
  }
}
case ON_ERROR_ADD_ORGNR_FAMILY_TREE: {
  console.log("ON_ERROR_ADD_ORGNR_FAMILY_TREE",action)
  return {
    ...state,
  }
}
//ON_START_DELETE_ORGNR_FAMILY_TREE, ON_DELETE_ORGNR_FAMILY_TREE
case ON_START_DELETE_ORGNR_FAMILY_TREE: {
  console.log("ON_START_DELETE_ORGNR_FAMILY_TREE",action)
  return {
    ...state,
  }
}
case ON_DELETE_ORGNR_FAMILY_TREE: {
  console.log("ON_DELETE_ORGNR_FAMILY_TREE",action)
  return {
    ...state,
  }
}
//ON_START_GET_ARTIKEL_TBAVDRAG,ON_GET_ARTIKEL_TBAVDRAG,ON_ERROR_GET_ARTIKEL_TBAVDRAG,
case ON_START_GET_ARTIKEL_TBAVDRAG: {
  console.log("ON_START_GET_ARTIKEL_TBAVDRAG",action)
  return {
    ...state,
    ArtiklarTBavdrag:[]
  }
}
case ON_GET_ARTIKEL_TBAVDRAG: {
  console.log("ON_GET_ARTIKEL_TBAVDRAG",action)
  return {
    ...state,
    ArtiklarTBavdrag:action.payload.ArtiklarTBavdrag
  }
}
case ON_ERROR_GET_ARTIKEL_TBAVDRAG: {
  console.log("ON_ERROR_GET_ARTIKEL_TBAVDRAG",action)
  return {
    ...state,
  }
}
//ON_START_ADD_ARTIKEL_TBAVDRAG, ON_ADD_ARTIKEL_TBAVDRAG, ON_ERROR_ADD_ARTIKEL_TBAVDRAG,
case ON_START_ADD_ARTIKEL_TBAVDRAG: {
  console.log("ON_START_ADD_ARTIKEL_TBAVDRAG",action)
  return {
    ...state
  }
}
case ON_ADD_ARTIKEL_TBAVDRAG: {
  console.log("ON_ADD_ARTIKEL_TBAVDRAG",action)
  return {
    ...state,
    ArtiklarTBavdrag:action.payload.ArtiklarTBavdrag
  }
}
case ON_ERROR_ADD_ARTIKEL_TBAVDRAG: {
  console.log("ON_ERROR_ADD_ARTIKEL_TBAVDRAG",action)
  return {
    ...state,
  }
}

case ON_START_FETCH_VALID_REST_API_TOKEN: {
  console.log("ON_START_FETCH_VALID_REST_API_TOKEN", action)
  return {
    ...state,
    ValidRestApiToken: null
  }
}
case ON_ERROR_FETCH_VALID_REST_API_TOKEN: {
  console.log("ON_ERROR_FETCH_VALID_REST_API_TOKEN", action)
  return {
    ...state,
    ValidRestApiToken: null
  }
}
case ON_FETCH_VALID_REST_API_TOKEN: {
  console.log("ON_FETCH_VALID_REST_API_TOKEN", action)
  return {
    ...state,
    ValidRestApiToken: action.payload.ValidRestApiToken
  }
}
//ON_START_GET_KUND_KONTAKTER,ON_GET_KUND_KONTAKTER,ON_ERROR_GET_KUND_KONTAKTER,
case ON_START_GET_KUND_KONTAKTER: {
  console.log("ON_START_GET_KUND_KONTAKTER",action)
  return {
    ...state
  }
}
case ON_GET_KUND_KONTAKTER: {
  console.log("ON_GET_KUND_KONTAKTER",action)
  return {
    ...state,
    currentKund:{...state.currentKund,Kontakter:action.payload.Kontakter},
  }
}
case ON_ERROR_GET_KUND_KONTAKTER: {
  console.log("ON_ERROR_GET_KUND_KONTAKTER",action)
  return {
    ...state,
  }
}
//ON_START_GET_ORDER_AFFAR_FROM_AF,ON_GET_ORDER_AFFAR_FROM_AF,ON_ERROR_GET_ORDER_AFFAR_FROM_AF,
case ON_START_GET_ORDER_AFFAR_FROM_AF:{
  return {
    ...state,
  }
}
case ON_GET_ORDER_AFFAR_FROM_AF:{
  return {
    ...state,
    OrderAffarfrom:action.payload.OrderAffarfrom
  }
}
case ON_ERROR_GET_ORDER_AFFAR_FROM_AF:{
  return {
    ...state,

  }
}
//ON_START_NEW_ORDER_AFFAR_FROM_AF, ON_NEW_ORDER_AFFAR_FROM_AF, ON_ERROR_ORDER_AFFAR_FROM_AF,
case ON_START_NEW_ORDER_AFFAR_FROM_AF:{
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_NEW_ORDER_AFFAR_FROM_AF:{
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
case ON_ERROR_ORDER_AFFAR_FROM_AF:{
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Error.Account.Sale.Status"),type:"error",loading:false},
  }
}
//ON_START_UPDATE_ORDER_AFFAR_FROM_AF, ON_UPDATE_ORDER_AFFAR_FROM_AF,
case ON_START_UPDATE_ORDER_AFFAR_FROM_AF:{
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_UPDATE_ORDER_AFFAR_FROM_AF:{
  return {
    ...state,
    ResponseKontoMsg:{msg:action.payload.message,type:"success",loading:false},
  }
}
//ON_START_GET_KONTO_TAGS,ON_GET_KONTO_TAGS,ON_ERROR_GET_KONTO_TAGS,
case ON_START_GET_KONTO_TAGS:{
  return {
    ...state,
    ResponseKontoMsg:{},
  }
}
case ON_GET_KONTO_TAGS:{
  return {
    ...state,
  }
}
case ON_ERROR_GET_KONTO_TAGS:{
  return {
    ...state,
    MinaTags:action.payload.MinaTags,
    AccountTags:action.payload.AccountTags,
  }
}
//
case ON_START_CHECK_FILE:{
  return {
    ...state,
    fileMessage:"",
    FileCheck:true,
    FileCheckWarning:false,
  }
}
case ON_CLOSE_CHECK_FILE:{
  return {
    ...state,
    fileMessage:"",
    FileCheck:false,
    FileCheckWarning:false,
  }
}
case ON_CHECK_FILE:{
  return {
    ...state,
    fileMessage:action.payload.message,
    FileCheck:false,
    FileCheckWarning:action.payload.canT
  }
}
case ON_ERROR_CHECK_FILE:{
  return {
    ...state,
    FileCheck:false,
    FileCheckWarning:false,
  }
}
//
//ON_START_GET_DASHBOARD_VALUEOF,ON_GET_DASHBOARD_VALUEOF,ON_ERROR_GET_DASHBOARD_VALUEOF,
case ON_START_GET_DASHBOARD_VALUEOF:{
  return {
    ...state
  }
}
case ON_GET_DASHBOARD_VALUEOF:{
  return {
    ...state,
    DashBoardValueOf:action.payload.DashBoardValueOf
  }
}
case ON_ERROR_GET_DASHBOARD_VALUEOF:{
  return {
    ...state
  }
}
//ON_START_UPDATE_DASHBOARD_VALUEOF,ON_UPDATE_DASHBOARD_VALUEOF,ON_ERROR_UPDATE_DASHBOARD_VALUEOF,
case ON_START_UPDATE_DASHBOARD_VALUEOF:{
  return {
    ...state
  }
}
case ON_UPDATE_DASHBOARD_VALUEOF:{
  return {
    ...state,
    DashBoardValueOf:action.payload.DashBoardValueOf
  }
}
case ON_ERROR_UPDATE_DASHBOARD_VALUEOF:{
  return {
    ...state
  }
}
//ON_START_GET_SMS_SETTINGS,ON_GET_SMS_SETTINGS,ON_ERROR_GET_SMS_SETTINGS,
case ON_START_GET_SMS_SETTINGS:{
  return {
    ...state,
    AfSmsSettings:{}
  }
}
case ON_GET_SMS_SETTINGS:{
  return {
    ...state,
    AfSmsSettings:action.payload.AfSmsSettings
  }
}
case ON_ERROR_GET_SMS_SETTINGS:{
  return {
    ...state
  }
}
//ON_START_UPDATE_SMS_SETTINGS,ON_UPDATE_SMS_SETTINGS,ON_ERROR_UPDATE_SMS_SETTINGS,
case ON_START_UPDATE_SMS_SETTINGS:{
  return {
    ...state,
    ResponseKontoMsg:{}
  }
}
case ON_UPDATE_SMS_SETTINGS:{
  return {
    ...state,
    ResponseKontoMsg:{msg:translate("Action.Updated"),type:"success",loading:false},
    AfSmsSettings:action.payload.AfSmsSettings
  }
}
case ON_ERROR_UPDATE_SMS_SETTINGS:{
  return {
    ...state
  }
}
//
default:
  return state;
}

  }
